<div class="container-fluid mt-4 supplier-data-wrapper">
  <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12" *ngIf="noSiteExists==false">
    <div class="d-flex align-items-center m-0 pb-1">
      <div class="col-4">
        <button class="btn btn-green btn-defBlue p-2 btn-ht btn-margin-right-standard" (click)="navigateToHome()" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (navigateToHome())">
          <span>
          <mat-icon svgIcon="home" alt="" class="pr-2"> </mat-icon>
        </span>
        <span class="float-right">
          ISA Home
        </span>
        </button>
        <button class="btn btn-green btn-defBlue p-2 btn-ht btn-margin-right-standard" (click)="sendToBuyers()" [disabled]="isSendToBuyerInProgress" *ngIf="showSendToBuyerButton()" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (sendToBuyers())">
          <span>
          <mat-icon svgIcon="mail" alt="" class="pr-2" > </mat-icon>
        </span>
        <span class="float-right">
          Send to Buyer
        </span>
        </button>

        <button class="btn btn-custom btn-darkred px-4 mr-2 btn-ht" *ngIf="roleVariableHide" type="button" data-toggle="modal" data-target="#openCreateCityModal" (click)="setCreateCityModalVals()" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (setCreateCityModalVals())">
          Create City
        </button>
      </div>
      <div class="center col-4"> <img src="assets/images/RG_RENAULT_GROUP_LOGOTYPE_BLACK_RGB_v21_1.png" class="logo-image-max-width"  alt="edit"></div>
      <div class="col-4 icon-align text-right">

        <div class="row"> <app-helpsection ></app-helpsection>
          <button *ngIf="!showForSupplier" class="home btn-home-style" (click)="navigateToHome()" title="Home" data-toggle="tooltip" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (navigateToHome())">
            <mat-icon svgIcon="home" width="17" height="15" alt="edit" class="icon-vertical-align-middle"></mat-icon></button>
          </div>
      </div>
    </div>

    <div class="edit opened_all mb-4" (click)="closeAllSections()" (keydown.enter)="closeAllSections()" (keydown.space)="closeAllSections()" id="openAllSection" *ngIf="showBoxDownForAllSec">
      <mat-icon svgIcon="downarrow" class="icon-arrow-absolute-standard" alt=""></mat-icon>
    <mat-icon svgIcon="downarrow" class="icon-arrow-margin-left" alt="" ></mat-icon>
    </div>
    <div class="row m-0">
      <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
        <div class="edit" (click)="acc('group')" (keydown.enter)="acc('group')" (keydown.space)="acc('group')" *ngIf="showBoxDownGroup">
          <mat-icon svgIcon="downarrow" class="icon-arrow-absolute-offset collapsed down_arrow_comp" alt=""></mat-icon>
        </div>
        <div class="edit opened_comp" (click)="acc('group')" (keydown.enter)="acc('group')" (keydown.space)="acc('group')"  *ngIf="!showBoxDownGroup">
          <mat-icon svgIcon="downarrow" class="icon-arrow-absolute-offset collapsed" alt=""></mat-icon>
        </div>
        <div class="backblue">
          <h5 class="font-weight-normal col">GROUP&nbsp;:&nbsp;<span class="font-weight-bold">
            <a class="link-white" [routerLink]="['/supplier-group-details',GroupAssign.groupId]">{{ GroupAssign ? GroupAssign.groupName : ''}}</a></span>&nbsp;</h5>
        </div>&nbsp;&nbsp;

        <section class="border-bottom-yellow p-1 height-auto-min-200" id="openAllBoxgroup">
            <div class="p-0 m-0 min-height-209">
              <div class="row m-0 align-center p-0 pt-1">
                <div class="col-3 col-sm-6 col-md-6 col-lg-5 col-xl-6 p-0 px-1">
                  <h4 class="title mt-2 mb-3">GENERAL INFORMATION</h4>
                </div>

              </div>
              <div class="text-center" *ngIf="GroupLoadin==true">
                <img src="assets/images/loading.gif" alt="loading...">
              </div>
              <div class="row">
              <div class="col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                <ng-container *ngIf="GroupAssign" >
                <div class="mb-2 row margin-left-2">
                  <div class="font-weight-bold">Group ID :</div>
                  <div class="pl-1" [innerHTML]="GroupAssign ? bolding(GroupAssign.groupAllianceIdentifier) : ''"></div>
                  <div class="pl-1">
                    <mat-icon svgIcon="speechcomment" alt="copy" (click)="copyToClipboard(GroupAssign.groupAllianceIdentifier)" (keydown.enter)="copyToClipboard(GroupAssign.groupAllianceIdentifier)" (keydown.space)="copyToClipboard(GroupAssign.groupAllianceIdentifier)" [matTooltip]="'Copy'" [ngStyle]="{'cursor': 'pointer'}" [matTooltipPosition]="'above'" tabindex="0"></mat-icon>

                  </div>

                  </div>
                <p class="mb-2 margin-left-2">
                  <span class="font-weight-bold">Group Category :</span>
                  <span class="pl-1">{{ GroupAssign ? GroupAssign.GroupCategory: '' }}</span>
                </p>
                <p class="mb-2 margin-left-2">
                    <span class="font-weight-bold">Group Status : </span>
                    <span class="pl-3 pr-3 group-status" *ngIf="GroupAssign.apoStatus" [ngStyle]="{'background':colorsGroup[GroupAssign.apoStatus2] ? colorsGroup[GroupAssign.apoStatus2]:'grey' }">
                      {{statusDisplay.replace('PENDING_VALIDATION','PENDING').replace('VALIDATED','ACTIVE').replace('ACTIVE','Active')}}
                    </span>
                    <span class="font-weight-bold pl-1">{{grpDate}}</span>
                </p>
                <p class="mb-2 margin-2" *ngIf="groupAlias && groupAlias.length > 0">
                  <ng-container *ngFor="let groupAlia of groupAlias">
                  <span class="font-weight-bold">{{ groupAlia.groupIdentifierKeyName.replace('MDM GROUP', 'Group Short Name') }}:</span>
                  <span class="pl-1">{{ groupAlia.value }}</span>
                  <span *ngIf="roleVariableHide && groupAlia.disableEdit" class="col edit pl-2" data-toggle="modal" data-target="#EditGrpAlias" (click)="EditAlias(groupAlia.groupIdentifierKeyName,groupAlia.value, groupAlia.row_id)" (keydown.enter)="EditAlias(groupAlia.groupIdentifierKeyName,groupAlia.value, groupAlia.row_id)" (keydown.space)="EditAlias(groupAlia.groupIdentifierKeyName,groupAlia.value, groupAlia.row_id)" tabindex="0" role="button">
                    <mat-icon svgIcon="edit" alt="edit"></mat-icon>
                  </span>
                  </ng-container>
                </p>
                <p class="mb-2 margin-2" *ngIf="this.showForSupplier == true">
                  <span class="font-weight-bold">BVD ID :</span>
                  <span class="pl-1">{{ groupbvdIDcpy ? groupbvdIDcpy : '--' }}</span>
                  <span class="pl-1" *ngIf="bvdloading==true"><img src="assets/images/loading.gif" alt="Updating..."></span>
                  <span class="pl-1" *ngIf="groupbvdIDcpy && showForConsult == true && this.showForSupplier == true">
                    <label class="switch m-0">
                      <input type="checkbox" id="sliderCheckBoxGrp" [disabled]="roleVariableHide==false || inPortfolioLoadingGrp==true" (change)="toggleInPortfolioSwitchGrp($event)" title="In Portfolio">
                      <span class="slider round"></span>
                    </label>&nbsp;
                    <span>({{countValueGrp}})</span>
                    <span class="pl-1" *ngIf="inPortfolioLoadingGrp==true"><img src="assets/images/loading.gif" alt="Updating..."></span>
                  </span>
                </p>

                </ng-container>
              </div>

            </div>
            </div>
          </section>
        </div>

      <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <div class="edit" (click)="acc('company')" (keydown.enter)="acc('company')" (keydown.space)="acc('company')" tabindex="0" *ngIf="showBoxDowncompany">
            <mat-icon svgIcon="downarrow" class="icon-arrow-absolute-offset collapsed down_arrow_comp" alt=""></mat-icon>
          </div>
          <div class="edit opened_comp" (click)="acc('company')" (keydown.enter)="acc('company')" (keydown.space)="acc('company')" tabindex="0" *ngIf="!showBoxDowncompany">
            <mat-icon svgIcon="downarrow" class="icon-arrow-absolute-offset collapsed" alt=""></mat-icon>
          </div>
          <div class="backblue">
            <h5 class="font-weight-normal col">COMPANY&nbsp;:&nbsp;<span class="font-weight-bold">
              <a class="link-white" [routerLink]="['/company-details/'] + companyId">{{businessEntityCompanyLegalName}}</a></span>&nbsp;</h5>
          </div>&nbsp;&nbsp;

          <section class="pt-2 pb-3 section-ht-lg border-bottom-yellow height-auto" id="openAllBoxcompany">
            <div class="p-0 m-0 ">
              <div class="row m-0 px-2 align-center">
                  <div class="col-6 col-sm-6 col-md-6 col-lg-4 col-xl-6 p-0 px-1">
                    <h4 class="title mt-2 mb-3">GENERAL INFORMATION</h4>
                  </div>
                  <div class="col-6 col-sm-2 col-md-2 col-lg-2 col-xl-2 p-0 px-1">
                    <h4 class="title mt-2 mb-3">COMPANY IDENTIFIERS</h4>
                  </div>
                <div class="col-6 col-sm-4 col-md-4 col-lg-6 col-xl-4 p-0 ">
                <div class="button-flex-wrap button-flex-right">
                  <button type="button" *ngIf="roleVariableHide" class="btn btn-custom btn-darkred px-2 bgcolor mr-2" [disabled]="multipleSiteAssn" (click)="resetInputField()" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (resetInputField())">
                    <span class="d-flex align-items-center"><mat-icon svgIcon="edit" class="img-btn pb-1"></mat-icon><span class="pl-1"> Update Company link </span></span>
                  </button>
                  <button type="button" class="btn btn-custom btn-blue" data-toggle="modal" data-target="#parentageStateModal" (click)="dispParentageStatusModal()" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (dispParentageStatusModal())">
                    <span class="align-items-center d-flex">
                      <mat-icon svgIcon="calendercharge" alt="" class="img-btn img-btn-xl"></mat-icon>
                      <span class="pl-1">Parentage State</span>
                    </span>
                  </button>

                </div>
                </div>
              </div>
              <div class="row">
              <div class="col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6 m-0">
                <div class="mb-2 row margin-left-2">
                  <div class="font-weight-bold">Company ID :</div>
                  <div class="pl-1" *ngIf="alliancecompanyidloading==true"><img src="assets/images/loading.gif" alt="Updating..."></div>
                  <div class="pl-1" *ngIf="alliancecompanyidloading==false" [innerHTML]="bolding(businessEntityCompanyAllianceIdentifier)"></div>

                  <div class="pl-1" *ngIf="alliancecompanyidloading==false">
                    <mat-icon svgIcon="speechcomment" alt="copy" (click)="copyToClipboard(businessEntityCompanyAllianceIdentifier)" (keydown.enter)="copyToClipboard(businessEntityCompanyAllianceIdentifier)" (keydown.space)="copyToClipboard(businessEntityCompanyAllianceIdentifier)" [matTooltip]="'Copy'" [ngStyle]="{'cursor': 'pointer'}" [matTooltipPosition]="'above'" tabindex="0"></mat-icon>
                  </div>
                </div>
                <p class="mb-2 margin-left-2 row">
                  <span class="font-weight-bold">Company Status : </span>
                  <span class="pl-1" *ngIf="bvdidstatusloading==true"><img src="assets/images/loading.gif" alt="Updating..."></span>
                  <span class="pl-1 group-status pl-3 pr-3 ml-1" *ngIf="companyStatusCode && companyStatusCode != ''" [ngStyle]="{'background':colorStatus[companyStatusCode.toLowerCase()],'min-width': '82px' }">{{companyStatusCode}}</span>
                  <span class="font-weight-bold padding-left-4">
                    {{dateDisplay}}
                  </span>
                </p>
                <p class="mb-2 margin-left-2 row">
                  <span class="font-weight-bold">Workflow Status : </span>
                  <span class="pl-1" *ngIf="bvdidstatusloading==true"><img src="assets/images/loading.gif" alt="Updating..."></span>
                  <span class="ml-1 group-status pl-3 pr-3" *ngIf="companyWorkflowStatus && companyWorkflowStatus != ''" [ngStyle]="{'background': workflowStatusColors[companyWorkflowStatus] || '#D8C4A0' }">{{companyWorkflowStatus}}</span>
                </p>
                <p class="mb-2 margin-left-2">
                  <span class="font-weight-bold">Company Short Name : </span>
                  <span class="pl-1">{{ companyShortName ? companyShortName : '' }}</span>
                </p>
                <p class="mb-2 margin-2" *ngIf="this.showForSupplier == true">
                  <span class="font-weight-bold">BVD ID :</span>
                  <span class="pl-1">{{ companybvdIDcpy ? companybvdIDcpy : '--' }}</span>
                  <span class="pl-1" *ngIf="bvdloading2==true"><img src="assets/images/loading.gif" alt="Updating..."></span>
                  <span class="pl-1" *ngIf="companybvdIDcpy && showForSupplier == true && showForConsult == true" >
                    <label class="switch m-0">
                      <input type="checkbox" id="sliderCheckBoxCmp" [disabled]="roleVariableHide==false || inPortfolioLoadingCmp==true" (change)="toggleInPortfolioSwitchCmp($event)" title="In Portfolio">
                      <span class="slider round"></span>
                    </label>&nbsp;
                    <span>({{countValueCmp}})</span>
                    <span class="pl-1" *ngIf="inPortfolioLoadingCmp==true"><img src="assets/images/loading.gif" alt="Updating..."></span>
                  </span>
                </p>
                <p class="mb-2 margin-left-2"  *ngIf="latestCmpOrbisStatus && latestCmpOrbisStatus != ''">
                  <span class="font-weight-bold">Orbis Status:&nbsp;</span>
                  <span class="group-status pl-3 pr-3 py-1"  [ngStyle]="{ 'background-color': latestCmpOrbisStatus.color, 'border-radius': '12px' ,'min-width': '82px'}" >
                    {{ latestCmpOrbisStatus.value }}
                  </span>
                  <span class="font-weight-bold padding-4-bottom-4">
                    {{ latestCmpOrbisStatus.startDate }}
                  </span>
                  </p>
                <p class="mb-2 margin-left-2" *ngIf="DUNSValue">
                  <span class="font-weight-bold">DUNS : </span>
                  <span class="pl-3 pr-3 py-1" *ngIf="DUNSValue && DUNSValue != ''">{{ DUNSValue ? DUNSValue : '' }}</span>
                </p>
                <p class="mb-2 margin-left-2" *ngIf="BPNLValue">
                  <span class="font-weight-bold">BPN : </span>
                  <span class="pr-3 py-1" *ngIf="BPNLValue && BPNLValue != '' && bpnCount == 1">{{ BPNLValue ? BPNLValue : '' }}</span>
                  <span class="pr-3 py-1 color-bright-red" *ngIf="BPNLValue && BPNLValue != '' && bpnCount >1">Error - Multiple BPN</span>
                </p>

              </div>
              <div class="col-5 col-sm-5 col-md-5 col-lg-5 col-xl-6 m-0">
              <ng-container *ngIf="CompanyIdentiTypes1">
                <div *ngFor="let cTypes of CompanyIdentiTypes1;let i=index">
                  <div *ngIf="companyAliasAll1 && companyAliasAll1[cTypes]" class="row m-0">
                    <div class="font-weight-bold col-12 col-sm-12 col-md-2 col-lg-2 col-xl-1 p-0">
                      <div *ngFor="let Cvalues of companyAliasAll[cTypes];let j=index">
                      <div *ngIf="roleVariableHide == false" class="p-0">{{cTypes ? cTypes : ''}} :</div>
                    </div>
                    <div *ngIf="roleVariableHide == true" class="p-0">
                      {{cTypes ? cTypes : ''}} :
                    </div>
                    </div>
                    <div class="col-12 col-sm-12 col-md-9 col-lg-8 col-xl-10 p-0">
                        <div class="col-12 col-sm-12 col-md-5 col-lg-10 col-xl-6"
                          *ngFor="let Cvalues of companyAliasAll1[cTypes];let j=index">
                          <span class="font-weight-bold label-darkblue pr-1" id="{{Cvalues.key}}" *ngIf="(Cvalues.archived ==true && roleVariableHide == true || Cvalues.archived ==false)" >{{Cvalues.val}} </span>
                          <span class="pl-3 pr-1" *ngIf="(Cvalues.archived ==true && roleVariableHide == true || Cvalues.archived ==false) && cTypes=='ALCOR' && alcorNameValsOnAlcorVal[Cvalues.val]">
                            {{alcorNameValsOnAlcorVal[Cvalues.val] ? alcorNameValsOnAlcorVal[Cvalues.val][0]['businessIdentifierName'] : ''}}
                          </span>
                          <span class="group-status px-3 py-1" [ngStyle]="{'background' : '#CB4B32'}" *ngIf="Cvalues.archived ==true && roleVariableHide == true" >Archived</span>
                        </div>

                    </div>
                  </div>
                </div>
                </ng-container>
              </div>
            </div>
            </div>
          </section>
      </div>

      <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 " >
        <div class="edit" (click)="acc('site')" (keydown.enter)="acc('site')" (keydown.space)="acc('site')" tabindex="0" *ngIf="showBoxDownSite">
          <mat-icon svgIcon="downarrow" class="icon-arrow-absolute-offset collapsed down_arrow_comp" alt=""></mat-icon>
        </div>
        <div class="edit opened_comp" (click)="acc('site')" (keydown.enter)="acc('site')" (keydown.space)="acc('site')" tabindex="0" *ngIf="!showBoxDownSite">
          <mat-icon svgIcon="downarrow" class="icon-arrow-absolute-offset collapsed" alt=""></mat-icon>
        </div>
        <div class="backdarkblue pl-4 margin-bottom-20">
          <h5 class="font-weight-normal col"><div class="row">
            <div class="font-weight-bold pr-1"> SITE&nbsp;:&nbsp; {{siteName}}</div>
            <div class="edit" *ngIf="roleVariableHide" data-target="#openEditNameModal" data-toggle="modal" (click)="setNameValue()" (keydown.enter)="setNameValue()" (keydown.space)="setNameValue()" tabindex="0" role="button"><mat-icon svgIcon="edit" alt="edit"></mat-icon></div></div></h5>
        </div>
        <div  id="openAllBoxcsite">
          <section class="pt-2 pb-3 section-ht-xs border-bottom-yellow height-auto">
            <div class="row m-0 align-center">
              <div class="col-12 col-sm-12 col-md-10 col-lg-6 col-xl-6 p-0 px-2 pt-2">
                <h4 class="title">GENERAL INFORMATION</h4>
              </div>
              <div class="col-12 col-sm-12 col-md-10 col-lg-4 col-xl-4 p-0 px-2 pt-2">
                <h4 class="title">SITE IDENTIFIERS</h4>
              </div>
              <div class="col-12 col-sm-12 col-md-2 col-lg-2 col-xl-2 p-0 px-2 text-right padding-right-15-important">
                <button type="button" *ngIf="roleVariableHide && sitebvidid != ''" class="btn btn-custom btn-darkred" data-target="#openCheckBvdModal" data-toggle="modal" (click)="getCheckBvd()">
                  Check BvD
                </button>
              </div>
            </div>
            <div class="row m-0">
            <div class="col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6 ml-3">
              <div class="mb-2 row">
                <div class="font-weight-bold">Site ID :</div>
                <div class="pl-1" *ngIf="siteIdLoading==true"><img src="assets/images/loading.gif" alt="Updating..."></div>
                <div class="pl-1" *ngIf="siteIdLoading==false" [innerHTML]="bolding(siteIdentifier)"></div>
                <div class="pl-1" *ngIf="siteIdLoading==false">
                  <mat-icon svgIcon="speechcomment" alt="copy" (click)="copyToClipboard(siteIdentifier)" (keydown.enter)="copyToClipboard(siteIdentifier)" (keydown.space)="copyToClipboard(siteIdentifier)" [matTooltip]="'Copy'" [ngStyle]="{'cursor': 'pointer'}" [matTooltipPosition]="'above'" tabindex="0"></mat-icon>

                </div>

              </div>
              <div class="mb-2 row">
                <div class="font-weight-bold">Site Status : &nbsp;</div>
                <div class="pl-1" *ngIf="siteActiveStatusLoading==true"><img src="assets/images/loading.gif" alt="Updating..."></div>
                <div class="pl-1 group-status pl-3 pr-3" *ngIf="siteActiveStatusLoading==false && siteActiveStatus" [ngStyle]="{'background' : colorStatus[siteActiveStatus.toLowerCase()]}">{{siteActiveStatus.replace("CREATED","Identified").replace("PENDING","Inactive").replace("ACTIVE","Active")}}</div>
                <mat-icon *ngIf="siteActiveStatus != '' && siteActiveStatus != undefined && roleVariableHide" svgIcon="edit" class="img-btn pl-1 edit" role="button" tabindex="0" (click)="resetSiteStatus('siteActiveStatus')" (keydown.enter)="resetSiteStatus('siteActiveStatus')" (keydown.space)="resetSiteStatus('siteActiveStatus')" data-target="#openEditSiteValStatus" data-toggle="modal"></mat-icon>
                <mat-icon *ngIf="roleVariableHide" svgIcon="file-reload" class="img-btn pl-1 edit" role="button" tabindex="0" (click)="resetSiteStatus('siteActiveStatus')" (keydown.enter)="resetSiteStatus('siteActiveStatus')" (keydown.space)="resetSiteStatus('siteActiveStatus')" data-target="#openblankStatusUpdate" data-toggle="modal"></mat-icon>
                <div class="pl-1" *ngIf="siteStatusLoading==true"><img src="assets/images/loading.gif" alt="Updating..."></div>
                <div class="pl-1 group-status pl-3 pr-3 ml-1" *ngIf="siteStatusLoading==false && sitestatus && sitestatus!='Built'" [ngStyle]="{'background' : siteStatusColor[sitestatus.toLowerCase()]}">{{sitestatus}}</div>

                <span class="font-weight-bold pl-1">{{siteDate}}</span>
              </div>
              <div class="mb-2 row" *ngIf="roleVariableHide || (siteWorkflowStatus && siteWorkflowStatus !== 'NotStarted')">
                <div class="font-weight-bold">Workflow Status : &nbsp;</div>
                <div class="ml-1 group-status pl-3 pr-3" *ngIf="siteWorkflowStatus"
                  [ngStyle]="{'background': workflowStatusColors[siteWorkflowStatus] || '#D8C4A0'}">
                  {{siteWorkflowStatus}}
                </div>
                <mat-icon *ngIf="roleVariableHide" svgIcon="edit" class="img-btn pl-1 edit" role="button" tabindex="0" data-toggle="modal" data-target="#editSiteWorkflowStatusModal" (click)="openSiteWorkflowStatusModal()" (keydown.enter)="openSiteWorkflowStatusModal()" (keydown.space)="openSiteWorkflowStatusModal()"></mat-icon>
              </div>
              <div class="mb-2 row">
                <div class="font-weight-bold">Site Short Name : &nbsp;</div>
                <div class="pl-1" *ngIf="nameloading==true"><img src="assets/images/loading.gif" alt="Updating..."></div>
                <div class="pl-1" *ngIf="nameloading==false">{{siteShortName ? siteShortName : ''}}</div>
                <mat-icon *ngIf="roleVariableHide==true || superUserShow==true" svgIcon="edit" class="img-btn pl-1 edit" tabindex="0" (click)="resetEditName(siteShortName)" (keydown.enter)="resetEditName(siteShortName)" (keydown.space)="resetEditName(siteShortName)" data-target="#openEditShortModal" data-toggle="modal"></mat-icon>
              </div>
              <div class="mb-2 row" *ngIf="showForSupplier && showBuyerProfile == true">
                <div class="font-weight-bold">BvD ID :</div>
                <div class="pl-1" *ngIf="bvdidloading==true"><img src="assets/images/loading.gif" alt="Updating..."></div>
                <div class="pl-1" *ngIf="bvdidloading==false">{{sitebvidid ? sitebvidid : '--'}}
                  <div *ngIf="showArchivedBvdId==true && sitebvidid!=''">
                    <div class="group-status px-3 py-1" [ngStyle]="{'background' : '#CB4B32'}">Archived</div>
                  </div>
                </div>
                <div> <mat-icon *ngIf="noSiteAssn==false && roleVariableHide" svgIcon="edit" class="img-btn pl-1 edit" role="button" tabindex="0" (click)="resetBvdId('modal')" (keydown.enter)="resetBvdId('modal')" (keydown.space)="resetBvdId('modal')" data-target="#openEditBvdModal" data-toggle="modal"></mat-icon>
                </div>
                <div class="pl-1" *ngIf="(showForSupplier==true && companyId != '' && companyId != undefined && sitebvidid != '') && showBuyerProfile == true &&showForConsult == true;">
                  <label class="switch m-0">
                    <input type="checkbox" id="sliderCheckBox" [disabled]="roleVariableHide==false || inPortfolioLoading==true" (change)="toggleInPortfolioSwitch($event)" title="In Portfolio">
                    <div class="slider round"></div>
                  </label>&nbsp;
                </div>
                  <div *ngIf="sitebvidid">({{countValue}})</div>
                  <div class="pl-1" *ngIf="inPortfolioLoading==true && countValue != '' "><img src="assets/images/loading.gif" alt="Updating..."></div>

              </div>
              <div class="mb-2 row margin-bottom-10"     *ngIf="latestOrbisStatus && latestOrbisStatus != ''">
            <div class="font-weight-bold">Orbis Status:&nbsp;</div>


            <div class="group-status pl-3 pr-3 py-1"  [ngStyle]="{ 'background-color': latestOrbisStatus.color, 'border-radius': '12px' ,'min-width': '82px'}" >
              {{ latestOrbisStatus.value }}
            </div>

            <div class="font-weight-bold padding-4-bottom-4">
              {{ latestOrbisStatus.startDate }}
            </div>
          </div>
          <div class="mb-2 row" *ngIf="BPNSValue">
            <span class="font-weight-bold">BPN : </span>
            <span *ngIf="BPNSValue && BPNSValue != '' && bpnSCount == 1">{{ BPNSValue ? BPNSValue : '' }}</span>
            <span class="color-bright-red" *ngIf="BPNSValue && BPNSValue != '' && bpnSCount  >1">Error - Multiple BPN</span>
          </div>
              <div class="mb-2 row">
                <div class="font-weight-bold">Country :</div>
                <div class="pl-1" *ngIf="countryloading==true"><img src="assets/images/loading.gif" alt="Updating..."></div>
                <div class="pl-1" *ngIf="countryloading==false">{{ siteCountry ? siteCountry : ''}}</div>
                <mat-icon  svgIcon="edit" class="img-btn pl-1 edit" role="button" tabindex="0" *ngIf="siteCity.toUpperCase() === 'UNKNOWN'" (click)="resetEditCountry(siteCountry)" (keydown.enter)="resetEditCountry(siteCountry)" (keydown.space)="resetEditCountry(siteCountry)" data-target="#openEditCountryModal" data-toggle="modal"></mat-icon>
              </div>
              <div class="mb-2 row">
                <div class="font-weight-bold">City :</div>
                <div class="pl-1" *ngIf="cityloading==true"><img src="assets/images/loading.gif" alt="Updating..."></div>
                <div class="pl-1" *ngIf="cityloading==false">{{ siteCity ? siteCity : ''}}</div>
                <mat-icon *ngIf="siteCity != '' && roleVariableHide" svgIcon="edit" class="img-btn pl-1 edit" role="button" tabindex="0" data-target="#openEditCityModal" (click)="resetEditCity()" (keydown.enter)="resetEditCity()" (keydown.space)="resetEditCity()" data-toggle="modal"></mat-icon>
                <a *ngIf="maplatitudeVal !='' && maplongitudeVals!=''" class="label-darkblue" [attr.href]="googleLink+ maplatitudeVal + ' ' + maplongitudeVal +'?hl=en'" target="_blank">
                <mat-icon svgIcon="map" class="img-btn pl-1 edit" role="button" ></mat-icon>
                </a>
              </div>
            </div>
            <div class="col-6 col-sm-6 col-md-6 col-lg-6 col-xl-5 float-right p-0 m-0" *ngIf="roleVariableHide ==true">
             <div class="row" *ngFor="let raftcodevalues of raftcode;let j=index">
                <div class="col-2 col-sm-6 col-md-6 col-lg-3 col-xl-1 font-weight-bold  ml-3 p-0" *ngIf="j==0">ALCOR:</div>
                <div class="col-2  col-sm-6 col-md-6 col-lg-3 col-xl-1 font-weight-bold  ml-3 p-0" *ngIf="j!=0"></div>

                <div class="col-2 col-sm-6 col-md-6 col-lg-2 col-xl-1  font-weight-bold label-darkblue ml-4 p-0">{{ raftcodevalues.businessIdentifierValue ? raftcodevalues.businessIdentifierValue : ''}}</div>
                <div class="col-2 col-sm-6 col-md-6 col-lg-3 col-xl-3 pl-4">{{ raftcodevalues.businessIdentifierName ? raftcodevalues.businessIdentifierName : ''}}</div>
                <div class="col-1 col-sm-6 col-md-6 col-lg-3 col-xl-1 p-0"><span *ngIf="showArchivedRaftcode==true">
                  <span class="group-status px-3 py-1" [ngStyle]="{'background' : '#CB4B32'}">Archived</span>
                  </span>
                  <mat-icon svgIcon="edit" class="img-btn pl-1 edit icon-edit-height-17" role="button" tabindex="0" (click)="loadraftcode(raftcodevalues.rowId)" (keydown.enter)="loadraftcode(raftcodevalues.rowId)" (keydown.space)="loadraftcode(raftcodevalues.rowId)" data-target="#openEditRaftModal" data-toggle="modal" *ngIf="showArchivedRaftcode==true || superUserShow==true"></mat-icon></div>

            </div>
            </div>
          </div>
          </section>
                <div>
                  <section class="pt-2 pb-3 border-bottom-yellow height-auto-min-80" *ngIf="roleVariableHide == true">
                      <div class="row m-0 align-center">
                        <div class="col-12 col-sm-2 col-md-2 col-lg-2 col-xl-2 p-0 pt-2 px-2">
                         <h4 class="title px-2"><div class="row">
                            <div class="padding-notes">NOTES</div>
                            <mat-icon svgIcon="edit" class="img-btn pl-1 edit" role="button" tabindex="0" (click)="resetEditNotes('modal')" (keydown.enter)="resetEditNotes('modal')" (keydown.space)="resetEditNotes('modal')" data-target="#openShortNoteEdit" data-toggle="modal"></mat-icon></div>
                          </h4>
                        </div>
                      </div>
                    <div class="p-0 m-0 section-scroll">
                      <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">

                        <textarea *ngIf="description != ''" name="notes" id="notesDesc" cols="185" [(ngModel)]="description" cdkTextareaAutosize class="bg-transparent-no-border" disabled></textarea>
                      </div>
                    </div>
                  </section>
                </div>
        <div *ngIf="roleVariableHide ==true || roleIsManager || showForConsult == false || showBuyerProfile ==false">
          <section class="pt-3 border-bottom-yellow height-auto-min-75">
                    <div class="row m-0 align-center">
                      <div class="col-12 col-sm-4 col-md-6 col-lg-6 col-xl-6 px-2">
                        <a class="title link-underline-clickable" (click)="toggleTaxIdentifiers()" (keydown.enter)="toggleTaxIdentifiers()" (keydown.space)="toggleTaxIdentifiers()" tabindex="0">TAX IDENTIFIERS ({{ getTaxIdentifierCount() }})</a>
                      </div>
                      <div class="col-12 col-sm-8 col-md-6 col-lg-6 col-xl-6 p-0 pl-5 pr-2 text-right">


                          <button type="button" class="btn btn-custom btn-darkred" *ngIf="roleVariableHide" data-toggle="modal" data-target="#AddTaxIdentfiers" (click)="LoadTaxType()">
                            <span><mat-icon svgIcon="add" class="img-btn"></mat-icon><span class="float-right"> Add Tax Identifier</span></span>
                          </button>
                        <button type="button" class="btn btn-custom btn-darkred pr-2 ml-1 margin-right-5" *ngIf="roleVariableHide && sitebvidid" ata-toggle="modal" data-target="#addTaxIdentifier" (click)="addTaxIdentifiers()" [disabled]="isLoading">
                          <span><mat-icon svgIcon="add-2" class="img-btn img-btn-lg"></mat-icon> <span class="float-right"> Update TAX Identifier </span></span>
                        </button>
                      </div>

                    </div>

                  <div *ngIf="showTaxIdentifiers">
                    <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                      <ng-container *ngIf="companyAliasAll && getAllTaxIdentifierKeys().length > 0">
                        <ul class="col-12 col-sm-12 col-md-8 col-lg-5 col-xl-12 flex-column list-view p-0">
                          <span>
                            <ng-container *ngFor="let Tvalues of getAllTaxIdentifierKeys();let j=index" >
                              <ng-container *ngIf="companyAliasAll && companyAliasAll[Tvalues]" >
                                <ng-container *ngFor="let Taxvalues of companyAliasAll[Tvalues];let k=index" >
                                  <div class="">
                                    <li class="d-flex mb-0 display-inline-float-left-50">
                                      <p class="col-8 mb-1 p-0">
                                        <span class="font-weight-bold">
                                          {{Tvalues?Tvalues:''}} :
                                        </span>
                                        <span class="font-weight-bold label-darkblue pl-2">
                                          {{ Taxvalues.val ? Taxvalues.val : ''}}
                                        </span>
                                        <mat-icon *ngIf="roleVariableHide" svgIcon="edit" class="img-btn pl-2 pb-1 edit" role="button" tabindex="0" data-target="#openEditTaxIdentifiers" (click)="EditTaxId(Taxvalues.key,Taxvalues.val,Taxvalues.endDate)" (keydown.enter)="EditTaxId(Taxvalues.key,Taxvalues.val,Taxvalues.endDate)" (keydown.space)="EditTaxId(Taxvalues.key,Taxvalues.val,Taxvalues.endDate)" data-toggle="modal" data-dismiss="modal"></mat-icon>
                                        <span *ngIf="Taxvalues.endDate=='archived'">
                                          <span class="group-status px-3 py-1" [ngStyle]="{'background' : '#CB4B32'}">Archived</span>
                                          </span>
                                      </p>


                                    </li>
                                  </div>
                                </ng-container>
                              </ng-container>
                            </ng-container>
                          </span>
                        </ul>
                      </ng-container>
                    </div>
                  </div>
                    <div class="text-center" *ngIf="TaxIdentifiLoading==true">
                      <img src="assets/images/loading.gif" alt="loading...">
                    </div>
                  </section>
                </div>
           <div>

            <section class="col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 p-0 border-bottom-yellow" >
              <div class="row m-0 pt-3 align-center">
                <div class="col col-12 col-sm-4 col-md-5 col-lg-5 col-xl-5">
                  <h4 class="title">QUALIFIERS <span class="p-0" *ngIf="showCount">({{qualifierNo}})</span></h4>
                </div>
                <div class="col col-12 col-sm-8 col-md-7 col-lg-7 col-xl-7 text-right">
                  <button type="button" *ngIf="roleVariableHide || superUserShow || ((siteWorkflowStatus.toLowerCase()=='waitingforsupplier') && (showForSupplier==false))" class="btn btn-green btn-custom btn-blue float-right d-flex align-center" data-toggle="modal" (click)="setDropdownValues()">
                    <mat-icon svgIcon="add" class="img-btn"></mat-icon><span class="float-right"> Add Qualifier to Site </span>
                  </button>
                </div>


              </div>

              <div class="row m-0">
                <div class="table-responsive mt-3 ">
                  <table class="table table-sm m-0 p-0 overflow-hidden">
                    <thead>
                      <tr>
                        <th class="beSticky table-sticky-header">
                          <div class="edit" (click)="openAllAccordion()" (keydown.enter)="openAllAccordion()" (keydown.space)="openAllAccordion()" tabindex="0" id="openAllBox" *ngIf="!showBoxDown">
                            <mat-icon svgIcon="downarrow" class="down_arrow " alt=""></mat-icon>
                            <mat-icon svgIcon="downarrow" class="down_arrow" alt=""></mat-icon>
                          </div>
                          <div class="edit opened" (click)="openAllAccordion()" (keydown.enter)="openAllAccordion()" (keydown.space)="openAllAccordion()" tabindex="0" *ngIf="showBoxDown">
                            <mat-icon svgIcon="downarrow" class="icon-arrow-inline-absolute collapsed" alt=""></mat-icon>
                            <mat-icon svgIcon="downarrow" class="icon-arrow-inline-margin collapsed" alt=""></mat-icon>
                          </div>
                        </th>
                        <th class="beSticky pl-5 text-left width-9"><span class="text-left" (click)="revQualifierSort()" (keydown.enter)="revQualifierSort()" (keydown.space)="revQualifierSort()" tabindex="0" role="button">Type</span></th>
                        <th class="beSticky text-left width-6"><div>Name</div><div>Activity</div></th>
                        <th class="beSticky text-left width-2">Status</th>
                        <th class="beSticky text-left width-15-important"> Qualifier ID</th>
                        <th class="beSticky text-left width-22-important">Address</th>
                      </tr>
                    </thead>
                    <tbody *ngIf="sitesData && sitesData.length > 0" id="panels">
                      <tr *ngFor="let site of sitesData; let i = index" class="p-0 forColor">
                        <td class="stayTop"><i class="btn"><mat-icon svgIcon="downarrow" class="change_img" role="button" tabindex="0" id="img{{i}}" data-toggle="collapse" [attr.data-target]="'#collapsible' + i"  aria-expanded="true" [attr.aria-controls]="'#collapsible' + i" (click)="changeArrow(i)" (keydown.enter)="changeArrow(i)" (keydown.space)="changeArrow(i)" alt=""></mat-icon></i></td>
                        <td class="stayTop" >
                          <span *ngIf="site.type != undefined" class="pl-1">

                            <span>
                              <mat-icon svgIcon="{{qualifierTypes[site.type]}}" class="qualifer-icons p-0 pl-2 pr-1" alt="" style="width: 40px !important;height: 40px !important;"></mat-icon>
                            </span>
                           <span>
                            <p style="font-weight: bold;"> {{[site.type] ? [site.type] : '-'}}</p>
                           </span>
                           <!-- <span class="mt-2" *ngIf="site.type== 'Ordering' && site.saer_code ">
                            <button class="btn btn-custom btn-blue" (click)="loadMaterialGrpHomologation(site)" data-toggle="modal" data-target="#dispMatGroupHomo" >Material Group Homologation</button>
                          </span> -->
                          </span>
                        </td>
                        <td class="stayTop">
                          <div class="row">
                          <span>{{site.label ? site.label : '-'}}
                          </span>
                          <span class="pl-1" *ngIf="roleVariableHide || ((siteActiveStatus.toLowerCase()=='pending') && (showForSupplier==false) && (site.status.toLowerCase()=='pending'))">
                            <mat-icon class="edit" svgIcon="edit" style="height: 18px !important;" alt="edit" tabindex="0" role="button" data-toggle="modal" data-target="#siteQualifierNameModalPopup" (click)="saveCurQualifier(site.status.toLowerCase(),site.rowId,site.label,site.raft_alias)" (keydown.enter)="saveCurQualifier(site.status.toLowerCase(),site.rowId,site.label,site.raft_alias)" (keydown.space)="saveCurQualifier(site.status.toLowerCase(),site.rowId,site.label,site.raft_alias)"></mat-icon>
                          </span>
                          </div>
                          <p class="mt-2" style="font-weight: bold;">{{site.activity}}</p>
                          <p class="mt-2" *ngIf="site.type == 'Manufacturing'">
                            <button class="btn btn-green btn-custom btn-blue"
                              (click)="showAssociatedPicking(site.type,site.identifier,site.rowId,site.status)">
                                <ng-container *ngIf="associatedCount == 0" data-toggle="modal" data-target="#showAddPickingQual" (click)="addAssociatedPicking()">
                                    Add Associated Picking
                                </ng-container>
                                <ng-container *ngIf="associatedCount > 0">
                                  Associated Picking ({{ associatedCount}})
                                </ng-container>
                            </button>
                          </p>
                          <p class="mt-2" *ngIf="site.type == 'Main Entrance' && roleVariableHide==true">
                            <button class="btn btn-custom btn-darkred" data-target="#showNameSync" data-toggle="modal" (click)="openSyncMainEntranceName(site.label)">Copy Main Entrance name on other qualifiers</button>
                          </p>
                          <div class="pl-3 row" *ngIf="site.type == 'Ordering' && c2bDisplay(site)">
                            <div class="font-weight-bold">C2B :</div><div class="pl-2 font-weight-bold">{{site.c2b_code ? site.c2b_code : ''}}</div>
                            <span *ngIf="roleVariableHide" class="pl-3">
                              <mat-icon class="edit"
                              style="height:18px !important"
                              svgIcon="edit" alt="edit" tabindex="0" role="button" data-toggle="modal" data-target="#siteQualifierc2bModalPopup" (click)="editC2bCode(site.c2b_code,site.edit_c2b_code,site.rowId,site.label,site.raft_name)" (keydown.enter)="editC2bCode(site.c2b_code,site.edit_c2b_code,site.rowId,site.label,site.raft_name)" (keydown.space)="editC2bCode(site.c2b_code,site.edit_c2b_code,site.rowId,site.label,site.raft_name)"></mat-icon>
                            </span>
                          </div>
                        </td>
                        <td class="stayTop">
                          <div class="m-0 d-flex justify-content-center" *ngIf="site.type != 'Main Entrance'">
                            <p class="m-0">
                              <span class="group-status pl-3 pr-3 py-1" style="min-width: 80px;" [ngStyle]="{'background' : colorStatus[site.status.toLowerCase()]}">
                              {{site.status ? site.status : '-'}}
                              </span>
                              <span class="d-block effDate" *ngIf="site.status.toLowerCase()!='archived'">{{site.effectiveDate ? (site.effectiveDate | date:'yyyy-MM-dd') : '-'}}</span>
                              <span class="d-block effDate" *ngIf="site.status.toLowerCase()=='archived'">{{site.acpEndDate ? (site.acpEndDate | date:'yyyy-MM-dd') : '-'}}</span>
                            </p>
                            <span *ngIf="roleVariableHide && site.type!='P14' && site.status.toLowerCase()!='archived'" class="pl-3">
                              <mat-icon class="edit" svgIcon="edit" alt="edit" tabindex="0" role="button" data-toggle="modal" data-target="#siteQualifierStatusModalPopup" (click)="saveCurQualifier(site.status.toLowerCase(),site.rowId,site.label,site.raft_alias,site.saer_code,site.edit_saer_code)" (keydown.enter)="saveCurQualifier(site.status.toLowerCase(),site.rowId,site.label,site.raft_alias,site.saer_code,site.edit_saer_code)" (keydown.space)="saveCurQualifier(site.status.toLowerCase(),site.rowId,site.label,site.raft_alias,site.saer_code,site.edit_saer_code)"></mat-icon>
                            </span>
                            <span *ngIf="superUserShow && site.type!='P14' && site.status.toLowerCase()=='archived'" class="pl-3">
                              <mat-icon class="edit" svgIcon="edit" alt="edit" tabindex="0" role="button" data-toggle="modal" data-target="#siteQualifierStatusModalPopup" (click)="saveCurQualifier(site.status.toLowerCase(),site.rowId,site.label,site.raft_alias,site.saer_code,site.edit_saer_code)" (keydown.enter)="saveCurQualifier(site.status.toLowerCase(),site.rowId,site.label,site.raft_alias,site.saer_code,site.edit_saer_code)" (keydown.space)="saveCurQualifier(site.status.toLowerCase(),site.rowId,site.label,site.raft_alias,site.saer_code,site.edit_saer_code)"></mat-icon>
                            </span>
                          </div>
                              <div *ngIf="site.type != 'Picking' && roleVariableHide && site.status.toLowerCase() == 'pending' && (site.type != 'Ordering' || site.type == 'Manufacturing' || site.type == 'Invoicing' || site.type == 'B2B Partner') && (site.saer_code==undefined || site.saer_code=='') && (site.c2b_code=='' || !site.c2b_code)">
                                <p class="mb-2 ml-2 mt-5 text-center">
                                  <button class="btn btn-custom btn-darkred" id="showAcpBtn" data-target="#showValidateAcp" data-toggle="modal" (click)="validateSite(site.rowId,site.raft_alias,site.type,site.editRowIdRaftAlias,site.raft_name)">Validate</button>
                                </p>
                              </div>
                              <div *ngIf="site.type != 'Picking' && roleVariableHide && site.status.toLowerCase() == 'pending' && site.type == 'Ordering' && site.multiplecode != true">
                                <p class="mb-2 ml-2 mt-5 text-center">
                                  <button class="btn btn-custom btn-darkred" id="showAcpBtn1" data-target="#showValidateAcpSaer" data-toggle="modal" (click)="validateSaer(site.rowId,site.type,site.editRowIdRaftAlias,site.saer_code,site.raft_alias,site.raft_name,site.latam_code,site.rnaipl_code)" >Validate</button>
                                </p>
                              </div>
                        </td>
                        <td class="stayTop">
                          <div class="row mb-1">
                           {{site.identifier ? site.identifier : '-'}}
                          </div>
                         <div *ngIf="site.type != 'Main Entrance' && site.type != 'Headquarters' && !site.raft_alias && !site.saer_code && !site.latam_code && !site.rnaipl_code" class="font-weight-bold" style="margin-left: -15px;">Code :</div>
                            <div *ngIf="site.type != 'Main Entrance' && site.type != 'Headquarters'">

                              <div class="mb-2 row" *ngIf="site.raft_alias && site.raft_alias != '' && !site.saer_code && site.multiplecode != true">
                                <ng-container *ngIf="site.raft_alias && site.raft_alias != '' && site.multiplecode != true">
                                  <div class="font-weight-bold">RAFT code :</div><div class="pl-2">{{site.raft_alias}}</div>
                                  <div class="pl-1" *ngIf="superUserShow"><mat-icon style="height:18px !important" class="edit" svgIcon="edit" alt="edit" tabindex="0" role="button" data-toggle="modal" data-target="#editRaftAliasValModal" (click)="editRaftAliasSet(site.raft_alias, site.editRowIdRaftAlias, site.rowId, site.raft_name)" (keydown.enter)="editRaftAliasSet(site.raft_alias, site.editRowIdRaftAlias, site.rowId, site.raft_name)" (keydown.space)="editRaftAliasSet(site.raft_alias, site.editRowIdRaftAlias, site.rowId, site.raft_name)"></mat-icon>&nbsp;
                                    <span *ngIf="(site.endDate != '' && site.endDate!=undefined) && site.raft_alias !=''" class="group-status px-3 py-1" style="background : #CB4B32">Archived</span>
                                  </div>
                                </ng-container>

                                <div *ngIf="site.multiplecode == true" class="mb-2 row" style="color: #CB4B32;">ERROR: MULTIPLE CODES</div>
                              </div>

                              <div class="mb-2 row" *ngIf="site.type == 'Ordering' && site.saer_code && site.saer_code != '' && (site.c2b_code || (!site.raft_alias && !site.latam_code)) && site.multiplecode != true">
                                <ng-container *ngIf="site.saer_code && site.saer_code != '' && site.multiplecode != true">
                                    <div class="font-weight-bold">SAER code :</div><div class="pl-2">{{site.saer_code}}</div>
                                    <div class="pl-1" *ngIf="roleVariableHide"><mat-icon class="edit" style="height:18px !important" svgIcon="edit" alt="edit" tabindex="0" role="button" data-toggle="modal" data-target="#editSaerValModal" (click)="editSaerAliasSet(site.saer_code, site.edit_saer_code, site.rowId, site.raft_name, site.endDate)" (keydown.enter)="editSaerAliasSet(site.saer_code, site.edit_saer_code, site.rowId, site.raft_name, site.endDate)" (keydown.space)="editSaerAliasSet(site.saer_code, site.edit_saer_code, site.rowId, site.raft_name, site.endDate)"></mat-icon>&nbsp;
                                      <span *ngIf="(site.endDate != '' && site.endDate!=undefined)&& site.saer_code !=''" class="group-status px-3 py-1" style="background : #CB4B32">Archived</span>
                                    </div>
                                </ng-container>

                                  <div *ngIf="site.multiplecode == true" class="mb-2 row" style="color: #CB4B32;">ERROR: MULTIPLE CODES</div>

                              </div>

                              <div class="mb-2 row" *ngIf="site.type == 'Ordering' && site.latam_code && site.latam_code != '' && !site.saer_code && !site.raft_alias && site.multiplecode != true">
                                <ng-container *ngIf="site.latam_code && site.latam_code != '' && site.multiplecode != true">
                                    <div class="font-weight-bold">LATAM code :</div><div class="pl-2">{{site.latam_code}}</div>
                                    <div class="pl-1" *ngIf="roleVariableHide"><mat-icon class="edit" style="height:18px !important" svgIcon="edit" alt="edit" tabindex="0" role="button" data-toggle="modal" data-target="#editLatamValModal" (click)="editLatamAliasSet(site.latam_code, site.edit_latam_code, site.rowId, site.latam_name, site.endDate)" (keydown.enter)="editLatamAliasSet(site.latam_code, site.edit_latam_code, site.rowId, site.latam_name, site.endDate)" (keydown.space)="editLatamAliasSet(site.latam_code, site.edit_latam_code, site.rowId, site.latam_name, site.endDate)"></mat-icon>&nbsp;
                                      <span *ngIf="(site.endDate != '' && site.endDate!=undefined)&& site.latam_code !=''" class="group-status px-3 py-1" style="background : #CB4B32">Archived</span>
                            </div>
                                </ng-container>

                                  <div *ngIf="site.multiplecode == true" class="mb-2 row" style="color: #CB4B32;">ERROR: MULTIPLE CODES</div>
                              </div>
                              <div *ngIf="site.multiplecode == true">
                                <div class="mb-2 row" style="color: #CB4B32;">ERROR: MULTIPLE CODES</div>
                              </div>
                              <div class="mb-2 row" *ngIf="site.type == 'Ordering' && site.rnaipl_code && site.rnaipl_code != '' && !site.saer_code && !site.raft_alias && !site.latam_code && site.multiplecode != true">
                                    <div class="font-weight-bold">RNAIPL code :</div><div class="pl-2">{{site.rnaipl_code}}</div>
                                    <div class="pl-1" *ngIf="superUserShow"><mat-icon class="edit" style="height:18px !important" svgIcon="edit" alt="edit" tabindex="0" role="button" data-toggle="modal" data-target="#editRnaiplValModal" (click)="editRnaiplAliasSet(site.rnaipl_code, site.edit_rnaipl_code, site.rowId)" (keydown.enter)="editRnaiplAliasSet(site.rnaipl_code, site.edit_rnaipl_code, site.rowId)" (keydown.space)="editRnaiplAliasSet(site.rnaipl_code, site.edit_rnaipl_code, site.rowId)"></mat-icon>&nbsp;
                                </div>
                                    <div class="pl-1" *ngIf="(site.endDate != '' && site.endDate!=undefined)&& site.rnaipl_code !=''">
                                      <span class="group-status px-3 py-1" style="background : #CB4B32">Archived</span>
                                    </div>
                              </div>

                            </div>
                              <div class="mb-2 row" *ngIf="site.type!='Main Entrance' && (site.raft_alias || site.saer_code || site.latam_code || site.rnaipl_code)">
                              <div class="font-weight-bold">Name :</div>
                              <div class="pl-2" style="white-space: pre;">{{site.raft_name}}</div>
                                <div><mat-icon class="edit"  style="height:18px !important" *ngIf="(!site.saer_code && !site.latam_code && site.raft_alias) && roleVariableHide" svgIcon="edit" alt="edit" tabindex="0" role="button" data-toggle="modal" data-target="#editRaftNameValModal" (click)="editRaftAliasSet(site.raft_alias,site.editRowIdRaftAlias,site.rowId,site.raft_name)" (keydown.enter)="editRaftAliasSet(site.raft_alias,site.editRowIdRaftAlias,site.rowId,site.raft_name)" (keydown.space)="editRaftAliasSet(site.raft_alias,site.editRowIdRaftAlias,site.rowId,site.raft_name)"></mat-icon>
                                  <mat-icon class="edit" style="height:18px !important" *ngIf="(site.type == 'Ordering' && site.saer_code && !site.raft_alias && !site.latam_code) && roleVariableHide" svgIcon="edit" alt="edit" tabindex="0" role="button" data-toggle="modal" data-target="#editSaerNameValModal" (click)="editSaerAliasSet(site.saer_code,site.editRowIdRaftName,site.rowId,site.raft_name)" (keydown.enter)="editSaerAliasSet(site.saer_code,site.editRowIdRaftName,site.rowId,site.raft_name)" (keydown.space)="editSaerAliasSet(site.saer_code,site.editRowIdRaftName,site.rowId,site.raft_name)"></mat-icon>
                                  <mat-icon class="edit" style="height:18px !important" *ngIf="(site.type == 'Ordering' && site.latam_code && !site.raft_alias && !site.saer_code) && roleVariableHide" svgIcon="edit" alt="edit" tabindex="0" role="button" data-toggle="modal" data-target="#editLatamNameValModal" (click)="editLatamAliasSet(site.latam_code,site.editRowIdLatamName,site.rowId,site.latam_name)" (keydown.enter)="editLatamAliasSet(site.latam_code,site.editRowIdLatamName,site.rowId,site.latam_name)" (keydown.space)="editLatamAliasSet(site.latam_code,site.editRowIdLatamName,site.rowId,site.latam_name)"></mat-icon>
                                  <mat-icon class="edit" style="height:18px !important" *ngIf="(site.type == 'Ordering' && site.rnaipl_code && !site.raft_alias && !site.saer_code && !site.latam_code) && roleVariableHide" svgIcon="edit" alt="edit" tabindex="0" role="button" data-toggle="modal" data-target="#editRnaiplNameValModal" (click)="editRnaiplNameSet(site.editRowIdRnaiplName,site.rowId,site.raft_name,site.rnaipl_code)" (keydown.enter)="editRnaiplNameSet(site.editRowIdRnaiplName,site.rowId,site.raft_name,site.rnaipl_code)" (keydown.space)="editRnaiplNameSet(site.editRowIdRnaiplName,site.rowId,site.raft_name,site.rnaipl_code)"></mat-icon>
                              </div>
                            </div>






                        </td>
                        <td class="pr-0 stayTop">
                          <div>

                            <div *ngIf="accessPointAddressData[site.rowId]">
                              <div class="pt-1 row">
                                <div class="" *ngIf="accessPointAddressData[site.rowId].wayNumber">
                                  {{accessPointAddressData[site.rowId].wayNumber}}, &nbsp;{{accessPointAddressData[site.rowId].streetName}}
                                </div>
                                <div class="text-justify" *ngIf="!accessPointAddressData[site.rowId].wayNumber">
                                  {{accessPointAddressData[site.rowId].streetName}}
                                </div>
                                <div *ngIf="accessPointAddressData[site.rowId] && (roleVariableHide || (site.status == 'Pending' && showForSupplier==false))">
                                  <mat-icon class="edit" style="height:18px !important" svgIcon="edit" alt="edit" tabindex="0" role="button" data-toggle="modal" data-target="#siteEditAddress" (click)="loadAddressModalDetails(site.gpslatdec,site.gpslondec,site.gpsEditRowId,site.addressEditRowId,site.rowId,accessPointAddressData[site.rowId],site.gpslat,site.gpslon)" (keydown.enter)="loadAddressModalDetails(site.gpslatdec,site.gpslondec,site.gpsEditRowId,site.addressEditRowId,site.rowId,accessPointAddressData[site.rowId],site.gpslat,site.gpslon)" (keydown.space)="loadAddressModalDetails(site.gpslatdec,site.gpslondec,site.gpsEditRowId,site.addressEditRowId,site.rowId,accessPointAddressData[site.rowId],site.gpslat,site.gpslon)"></mat-icon>
                                </div>
                              </div>
                              <div class="pt-1 row">
                                {{accessPointAddressData[site.rowId].addressinfo}}
                              </div>
                              <div class="pt-1 row">
                                {{accessPointAddressData[site.rowId].addressinformation}}
                              </div>
                              <div class="pt-1 row" *ngIf="accessPointAddressData[site.rowId].postalCode">
                                <div>
                                <label class="font-weight-bold p-0 m-0" for="postalCode">Postal Code:</label>
                                {{accessPointAddressData[site.rowId].postalCode}}
                                </div>
                              </div>
                              <div class="pt-1 row" *ngIf="accessPointAddressData[site.rowId].territorialDivision">
                                <div>
                                <label class="font-weight-bold p-0 m-0" for="territorialDivision">Territorial Division:</label>
                                {{accessPointAddressData[site.rowId].territorialDivision}}
                                </div>
                              </div>
                            </div>
                            <div class="row" *ngIf="!accessPointAddressData[site.rowId] && showBuyerProfile">
                              <div class="" *ngIf="!accessPointAddressData[site.rowId]">
                                <mat-icon class="edit" svgIcon="edit" alt="edit" tabindex="0" role="button" data-toggle="modal" data-target="#siteEditAddress" (click)="loadAddressModalDetails(site.addressEditRowId,site.rowId,accessPointAddressData[site.rowId])" (keydown.enter)="loadAddressModalDetails(site.addressEditRowId,site.rowId,accessPointAddressData[site.rowId])" (keydown.space)="loadAddressModalDetails(site.addressEditRowId,site.rowId,accessPointAddressData[site.rowId])"></mat-icon>
                              </div>
                            </div>
                            <br>
                            <div class="pr-1 row">
                              <div class="font-italic">

                                <ng-container *ngIf="site.postalSummary">
                                  <div>{{site.postalSummary.line0 ? site.postalSummary.line0 : ''}}</div>
                                  <div>{{site.postalSummary.line1 ? site.postalSummary.line1 : ''}}</div>
                                  <div>{{site.postalSummary.line2 ? site.postalSummary.line2 : ''}}</div>
                                  <div>{{site.postalSummary.line3 ? site.postalSummary.line3 : ''}}</div>
                                  <div>{{site.postalSummary.line4 ? site.postalSummary.line4 : ''}}</div>
                                  <div>{{site.postalSummary.line5 ? site.postalSummary.line5 : ''}}</div>
                                  <div>{{site.postalSummary.line6 ? site.postalSummary.line6 : ''}}</div>
                                  <div>{{site.postalSummary.line7 ? site.postalSummary.line7 : ''}}</div>
                                </ng-container>
                              </div>
                            </div>
                            <div class="accordion constcs">
                              <div id="collapsible{{i}}" data-parent="#panels" class="collapse show recurring pt-1">
                                <div>
                                  <div class="mb-2 row">
                                    <div class="font-weight-bold">GPS :</div>
                                    <div>
                                    <a *ngIf="site.gpslatdec && site.gpslondec" class="label-darkblue" [attr.href]="googleLink+ site.gpslatdec+ ' ' + site.gpslondec +'?hl=en'" target="_blank">
                                      {{site.gpslatdec ? site.gpslatdec : '-'}}, &nbsp;{{site.gpslondec ? site.gpslondec : '-'}}</a>
                                    </div>
                                    <div *ngIf="(roleVariableHide || (showForSupplier==false && !site.gpslatdec && !site.gpslondec)) && site.status.toLowerCase()!='archived'">
                                      <mat-icon class="edit" style="height:18px !important" svgIcon="edit" alt="edit" tabindex="0" role="button" data-toggle="modal" data-target="#editGpsCoordinatesModal" (click)="loadGpsCoordinates(site.gpslatdec,site.gpslondec,site.gpsEditRowId,site.rowId,site.gpslat,site.gpslon)" (keydown.enter)="loadGpsCoordinates(site.gpslatdec,site.gpslondec,site.gpsEditRowId,site.rowId,site.gpslat,site.gpslon)" (keydown.space)="loadGpsCoordinates(site.gpslatdec,site.gpslondec,site.gpsEditRowId,site.rowId,site.gpslat,site.gpslon)"></mat-icon></div>
                                  </div>
                                </div>
                                <div>
                                  <button type="button" class="btn btn-custom btn-custom-sm btn-blue float-right mr-2" data-toggle="modal" data-target="#showSelectAnotherAddress" (click)="showAddressList(site.addressEditRowId,site.rowId,site.gpsEditRowId)" *ngIf="accessPointAddressData[site.rowId] && (roleVariableHide || (site.status == 'Pending' && showForSupplier==false))">
                                     Select Another Address
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                    <tbody *ngIf="sitesData && sitesData.length <= 0" #customLoadingTemplate3>
                        <tr>
                          <td colspan="7" class="font-weight-bold label-darkblue text-center"> No records found.</td>
                        </tr>
                    </tbody>

                      <ng-container *ngIf="loading">
                        <div class="local-loading-overlay">
                          <div class="custom-spinner-template">
                            <mat-spinner class="custom-spinner black-spinner" diameter="40"></mat-spinner>
                          </div>
                        </div>
                      </ng-container>

                  </table>

                </div>
              </div>
            </section>
            <section class="col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 p-0 border-bottom-yellow">
              <div class="row m-0 pt-3 align-center">
                <div class="col col-12 col-sm-4 col-md-5 col-lg-5 col-xl-5">
                  <a (click)="toggleSiteContacts()" (keydown.enter)="toggleSiteContacts()" (keydown.space)="toggleSiteContacts()" tabindex="0" class="title"
                    style="font-size: 15px; text-decoration: underline;color:#000; cursor:pointer; font-weight:600;">
                    SITE CONTACTS ({{SiteContacts?.length || 0}})
                  </a>
                </div>
                <div class="col col-12 col-sm-8 col-md-7 col-lg-7 col-xl-7 text-right">
                  <button type="button"
                    *ngIf="roleVariableHide || showForSupplier==false || superUserShow || !showBuyerProfile || roleIsManager"
                    data-toggle="modal" data-target="#AddnewSiteContacts" (click)="AddEditSiteContact('load')"
                    class=" sitecontact==true ? btn btn-green btn-custom btn-custom-md btn-blue : btn btn-custom btn-custom-md btn-grey"
                    [disabled]="!sitecontact" style="position: relative;top: 8px;">
                    <mat-icon svgIcon="add" class="img-btn"></mat-icon><span class="float-right"> Add Site Contact </span>
                  </button>
                </div>

                  <a [href]="pdfLink" target="_blank" style="font-size: 15px; text-decoration: underline;color:#CB3B42; left: 16px; position: relative; padding-bottom: 10px;">
                    Personal Data Protection
                  </a>
              </div>

              <div *ngIf="showSiteContactsBlock" class="row m-0">
                <div class="table-responsive mt-3 scroll-table-section">
                  <table class="table table-sm m-0">
                    <thead>
                      <tr>
                        <th class="cdwidth15" style="text-align: left;text-decoration: none;">First Name</th>
                        <th class="cdwidth15" style="text-align: left;text-decoration: none;">Last Name</th>
                        <th class="cdwidth20" style="text-align: left;text-decoration: none;">E-mail</th>
                        <th style="text-align: left;text-decoration: none;">IPN</th>
                        <th class="cdwidth17" style="text-align: left;text-decoration: none;">Role</th>
                        <th class="cdwidth13" style="text-align: left;text-decoration: none;">Cellphone</th>
                        <th class="cdwidth15" style="text-align: left;text-decoration: none;">Phone</th>
                        <th class="cdwidth2"></th>
                      </tr>
                    </thead>
                    <tbody *ngIf="SiteContacts.length>0" >
                      <tr *ngFor="let siteCont of SiteContacts">
                        <td>{{siteCont.personFirstName ? siteCont.personFirstName : ''}}</td>
                        <td class="font-weight-bold label-darkblue" data-toggle="modal" data-target="#openContactDetails" *ngIf="superusershow==true" (click)="AddEditCmpContact('edit',siteCont.row_id)" style="cursor: pointer;" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (AddEditCmpContact('edit',siteCont.row_id))">{{siteCont.personLastName ? siteCont.personLastName : '' }}</td>
                        <td *ngIf="roleVariableHide || showBuyerProfile || roleIsManager==true || showForConsult == true " >{{siteCont.personLastName ? siteCont.personLastName : '' }}</td>
                        <td>{{PersonDetails[siteCont.personRowId+'_email'] ? PersonDetails[siteCont.personRowId+'_email'] : '' }}</td>
                        <td>
                          <ng-container *ngIf="personIpn[siteCont.personRowId] && !personIpn[siteCont.personRowId].archived && (!personIpn[siteCont.personRowId].endDate || personIpn[siteCont.personRowId].endDate >= today); else emptyIpn">
                            {{personIpn[siteCont.personRowId].loginId}}
                          </ng-container>
                          <ng-template #emptyIpn></ng-template>
                        </td>
                        <td>{{siteCont.roleTypeLabel ? siteCont.roleTypeLabel : '' }} <span *ngIf="superusershow==true"> <mat-icon svgIcon="edit" alt="edit"  width="14" height="15" data-toggle="modal" data-target="#EditCmpConRole" (click)="AddEditCmpContact('edit',siteCont.rowId)" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (AddEditCmpContact('edit',siteCont.rowId))"></mat-icon></span></td>
                        <td>{{PersonDetails[siteCont.personRowId+'_p'] ? PersonDetails[siteCont.personRowId+'_p'] : ''}}</td>
                        <td>{{PersonDetails[siteCont.personRowId+'_f'] ? PersonDetails[siteCont.personRowId+'_f'] : ''}}</td>
                        <td *ngIf="showForConsult == true"><mat-icon svgIcon="edit" style="cursor: pointer;" alt="edit"  width="14" height="15" data-toggle="modal" data-target="#openContactAndRole" (click)="AddEditSiteContact('edit',siteCont.rowId)" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (AddEditSiteContact('edit',siteCont.rowId))"></mat-icon></td>
                      </tr>
                    </tbody>
                    <tbody *ngIf="ContactsFlag==true && SiteContacts.length==0">
                      <tr>
                        <td colspan="8" class="font-weight-bold label-darkblue text-center" *ngIf="SiteIdentiLoading==false &&ContactsFlag==true">No Results</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
  </div>
</div>
</div>
<div *ngIf="noSiteExists==true">No Site Found or Network Error!!!</div>

<div class="modal fade" id="showValidateAcpSaer" tabindex="-1" aria-modal="true" aria-labelledby="validateModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-custom" *ngIf="displayValidate==true">
    <div class="modal-content">
      <div class="modal-header border-0">
        <h6 class="modal-title font-weight-bold text-center" id="validateModalLabel">
          Please Wait Loading Data....
        </h6>
        <button type="button" class="close" id="closeValidateAcpSaer" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <section class="row m-0 bg-white no-shadow">

           <ng-container *ngIf="loadingValidateAcpSaer">
              <div class="local-loading-overlay">
                <div class="custom-spinner-template">
                  <mat-spinner class="custom-spinner black-spinner" diameter="40"></mat-spinner>
                </div>
              </div>
            </ng-container>

        </section>
      </div>
      <div class="modal-footer border-0">
        <button type="button" class="btn btn-custom btn-custom-sm btn-blue" data-dismiss="modal">Cancel</button>
      </div>
    </div>
  </div>

    <div class="modal-dialog modal-custom" *ngIf="displayValidate==false">
      <div class="modal-content">
        <div class="modal-header border-0">
          <h6 class="modal-title font-weight-bold text-center" id="validateOrderingLabel">
            Validate Ordering
          </h6>
          <button type="button" class="close" id="closeValidateAcplabelModel" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <section class="row m-0 bg-white no-shadow">

            <div class="form-group col-12 pt-4" *ngIf="roleVariableHide">
              <span class="font-weight-bold">RAFT</span>
              <label class="switch m-0">
                <input type="checkbox" id="sliderCheckBoxRaft" (change)="toggleCodeDispForValidation('RAFT')" [(ngModel)]="raftvalidtaeswitch" title="RAFT_Code">
                <span class="slider round"></span>
              </label>
              <span *ngIf="raftLoading">
                  <img src="assets/images/loading.gif" alt="loading...">
              </span>
            </div>


            <div class="form-group col-6 pt-4" *ngIf="roleVariableHide">
              <span class="font-weight-bold">SAER</span>
              <label class="switch m-0">
                <input type="checkbox" id="sliderCheckBoxSaer" (change)="toggleCodeDispForValidation('SAER')" [(ngModel)]="saerswitchvalidate" title="SAER_Code">
                <span class="slider round"></span>
              </label>
            </div>
            <div class="form-group col-md-6 col-12" *ngIf="!showSaerValidate"></div>
            <div class="form-group col-md-6 col-12" *ngIf="showSaerValidate">
              <mat-label class="label-control">Code</mat-label>
              <input class="form-control form-control-sm" maxlength="8" [(ngModel)]="saerCodeModelValidate" type="text" />
              <span class="ng-clear-wrapper datalistClearButton" title="Clear all">
                <span class="ng-clear" style="background-color: #fff;" (click)="upresetAddQualifierSiteFields('latamNameModelValidate')" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (upresetAddQualifierSiteFields('latamNameModelValidate'))">×</span>
              </span>
              <mat-label class="label-control">Name</mat-label>
              <div>
                <input style="padding-right: 2px;" class="form-control form-control-sm form-control-paddings" [(ngModel)]="saerNameModelValidate" (ngModelChange)="saerNameModelValidate = $event.toUpperCase()" type="text"/>
                <span class="ng-clear-wrapper datalistClearButton" title="Clear all">
                  <span class="ng-clear" style="background-color: #fff;" (click)="upresetAddQualifierSiteFields('saerNameModelValidate')" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (upresetAddQualifierSiteFields('saerNameModelValidate'))">×</span>
                </span>
              </div>
            </div>



            <div class="form-group col-6 pt-4" *ngIf="roleVariableHide">
              <span class="font-weight-bold">LATAM</span>
              <label class="switch m-0">
                <input type="checkbox" id="sliderCheckBoxLatam" (change)="toggleCodeDispForValidation('LATAM')" [(ngModel)]="latamswitchvalidate" title="LATAM_Code">
                <span class="slider round"></span>
              </label>
            </div>
            <div class="form-group col-md-6 col-12" *ngIf="!showLatamValidate"></div>
            <div class="form-group col-md-6 col-12" *ngIf="showLatamValidate">
              <mat-label class="label-control">Code</mat-label>
              <input class="form-control form-control-sm" maxlength="8" [(ngModel)]="latamCodeModelValidate" type="text" />
              <span class="ng-clear-wrapper datalistClearButton" title="Clear all">
                <span class="ng-clear" style="background-color: #fff;" (click)="upresetAddQualifierSiteFields('latamCodeModelValidate')" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (upresetAddQualifierSiteFields('latamCodeModelValidate'))">×</span>
              </span>

              <mat-label class="label-control">Name</mat-label>
              <div>
                <input style="padding-right: 2px;" class="form-control form-control-sm form-control-paddings" [(ngModel)]="latamNameModelValidate" (ngModelChange)="latamNameModelValidate = $event.toUpperCase()" type="text"/>
                <span class="ng-clear-wrapper datalistClearButton" title="Clear all">
                  <span class="ng-clear" style="background-color: #fff;" (click)="upresetAddQualifierSiteFields('latamNameModelValidate')" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (upresetAddQualifierSiteFields('latamNameModelValidate'))">×</span>
                </span>
              </div>
            </div>

            <div class="form-group col-6 pt-4" *ngIf="roleVariableHide">
              <span class="font-weight-bold">RNAIPL</span>
              <label class="switch m-0">
                <input type="checkbox" id="sliderCheckBoxRnaiplValidate" (change)="toggleCodeDispForValidation('RNAIPL')" [(ngModel)]="rnaiplswitchvalidate" title="RNAIPL_Code">
                <span class="slider round"></span>
              </label>
            </div>
            <div class="form-group col-md-6 col-12" *ngIf="!showRnaiplValidate"></div>
            <div class="form-group col-md-6 col-12" *ngIf="showRnaiplValidate">
              <mat-label class="label-control">Code</mat-label>
              <input class="form-control form-control-sm" minlength="2" maxlength="6" pattern="[A-Za-z0-9]{2,6}" [(ngModel)]="rnaiplCodeModelValidate" (ngModelChange)="rnaiplCodeModelValidate = $event.toUpperCase()" type="text" />
              <span class="ng-clear-wrapper datalistClearButton" title="Clear all">
                <span class="ng-clear" style="background-color: #fff;" (click)="upresetAddQualifierSiteFields('rnaiplCodeModelValidate')" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (upresetAddQualifierSiteFields('rnaiplCodeModelValidate'))">×</span>
              </span>
              <span style="color: #cb4b32;" *ngIf="rnaiplCodeModelValidateError==true">Enter 2-6 alphanumeric characters</span>

              <mat-label class="label-control">Name</mat-label>
              <div>
                <input style="padding-right: 2px;" class="form-control form-control-sm form-control-paddings" [(ngModel)]="rnaiplNameModelValidate" (ngModelChange)="rnaiplNameModelValidate = $event.toUpperCase()" type="text"/>
                <span class="ng-clear-wrapper datalistClearButton" title="Clear all">
                  <span class="ng-clear" style="background-color: #fff;" (click)="upresetAddQualifierSiteFields('rnaiplNameModelValidate')" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (upresetAddQualifierSiteFields('rnaiplNameModelValidate'))">×</span>
                </span>
              </div>
            </div>


          </section>

    </div>
        <div class="modal-footer border-0">
          <button type="button" class="btn btn-custom btn-custom-sm btn-blue" data-dismiss="modal">Cancel</button>
          <button type="button" class="btn btn-custom btn-custom-sm btn-blue" [disabled]="saveDisable()" (click)="saveLatamAndSaer()">
            <mat-icon svgIcon="mail" class="img-btn"></mat-icon><span class="float-right">   Save </span>
          </button>
        </div>
      </div>
    </div>

</div>

<div class="modal fade modal-above" id="ArcaPopup" tabindex="-1" aria-modal="true" aria-labelledby="ArcaPopupLabel" aria-hidden="true">
<div class="modal-dialog modal-custom">
  <div class="modal-content">
    <div class="modal-header border-0">
      <h6 class="modal-title font-weight-bold text-center" id="ArcaPopupLabel">
        Search User
        <button type="button" class="close" id="closeGCBtn" #closeBtn data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </h6>
    </div>
    <span class="col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12" style="margin-top: 5px; font-weight: 900">
      <mat-label class="label-control">IPN
      </mat-label>
      <input type="text" class="form-control form-control-sm" [(ngModel)]="ArcIpn" (ngModelChange)="ArcNameModelChange()">
      <span class="ng-clear-wrapper datalistClearButton" title="Clear all"><span class="ng-clear" (click)="resetArcaSearch('ArcIpn')" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (resetArcaSearch('ArcIpn'))">×</span></span>
    </span>
    <span class="col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12" style="margin-top: 5px; font-weight: 900">
      <mat-label class="breakline"><span class="breakline2">OR</span>
      </mat-label>
    </span>
    <span class="col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12" style="margin-top: 5px; font-weight: 900">
      <mat-label class="label-control">First Name
      </mat-label>
      <input type="text" class="form-control form-control-sm" [(ngModel)]="ArcFirstName" (ngModelChange)="ArcNameModelChange()">
      <span class="ng-clear-wrapper datalistClearButton" title="Clear all"><span class="ng-clear" (click)="resetArcaSearch('ArcFirstName')" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (resetArcaSearch('ArcFirstName'))">×</span></span>
    </span>
    <span class="col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12" style="margin-top: 5px; font-weight: 900">
      <mat-label class="label-control">Last Name
      </mat-label>
      <input type="text" class="form-control form-control-sm" [(ngModel)]="ArcLastName" (ngModelChange)="ArcNameModelChange()">
      <span class="ng-clear-wrapper datalistClearButton" title="Clear all"><span class="ng-clear" (click)="resetArcaSearch('ArcLastName')" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (resetArcaSearch('ArcLastName'))">×</span></span>
    </span>
    <div style="text-align: center;" *ngIf="arcaSrchWait==true">
      <img src="assets/images/loading.gif" alt="loading...">
    </div>
    <div style="text-align: center;" *ngIf="arcaSrchnoresults==true">
      <span> No search results</span>
    </div>
    <span class="table-responsive mt-3" *ngIf="resetArca==true">
      <table class="table table-sm m-0">
        <thead>
          <tr>
            <th class="ccwidth1" (click)="sort('code')" tabindex="0" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (sort('code'))">IPN</th>
            <th class="ccwidth1" (click)="sort('status')" tabindex="0" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (sort('status'))">First Name</th>
            <th class="ccwidth1" (click)="sort('label')" tabindex="0" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (sort('label'))">Last Name</th>
            <th class="ccwidth1" *ngIf="showUidDisable==false">SAM</th>
          </tr>
        </thead>
        <tbody #customLoadingTemplate>
          <tr *ngFor="let cmdData of data | orderBy: key:reverse; let i=index">
            <td class="font-weight-bold">
              <span *ngIf="isaRoleFor_Uid[cmdData.Uid]=='manager' || showUidDisable==true">
                <a class="label-darkblue" href="javascript:void(0)" (click)="PasteSam(cmdData.Uid,cmdData.FirstName,cmdData.LastName,cmdData.Mail)"> {{cmdData ? cmdData.Uid : ''}} </a>
              </span>
              <span *ngIf="isaRoleFor_Uid[cmdData.Uid]!='manager' && showUidDisable==false">
                {{cmdData ? cmdData.Uid : ''}}
              </span>
            </td>
            <td class="font-weight-bold">{{cmdData ? cmdData.FirstName : ''}}
               </td>
            <td class="font-weight-bold">{{cmdData ? cmdData.LastName : ''}}</td>
            <td *ngIf="showUidDisable==false">
             <span *ngIf="isaRoleFor_Uid[cmdData.Uid]=='manager'">
                <img src="assets/images/greentick.png" alt="loading...">
              </span>
              <span *ngIf="isaRoleFor_Uid[cmdData.Uid]!='manager'"  >
                <img src="assets/images/close.png" alt="loading...">
                </span>

            </td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
              <td colspan="4">

              </td>
          </tr>
        </tfoot>
      </table>
    </span>

    <div class="modal-footer border-0">
      <section class="bg-white no-shadow m-0">

        <button type="button" class="btn btn-custom btn-custom-sm btn-blue" (click)="ArcSearch()">
          <mat-icon svgIcon="search" class="img-btn mr-2"></mat-icon> <span class="float-right"> Search </span>
        </button>
      </section>
    </div>
  </div>
</div>
</div>

<div class="modal fade"  id="openNoAlcor" tabindex="-1" aria-modal="true" aria-labelledby="openNoAlcorLabel" aria-hidden="true">
<div class="modal-dialog modal-custom">
 <div class="modal-content">
   <div class="modal-header border-0">
     <h6 class="modal-title font-weight-bold text-center" id="openNoAlcorLabel">
      Qualifier Validation
       <button type="button" class="close" id="closeNoAlcor" #closeBtn data-dismiss="modal" aria-label="Close">
         <span aria-hidden="true">&times;</span>
       </button>
     </h6>
   </div>

   <div class="modal-body">
     <section class="row m-0 bg-white no-shadow">
       <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
         <div class="mb-2">Company Name: <span class="label-blue font-weight-bold">{{businessEntityCompanyLegalName}}</span></div>
         <img src="assets/images/warning.png" class="img-btn mr-2"><span>No ALCOR alias associated to the company !</span>
       </div>
     </section>
   </div>

   <div class="modal-footer border-0">
     <section class="bg-white no-shadow m-0">
       <button type="button" class="btn btn-custom btn-custom-sm btn-blue" data-dismiss="modal">Cancel</button>
     </section>
   </div>
 </div>
</div>
</div>
<div style="display: none;">
  <table id="excelTableLog">
    <thead>
      <tr>
        <th>Identifiers</th>
        <th>Updated</th>
        <th>Status</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let Data of TableData">
        <td>
          {{Data['identifier'] ? Data['identifier'] : '-'}}
        </td>
        <td>
          {{Data['updated'] ? Data['updated'] : '-'}}
        </td>
        <td>
          {{Data['reverted'] ? Data['reverted'] : '-'}}
        </td>
      </tr>
    </tbody>
  </table>
</div>
<div class="modal fade"  id="openForsingleAlcor" tabindex="-1" aria-modal="true" aria-labelledby="openForsingleAlcorLabel" aria-hidden="true">
<div class="modal-dialog modal-custom">
  <div class="modal-content" style="width: 800px;margin-left: -26% !important;">
    <div class="modal-header border-0">
      <h6 class="modal-title font-weight-bold text-center" id="openForsingleAlcorLabel">
       Select RAFT alias for the Qualifier

      </h6>
      <button type="button" class="close" id="closeForsingleAlcor" data-dismiss="modal" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>

   <div class="modal-body px-0">
     <section class="row m-0 bg-white no-shadow">
       <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 p-0">
         <div class="modal-body row m-0 p-0 table-responsive">
           <table class="table m-0">
             <thead style="background-color: #F5F5F5;">
               <tr class="col p-0">
                 <th class="thCustom" (click)="sort('')" tabindex="0" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (sort(''))"></th>
                 <th class="thCustom font-weight-bold" (click)="sort('alias')" tabindex="0" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (sort('alias'))">RAFT Code</th>
                 <th class="thCustom font-weight-bold" (click)="sort('name')"  tabindex="0" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (sort('name'))">RAFT Name</th>
                 <th class="thCustom font-weight-bold" (click)="sort('effectiveDate')" tabindex="0" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (sort('effectiveDate'))">Effective Date</th>
                 <th class="thCustom font-weight-bold" (click)="sort('endDate')" tabindex="0" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (sort('endDate'))">End Date</th>
                 <th class="thCustom font-weight-bold" (click)="sort('qualifier')" tabindex="0" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (sort('qualifier'))">Qualifier type</th>
               </tr>
             </thead>
             <tbody *ngIf="mainValidateAcpData.length>0">
               <tr *ngFor="let main of mainValidateAcpData | orderBy: key:reverse; let i = index" class="col forColor p-0">
                   <td class="tdCustom">
                       <input id="{{main.alias}}" class="edit" [disabled]="main.disableRadio" (click)="saveAccessPointRowId(main.rowId,main.alias)" value="{{main.alias}}" [(ngModel)]="raftRadioVal" name="qualifierSame" type="radio">
                   </td>
                   <td class="tdCustom font-weight-bold">
                     <span class="edit" (click)="selectInputFieldRaftselect(main.alias,main.disableRadio)" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (selectInputFieldRaftselect(main.alias,main.disableRadio))">
                       {{main.alias ? main.alias : '-'}}
                     </span>
                   </td>
                   <td class="tdCustom font-weight-bold">
                     <span *ngIf="raftNameUpdatedForAlcor">
                       {{raftNameUpdatedForAlcor[main.rowId] ? raftNameUpdatedForAlcor[main.rowId].identifierValue : '-'}}
                     </span>
                   </td>
                   <td class="tdCustom font-weight-bold">
                     <span>
                       {{main.effectiveDate ? main.effectiveDate : '-'}}
                     </span>
                   </td>
                   <td class="tdCustom font-weight-bold">
                     <span>
                       {{main.endDate ? main.endDate : '-'}}
                     </span>
                   </td>
                   <td class="tdCustom">
                     <span class="p-0" *ngFor="let mainQua of main.qualifier">
                       <mat-icon class="qualifer-icons" svgIcon="{{qualifierTypes[mainQua]}}" title="{{qualifierTypesText[mainQua] ? qualifierTypesText[mainQua] : ''}}" style="width: 40px !important;height: 40px !important;" data-toggle="tooltip" alt=""></mat-icon>
                     </span>
                   </td>
               </tr>
             </tbody>
             <tbody *ngIf="mainValidateAcpData.length==0">
               <tr>
                 <td colspan="7" class="font-weight-bold text-darkblue text-center">No Results</td>
               </tr>
             </tbody>
             <tfoot>
                   <tr>
                     <td colspan="8">

                     </td>
                   </tr>
             </tfoot>
           </table>
         </div>
       </div>
     </section>
   </div>

    <div class="modal-footer border-0">
      <section class="bg-white no-shadow m-0">
        <button type="button" class="btn btn-custom btn-link" data-dismiss="modal"> Cancel </button>
        <button type="button" class="btn btn-custom btn-custom-sm btn-blue ml-2" [disabled]="disableSaveRaftBtn==true" (click)="saveUpdateRaft()">
          <mat-icon svgIcon="mail" class="img-btn"></mat-icon><span class="float-right"> Save </span>
        </button>
      </section>
    </div>
  </div>
 </div>
</div>
<div class="modal fade"  id="openFormultipleAlcor" tabindex="-1" aria-modal="true" aria-labelledby="openFormultipleAlcorLabel" aria-hidden="true">
  <div class="modal-dialog modal-custom">
    <div class="modal-content" style="width: 800px;margin-left: -26% !important;">
      <div class="modal-header border-0">

              <h6 class="modal-title font-weight-bold text-center" id="openFormultipleAlcorLabel">
               Select ALCOR
                <button type="button" class="close" id="closeFormultipleAlcor" #closeBtn data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </h6>
            </div>

            <div class="modal-body px-0">
             <section class="row m-0 bg-white no-shadow">
                <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 p-0">
                 <div class="modal-body row m-0 p-0 table-responsive">
                   <table class="table m-0">
                     <thead style="background-color: #F5F5F5;">
                       <tr class="col p-0">
                         <th class="thCustom" style="width: 1% !important;" (click)="sort('')" tabindex="0" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (sort(''))"></th>
                         <th class="thCustom"(click)="sort('alias')" tabindex="0" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (sort('alias'))">ALCOR</th>
                         <th class="thCustom"(click)="sort('businessIdentifierName')" tabindex="0" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (sort('businessIdentifierName'))">ALCOR Name</th>
                         <th class="thCustom"(click)="sort('effectiveDate')" tabindex="0" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (sort('effectiveDate'))">Effective Date</th>
                         <th class="thCustom"(click)="sort('endDate')" tabindex="0" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (sort('endDate'))">End Date</th>
                       </tr>
                     </thead>

                     <tbody *ngIf="mainValidateAlcorData.length>0">
                       <tr *ngFor="let alcors of mainValidateAlcorData | orderBy: key:reverse; let i = index" class="forColor p-0">
                         <td class="text-left tdCustom" style="width: 0% !important;">
                           <input class="edit" id="{{alcors.aliass}}" value="{{alcors.aliass}}" [(ngModel)]="alcorRadioVal" name="sameAlcor" type="radio">
                         </td>
                         <td class="tdCustom font-weight-bold edit" (click)="selectInputField(alcors.aliass)" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (selectInputField(alcors.aliass))">{{alcors.aliass ? alcors.aliass : '-'}}</td>
                         <td class="tdCustom">
                           <span *ngIf="alcorRealEstateIdenData.length > 0">
                             {{alcorRealEstateIdenData[alcors.aliass] ? (alcorRealEstateIdenData[alcors.aliass].businessIdentifierName ? alcorRealEstateIdenData[alcors.aliass].businessIdentifierName : '-') : '-'}}
                           </span>
                         </td>
                         <td class="tdCustom">
                           <span *ngIf="alcorRealEstateIdenData.length > 0">
                               {{alcorRealEstateIdenData[alcors.aliass] ? (alcorRealEstateIdenData[alcors.aliass].effectiveDate ? alcorRealEstateIdenData[alcors.aliass].effectiveDate : '-') : '-'}}
                           </span>
                         </td>
                         <td class="tdCustom">
                           <span *ngIf="alcorRealEstateIdenData.length > 0">
                               {{alcorRealEstateIdenData[alcors.aliass] ? (alcorRealEstateIdenData[alcors.aliass].endDate ? alcorRealEstateIdenData[alcors.aliass].endDate : '-') : '-'}}
                           </span>
                         </td>
                       </tr>
                     </tbody>
                     <tbody *ngIf="mainValidateAlcorData.length==0">
                       <tr>
                         <td colspan="7" class="font-weight-bold text-darkblue text-center">No Results</td>
                       </tr>
                     </tbody>
                     <tfoot>
                       <tr>
                         <td colspan="8">

                         </td>
                       </tr>
                     </tfoot>
                   </table>
                 </div>
               </div>
             </section>
            </div>

            <div class="modal-footer border-0">
              <section class="bg-white no-shadow m-0">
                <button type="button" class="btn btn-custom btn-link" data-dismiss="modal"> Cancel </button>
                <button type="button" class="btn btn-custom btn-custom-sm btn-blue ml-2" (click)="openAlcorVal()">
                  <mat-icon svgIcon="mail" class="img-btn"></mat-icon><span class="float-right"> Save </span>
                </button>
              </section>
            </div>
           </div>
         </div>
</div>




<div class="modal fade"  id="createMailModalPopup" tabindex="-1" aria-modal="true" aria-labelledby="createMailModalPopupLabel" aria-hidden="true">
<div class="modal-dialog modal-custom">
  <div class="modal-content">
    <div class="modal-header border-0">
      <h6 class="modal-title font-weight-bold text-center" id="createMailModalPopupLabel">
          Reminder
        <button type="button" class="close" id="closeCCBtn" #closeBtn data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </h6>
    </div>

    <div class="modal-body">
      <section class="row m-0 bg-white no-shadow">
        <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <mat-label class="label-control">
            <h4 class="title px-2" >Reminder Notes</h4>
          </mat-label>
          <textarea
          rows="3" cols="60"
            [(ngModel)]="MailNameModel">
          </textarea>
          <span class="ng-clear-wrapper datalistClearButton" title="Clear all"><span class="ng-clear" (click)="resetCompanyNameFields()" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (resetCompanyNameFields())">×</span></span>
        </div>
      </section>
    </div>

    <div class="modal-footer border-0">
      <section class="bg-white no-shadow m-0">
        <button type="button" class="btn btn-custom btn-link" data-dismiss="modal"> Cancel </button>

          <button class="btn btn-custom btn-blue float-right mr-2 mb-4" style="border-radius: 0 0.25rem 0.25rem 0;"> Send to Approver</button>
          <button class="btn btn-custom btn-blue float-right pr-0" style="border-radius: 0.25rem 0 0 0.25rem;">
            <mat-icon svgIcon="mail" class="img-btn img-btn-lg" alt=""></mat-icon>
          </button>

      </section>
    </div>
  </div>
</div>
</div>



<div class="modal fade"  id="addqualiferSiteModalPopup" tabindex="-1" aria-modal="true" aria-labelledby="addqualiferSiteModalPopupLabel" aria-hidden="true">
<div class="modal-dialog modal-custom">
<div class="modal-content">
  <div class="modal-header border-0">
    <h6 class="modal-title font-weight-bold text-center" id="addqualiferSiteModalPopupLabel">
      Add Qualifier to Site
      <button type="button" class="close" id="closeQSBtn" #closeBtn data-dismiss="modal" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </h6>
  </div>

  <div class="modal-body">
    <section class="row m-0 bg-white no-shadow">
      <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
        <mat-label class="label-control">Type<span class="element_astrick">*</span>
        </mat-label>
        <div>
          <mat-select class="form-control form-control-sm" name="type"  [(ngModel)]="selectedQualifierVal" (ngModelChange)="qualifierTypeChange()" panelClass="dropdown-panel" [disableOptionCentering]="true">
            <mat-select-trigger >
              <mat-icon class="mat-icon-rtl-mirror" [svgIcon]="selectedQualifierVal=='B2b' ? 'B2bn' : selectedQualifierVal" class="mat-icon-rtl-mirror" style="height:15px !important"></mat-icon>
              <span class="pl-2">{{selectedQualifierVal=='B2b' ? qualifierTypesText['P18'] : qualifierTypesText[selectedQualifierVal]}}</span>
            </mat-select-trigger>
           <mat-option [disabled]="mainEntranceExists==true" value="P14">
              <mat-icon svgIcon="P14" class="mat-icon-rtl-mirror"></mat-icon>
              {{qualifierTypesText['P14']}}
            </mat-option>
            <mat-option *ngIf="roleVariableHide" value="B2b">
              <mat-icon svgIcon="B2bn" class="mat-icon-rtl-mirror"></mat-icon>
              {{qualifierTypesText['P18']}}
            </mat-option>

            <mat-option value="P11">
              <mat-icon svgIcon="P11" class="mat-icon-rtl-mirror"></mat-icon>
              {{qualifierTypesText['P11']}}
            </mat-option>
            <mat-option value="P13" *ngIf="showForSupplier==true">
              <mat-icon svgIcon="P13" class="mat-icon-rtl-mirror"></mat-icon>
              {{qualifierTypesText['P13']}}
            </mat-option>
            <mat-option value="P05">
              <mat-icon svgIcon="P05" class="mat-icon-rtl-mirror"></mat-icon>
              {{qualifierTypesText['P05']}}
            </mat-option>
            <mat-option *ngIf="superUserShow" value="P19">
              <mat-icon svgIcon="P19" class="mat-icon-rtl-mirror"></mat-icon>
              {{qualifierTypesText['P19']}}
            </mat-option>
            <mat-option value="P07">
              <mat-icon svgIcon="P07" class="mat-icon-rtl-mirror"></mat-icon>
              {{qualifierTypesText['P07']}}
            </mat-option>
            <mat-option *ngIf="superUserShow" value="P09">
              <mat-icon svgIcon="P09" class="mat-icon-rtl-mirror"></mat-icon>
              {{qualifierTypesText['P09']}}
            </mat-option>
            <mat-option *ngIf="roleVariableHide || showForSupplier==false || superUserShow" value="P06">
              <mat-icon svgIcon="P06" class="mat-icon-rtl-mirror"></mat-icon>
              {{qualifierTypesText['P06']}}
            </mat-option>
            <mat-option *ngIf="superUserShow" value="P08">
              <mat-icon svgIcon="P08" class="mat-icon-rtl-mirror"></mat-icon>
              {{qualifierTypesText['P08']}}
            </mat-option>
          </mat-select>
        <span style="color: #cb4b32;" *ngIf="qualiferSiteTypeModelErrorUp==true">Please select Type</span>
        </div>
      </div>

      <div class="form-group col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 pt-4" *ngIf='roleVariableHide==true && showSearCodeSwitch==true'>
        <span class="font-weight-bold">SAER
        </span>
        <label class="switch m-0">
          <input type="checkbox" id="sliderCheckBox1" (change)="toggleSaerCodeDisp('SAER')" [(ngModel)]="saerswitch" title="SAER_Code">
          <span class="slider round"></span>
        </label>
      </div>
      <div class="form-group col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6" *ngIf="(superUserShow==true || roleVariableHide==true)&& !saerswitch"></div>
      <div class="form-group col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6" *ngIf="(superUserShow==true || roleVariableHide==true) && saerswitch">
        <mat-label class="label-control">Code
        </mat-label>
        <div>
          <input style="padding-right: 2px;" maxlength="8" class="form-control form-control-sm form-control-paddings" [(ngModel)]="saerCodeModel" type="text"/>
          <span class="ng-clear-wrapper datalistClearButton" title="Clear all"><span class="ng-clear" style="background-color: #fff;" (click)="upresetAddQualifierSiteFields('saerCodeModel')" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (upresetAddQualifierSiteFields('saerCodeModel'))">×</span></span>
          <span style="color: #cb4b32;" *ngIf="saerCodeModelError==true">Enter 8 Digit Numerical value</span>
          <span style="color: #cb4b32;" *ngIf="saerNotUniqueError==true">SAER code must be unique!!!</span>
        </div>

        <mat-label class="label-control">Name
        </mat-label>
        <div>
          <input style="padding-right: 2px;" maxlength="10" class="form-control form-control-sm form-control-paddings" [(ngModel)]="saerNameModel"  (ngModelChange)="saerNameModel = $event.toUpperCase()" type="text"/>
          <span class="ng-clear-wrapper datalistClearButton" title="Clear all"><span class="ng-clear" style="background-color: #fff;" (click)="upresetAddQualifierSiteFields('saerNameModel')" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (upresetAddQualifierSiteFields('saerNameModel'))">×</span></span>
        </div>
      </div>

      <div class="form-group col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 pt-4" *ngIf='roleVariableHide==true && showLatamCodeSwitch==true'>
        <span class="font-weight-bold">LATAM
        </span>
        <label class="switch m-0">
          <input type="checkbox" id="sliderCheckBox3" (change)="toggleSaerCodeDisp('LATAM')" [(ngModel)]="latamswitch" title="LATAM_Code">
          <span class="slider round"></span>
        </label>
      </div>
      <div class="form-group col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6" *ngIf="(superUserShow==true || roleVariableHide==true) && !latamswitch"></div>
      <div class="form-group col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6" *ngIf="(superUserShow==true || roleVariableHide==true) && latamswitch">
        <mat-label class="label-control">Code
        </mat-label>
        <div>
          <input style="padding-right: 2px;" maxlength="10" class="form-control form-control-sm form-control-paddings" [(ngModel)]="latamCodeModel" type="text"/>
          <span class="ng-clear-wrapper datalistClearButton" title="Clear all"><span class="ng-clear" style="background-color: #fff;" (click)="upresetAddQualifierSiteFields('latamCodeModel')" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (upresetAddQualifierSiteFields('latamCodeModel'))">×</span></span>
          <span style="color: #cb4b32;" *ngIf="latamCodeModelError==true">Enter 10 Digit value</span>

        </div>

        <mat-label class="label-control">Name
        </mat-label>
        <div>
          <input style="padding-right: 2px;" class="form-control form-control-sm form-control-paddings" [(ngModel)]="latamNameModel"  (ngModelChange)="latamNameModel = $event.toUpperCase()" type="text"/>
          <span class="ng-clear-wrapper datalistClearButton" title="Clear all"><span class="ng-clear" style="background-color: #fff;" (click)="upresetAddQualifierSiteFields('latamNameModel')" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (upresetAddQualifierSiteFields('latamNameModel'))">×</span></span>
        </div>
      </div>

      <div class="form-group col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 pt-4" *ngIf='roleVariableHide==true && showRnaiplCodeSwitch==true'>
        <span class="font-weight-bold">RNAIPL
        </span>
        <label class="switch m-0">
          <input type="checkbox" id="sliderCheckBoxRnaipl" (change)="toggleSaerCodeDisp('RNAIPL')" [(ngModel)]="rnaiplswitch" title="RNAIPL_Code">
          <span class="slider round"></span>
        </label>
      </div>
      <div class="form-group col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6" *ngIf="(superUserShow==true || roleVariableHide==true) && !rnaiplswitch"></div>
      <div class="form-group col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6" *ngIf="(superUserShow==true || roleVariableHide==true) && rnaiplswitch">
        <mat-label class="label-control">Code
        </mat-label>
        <div>
          <input style="padding-right: 2px;" minlength="2" maxlength="6" pattern="[A-Za-z0-9]{2,6}" class="form-control form-control-sm form-control-paddings" [(ngModel)]="rnaiplCodeModel" (ngModelChange)="rnaiplCodeModel = $event.toUpperCase()" type="text"/>
          <span class="ng-clear-wrapper datalistClearButton" title="Clear all"><span class="ng-clear" style="background-color: #fff;" (click)="upresetAddQualifierSiteFields('rnaiplCodeModel')" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (upresetAddQualifierSiteFields('rnaiplCodeModel'))">×</span></span>
          <span style="color: #cb4b32;" *ngIf="rnaiplCodeModelError==true">Enter 2-6 alphanumeric characters</span>
        </div>

        <mat-label class="label-control">Name
        </mat-label>
        <div>
          <input style="padding-right: 2px;" maxlength="10" class="form-control form-control-sm form-control-paddings" [(ngModel)]="rnaiplNameModel" (ngModelChange)="rnaiplNameModel = $event.toUpperCase()" type="text"/>
          <span class="ng-clear-wrapper datalistClearButton" title="Clear all"><span class="ng-clear" style="background-color: #fff;" (click)="upresetAddQualifierSiteFields('rnaiplNameModel')" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (upresetAddQualifierSiteFields('rnaiplNameModel'))">×</span></span>
        </div>
      </div>

      <div class="form-group col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 pt-4" *ngIf="roleVariableHide && showSearCodeSwitch">
        <span class="font-weight-bold">C2B
        </span>
        <label class="switch m-0">
          <input type="checkbox" id="sliderCheckBox2" (change)="toggleSaerCodeDisp('C2B')" title="C2B_Code">
          <span class="slider round"></span>
        </label>
      </div>

     <div class="form-group col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6" *ngIf="showC2BFields">
        <mat-label class="label-control">Code</mat-label>
        <div>
          <input style="padding-right: 2px;" maxlength="10" class="form-control form-control-sm form-control-paddings" [(ngModel)]="c2bNameModel" (ngModelChange)="checkvalidatec2b($event)" type="text"
          title="Only letters S, U, P and digits 0-9 are allowed"/>
          <span class="ng-clear-wrapper datalistClearButton" title="Clear all">
            <span class="ng-clear" style="background-color: #fff;" (click)="upresetAddQualifierSiteFields('c2bNameModel')" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (upresetAddQualifierSiteFields('c2bNameModel'))">×</span>
          </span>
          <div *ngIf="c2bNameModelError != ''" class="text-danger">
            {{c2bNameModelError}}
          </div>
        </div>
      </div>


      <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
        <mat-label class="label-control">Name
        </mat-label>
        <div>
          <input style="padding-right: 2px;" class="form-control form-control-sm form-control-paddings" [(ngModel)]="qualiferSiteNameModelUp" type="text"/>
          <span class="ng-clear-wrapper datalistClearButton" title="Clear all"><span class="ng-clear" style="background-color: #fff;"  (click)="upresetAddQualifierSiteFields('qualiferSiteNameModelUp')" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (upresetAddQualifierSiteFields('qualiferSiteNameModelUp'))">×</span></span>
        </div>
      </div>

      <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12" *ngFor="let addressVals of newData;let i = index">
        <div class="row">
          <div class="form-group col col-12 col-sm-1 col-md-1 col-lg-1 col-xl-1">
            <span *ngIf="addressVals.addressEditRowIdForGPS;else templatA">
              <input style="width: 1.2rem;height: 1.2rem;"  value="{{addressVals.addressEditRowIdForGPS}}" class="edit" type="radio" [(ngModel)]="addressRadioval" (click)="toggleForNewAddress()" id="addressRadiovalBtn[{{i}}]"/>
            </span>
            <ng-template #templatA>
              <span *ngIf="addressVals.addressEditRowId">
                <input style="width: 1.2rem;height: 1.2rem;"  value="{{addressVals.addressEditRowId}}" class="edit" type="radio" [(ngModel)]="addressRadioval" (click)="toggleForNewAddress()" id="addressRadiovalBtn[{{i}}]"/>
              </span>
            </ng-template>
          </div>

        <div class="form-group col col-12 col-sm-11 col-md-11 col-lg-11 col-xl-11">
          <P class="mb-2">
          <span *ngIf="addressVals['wayNumber']">
            {{addressVals['wayNumber']}}
          </span>
          <span class="pl-1" *ngIf="addressVals['streetName']">
            {{addressVals['streetName']}}
          </span>
          </P>
          <P class="mb-2" *ngIf="addressVals['additionalInformation1']">
          <span class="font-weight-bold">
            {{addressVals['additionalInformation1']}}
          </span>
          </P>
          <P class="mb-2" *ngIf="addressVals['additionalInformation2']">
          <span class="font-weight-bold">
            {{addressVals['additionalInformation2']}}
          </span>
          </P>
          <P class="mb-2">
          <span class="font-weight-bold">Postal Code : </span>
          <span class="pl-1">
            {{addressVals['postalCode'] ? addressVals['postalCode'] : '-'}}
          </span>
          </P>
          <P class="mb-2">
          <span class="font-weight-bold">Territorial Division: </span>
          <span class="pl-1">
            {{addressVals['territorialDivision'] ? addressVals['territorialDivision'] : '-'}}
          </span>
          </P>
          <P class="mb-2">
          <span class="font-weight-bold">GPS: </span>
          <span class="font-weight-bold label-darkblue" *ngIf="addressVals['gpsDataLat']">
            {{addressVals['gpsDataLat']}},
          </span>
          <span class="pl-1 font-weight-bold label-darkblue" *ngIf="addressVals['gpsDataLon']">
            {{addressVals['gpsDataLon']}}
          </span>
          </P>
        </div>
        </div>
      </div>
      <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
        <span style="color: #cb4b32;" *ngIf="radioNotChecked==true">Please Select Address or Add new address!</span>
      </div>

      <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
        <div class="row">
        <div class="form-group col col-12 col-sm-1 col-md-1 col-lg-1 col-xl-1">
          <span>
          <input style="width: 1.2rem;height: 1.2rem;" class="edit" type="radio" id="AddNewAddressRadio" (click)="toggleForNewAddress()">
          </span>
        </div>
        <div class="form-group col col-12 col-sm-11 col-md-11 col-lg-11 col-xl-11">
          <span class=" font-weight-bold">NEW ADDRESS
          </span>
        </div>
        </div>
      </div>
      <div *ngIf="AddNewAddress==true" class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
        <div class="row">
        <div class="form-group col col-12 col-sm-3 col-md-3 col-lg-3 col-xl-3">
          <mat-label class="label-control">N°
          </mat-label>
          <div>
          <input
          style="padding-right: 2px;"
          class="form-control form-control-sm form-control-paddings"
          [(ngModel)]="wayNumberModelQualifierEdit" 
          type="text"
          (keyup)="checkForRegExAddressAdd($event,wayNumberModelQualifierEdit,'wayNumberModelQualifierEdit')"
          (ngModelChange)="wayNumberModelQualifierEdit = $event.toUpperCase()"
          maxlength="9"/>
          <span class="ng-clear-wrapper datalistClearButton" title="Clear all"><span class="ng-clear" style="background-color: #fff;" (click)="upresetAddQualifierSiteFields('wayNumberModelQualifierEdit')" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (upresetAddQualifierSiteFields('wayNumberModelQualifierEdit'))">×</span></span>
          <span style="color: #cb4b32;" *ngIf="wayNumberModelQualifierEditRegExError==true">A-Z 0-9 space () . , - /</span>
          </div>
        </div>
        <div class="form-group col col-12 col-sm-9 col-md-9 col-lg-9 col-xl-9">
          <mat-label class="label-control">Street<span class="element_astrick">*</span>
          </mat-label>
          <div>
          <input
          style="padding-right: 2px;"
          class="form-control form-control-sm form-control-paddings"
          [(ngModel)]="qualiferSiteStreetModelUp" 
          type="text"
          (keyup)="checkForRegExAddressAdd($event,qualiferSiteStreetModelUp,'qualiferSiteStreetModelUp')"
          (ngModelChange)="qualiferSiteStreetModelUp = $event.toUpperCase()"
          maxlength="35"/>
          <span class="ng-clear-wrapper datalistClearButton" title="Clear all"><span class="ng-clear" style="background-color: #fff;"  (click)="upresetAddQualifierSiteFields('qualiferSiteStreetModelUp')" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (upresetAddQualifierSiteFields('qualiferSiteStreetModelUp'))">×</span></span>
          <span style="color: #cb4b32;" *ngIf="qualiferSiteStreetModelErrorUp==true">Please enter street</span>
          <span style="color: #cb4b32;" *ngIf="qualiferSiteStreetModelUpRegExError==true">A-Z 0-9 space () . , - /</span>
          </div>
        </div>
        </div>

        <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 p-0">
        <mat-label class="label-control">Additional Address information
        </mat-label>
        <div class="mb-2">
          <input style="padding-right: 2px;"
          class="form-control form-control-sm form-control-paddings"
          [(ngModel)]="qualiferSiteAdditionalAddress" 
          (ngModelChange)="qualiferSiteAdditionalAddress = $event.toUpperCase()"
          (keyup)="checkForRegExAddressAdd($event,qualiferSiteAdditionalAddress,'qualiferSiteAdditionalAddress')"
          maxlength="35"
          type="text"/>
          <span class="ng-clear-wrapper datalistClearButton" title="Clear all">
          <span class="ng-clear" style="background-color: #fff;" (click)="upresetAddQualifierSiteFields('qualiferSiteAdditionalAddress')" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (upresetAddQualifierSiteFields('qualiferSiteAdditionalAddress'))">×</span></span>
          <span style="color: #cb4b32;" *ngIf="qualiferSiteAdditionalAddressRegExError==true">A-Z 0-9 space () . , - /</span>
        </div>
        <div>
          <input style="padding-right: 2px;"
          class="form-control form-control-sm form-control-paddings"
          [(ngModel)]="qualiferSiteAdditionalAddressInfo" 
          maxlength="35"
          type="text"
          (ngModelChange)="qualiferSiteAdditionalAddressInfo = $event.toUpperCase()"
          (keyup)="checkForRegExAddressAdd($event,qualiferSiteAdditionalAddressInfo,'qualiferSiteAdditionalAddressInfo')" />
          <span class="ng-clear-wrapper datalistClearButton" title="Clear all">
          <span class="ng-clear" style="background-color: #fff;" (click)="upresetAddQualifierSiteFields('qualiferSiteAdditionalAddressInfo')" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (upresetAddQualifierSiteFields('qualiferSiteAdditionalAddressInfo'))">×</span></span>
          <span style="color: #cb4b32;" *ngIf="qualiferSiteAdditionalAddressInfoRegExError==true">A-Z 0-9 space () . , - /</span>
        </div>
        </div>

        <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 p-0">
        <mat-label class="label-control">City Postal Code
        </mat-label>
        <div>
          <input
          style="padding-right: 2px;"
          class="form-control form-control-sm form-control-paddings"
          (keyup)="checkForRegExAddressAdd($event,postalCodeModel,'postalCodeModel')"
          [(ngModel)]="postalCodeModel" 
          (ngModelChange)="postalCodeModel = $event.toUpperCase()"
          type="text"
          maxlength="9"/>
          <span class="ng-clear-wrapper datalistClearButton" title="Clear all"><span class="ng-clear" style="background-color: #fff;" (click)="upresetAddQualifierSiteFields('postalCodeModel')" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (upresetAddQualifierSiteFields('postalCodeModel'))">×</span></span>
          <span style="color: #cb4b32;" *ngIf="postalCodeModelRegExError==true">A-Z 0-9 space () . , - /</span>
        </div>
        </div>

        <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 p-0">
        <mat-label class="label-control">Territorial Division
        </mat-label>
        <div>
          <input
          style="padding-right: 2px;"
          class="form-control form-control-sm form-control-paddings"
          (keyup)="checkForRegExAddressAdd($event,territorialDivModelQualifierEdit,'territorialDivModelQualifierEdit')"
          [(ngModel)]="territorialDivModelQualifierEdit" 
          type="text"
          (ngModelChange)="territorialDivModelQualifierEdit = $event.toUpperCase()"
          maxlength="35"/>
          <span class="ng-clear-wrapper datalistClearButton" title="Clear all"><span class="ng-clear" style="background-color: #fff;" (click)="upresetAddQualifierSiteFields('territorialDivModelQualifierEdit')" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (upresetAddQualifierSiteFields('territorialDivModelQualifierEdit'))">×</span></span>
          <span style="color: #cb4b32;" *ngIf="territorialDivModelQualifierEditRegExError==true">A-Z 0-9 space () . , - /</span>
        </div>
        </div>
        <section class="row m-0 bg-white no-shadow">
          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 p-0">
            <mat-label class="label-control">Latitude :</mat-label>
            <p style="position: relative;padding: 0;">
              <span style="width: 18%;display: inline-block;">
                <input id="latitude_degres" type="text" (keyup)="dmsversddanotheraddress()" class="form-control form-control-sm form-control-paddings pr-1" [(ngModel)]="latDegVal">

              </span>
              <mat-label class="font-weight-bold" style="position: absolute;top: 0;" for="latitude_degres">&deg;</mat-label>&nbsp;
              <span style="width: 18%;display: inline-block;">
                <input id="latitude_minutes" type="text" (keyup)="dmsversddanotheraddress()" class="form-control form-control-sm form-control-paddings pr-1" [(ngModel)]="latMinVal">

              </span>
              <mat-label class="font-weight-bold" style="position: absolute;top: 0;" for="latitude_minutes">'</mat-label>&nbsp;
              <span style="width: 35%;display: inline-block;">
                <input id="latitude_secondes" type="text" (keyup)="dmsversddanotheraddress()" class="form-control form-control-sm form-control-paddings pr-1" [(ngModel)]="latSecVal">

              </span>
              <mat-label class="font-weight-bold" style="position: absolute;top: 0;" for="latitude_secondes">''</mat-label>&nbsp;
              <span style="width: 17%;display: inline-block;">
              <mat-select class="form-control form-control-sm p-0 dropdown-select" [(ngModel)]="northSouthModel" (ngModelChange)="dmsversddanotheraddress()" panelClass="dropdown-panel" [disableOptionCentering]="true">
                  <mat-option value="North">N</mat-option>
                  <mat-option value="South">S</mat-option>
              </mat-select>
              </span>
            </p>
          </div>
          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 pr-0">
            <mat-label class="label-control">Longitude :</mat-label>
            <p style="position: relative;padding: 0;">
              <span style="width: 18%;display: inline-block;">
                <input id="longitude_degres" type="text" (keyup)="dmsversddanotheraddress()" class="form-control form-control-sm form-control-paddings pr-1" [(ngModel)]="longDegVal">

              </span>
              <mat-label class="font-weight-bold" style="position: absolute;top: 0;" for="longitude_degres">&deg;</mat-label>&nbsp;
              <span style="width: 18%;display: inline-block;">
                <input id="longitude_minutes" type="text" (keyup)="dmsversddanotheraddress()" class="form-control form-control-sm form-control-paddings pr-1" [(ngModel)]="longMinVal">

              </span>
              <mat-label class="font-weight-bold" style="position: absolute;top: 0;" for="longitude_minutes">'</mat-label>&nbsp;
              <span style="width: 35%;display: inline-block;">
                <input id="longitude_secondes" type="text" (keyup)="dmsversddanotheraddress()" class="form-control form-control-sm form-control-paddings pr-1" [(ngModel)]="longSecVal">

              </span>
              <mat-label class="font-weight-bold" style="position: absolute;top: 0;" for="longitude_secondes">''</mat-label>&nbsp;
              <span style="width: 17%;display: inline-block;">
              <mat-select class="form-control form-control-sm p-0 dropdown-select"  [(ngModel)]="eastWestModel" (ngModelChange)="dmsversddanotheraddress()" panelClass="dropdown-panel" [disableOptionCentering]="true">
                  <mat-option value="East">E</mat-option>
                  <mat-option value="West">W</mat-option>
              </mat-select>
              </span>
            </p>
          </div>
       </section>

        <div class="row">
        <div class="form-group col col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
          <mat-label class="label-control">Latitude
          </mat-label>
          <div>
          <input style="padding-right: 2px;" class="form-control form-control-sm form-control-paddings"  (keyup)="ddversdmsanotheraddress()" [(ngModel)]="gpsValueModelLat" type="text"/>
          <span class="ng-clear-wrapper datalistClearButton" title="Clear all"><span class="ng-clear" style="background-color: #fff;" (click)="upresetAddQualifierSiteFields('gpsValueModelLat')" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (upresetAddQualifierSiteFields('gpsValueModelLat'))">×</span></span>
          </div>
        </div>

        <div class="form-group col col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 p-0">
          <mat-label class="label-control">Longitude
          </mat-label>
          <div>
          <input style="padding-right: 2px;" class="form-control form-control-sm form-control-paddings" (keyup)="ddversdmsanotheraddress()"  [(ngModel)]="gpsValueModelLon" type="text"/>
          <span class="ng-clear-wrapper datalistClearButton" title="Clear all"><span class="ng-clear" style="background-color: #fff;" (click)="upresetAddQualifierSiteFields('gpsValueModelLon')" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (upresetAddQualifierSiteFields('gpsValueModelLon'))">×</span></span>
          </div>
        </div>
        </div>
      </div>
    </section>
  </div>

  <div class="modal-footer border-0">
    <section class="bg-white no-shadow m-0" style="width: 100%;">
      <button type="button"  class="btn btn-custom btn-blue" (click)="copyGpsdata('gpslat')" *ngIf="AddNewAddress==true && roleVariableHide ==true && gpsValueModelLat=='' && gpsValueModelLon==''" >
        Copy city Gps data
      </button>
    <div style="float: right;">
      <button type="button" class="btn btn-custom btn-link" data-dismiss="modal"> Cancel </button>
      <button type="button" class="btn btn-custom btn-custom-sm btn-blue" (click)="AddQualifierDetails()" [disabled]="disableAddQualifierToSite==true">
        <mat-icon svgIcon="mail" class="img-btn mr-2"></mat-icon><span class="float-right">{{saveDatas}}</span>
      </button>
  </div>
 </section>

  </div>
</div>
</div>
</div>







<!-- <div class="modal fade mt-4" id="dispMatGroupHomo" tabindex="-1" aria-modal="true" aria-labelledby="dispMatGroupHomoLabel" aria-hidden="true">
<div class="modal-dialog modal-custom">
  <div class="modal-content" style="width: 920px;height:700px;margin-left: -30% !important;">
    <div class="modal-header border-0">
      <h6 class="modal-title font-weight-bold text-center" id="dispMatGroupHomoLabel">
        Material Group Homologation
        <button type="button" class="close" id="closeMatGroupHomo" #closeBtn data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </h6>
    </div>
    <div class="modal-title font-weight-bold ml-4 mt-3 mb-2">
      <div class="row">
        <div class="col col-12 col-sm-3 col-md-3 col-lg-6 col-xl-6" > <h6 class="font-weight-bold"><span class="label-darkblue">{{ selectedSaerCode ? selectedSaerCode : '' }}</span><span class="ml-4 mt-3 mb-2">{{selectedLabel ? selectedLabel : ''}}</span></h6></div>
            <div class="col col-12 col-sm-3 col-md-3 col-lg-5 col-xl-5 text-right ml-5">
               <button type="button" *ngIf="roleVariableHide" class="btn btn-custom btn-blue float-right d-flex align-center Mgbtn" (click)="setMaterilGroupModalVals()" data-target="#openAddMaterialGroupModal" data-toggle="modal">
                  <mat-icon svgIcon="add" class="MGimg-btn"></mat-icon><span class="float-right"> Add Material Group By ADMIN </span>
                </button>
              </div>
            </div>
          </div>
    <div class="modal-body row m-0 p-0 table-responsive ">
      <table class="table m-0"  >
        <thead style="background-color: #F5F5F5;">
          <tr class="col p-0">
            <th class="sortDecorationunderline">Material Group</th>
            <th class="sortDecorationunderline">Description</th>
            <th class="sortDecorationunderline">Activity</th>
            <th class="sortDecorationunderline">Status/ Start Date</th>

          </tr>
        </thead>
        <tbody *ngIf="dataForMaterialGroup.length>0">
          <tr *ngFor="let dasd of dataForMaterialGroup; let i = index" class="col forColor p-0">
            <td class="col-12 col-md-2 col-lg-1 col-xl-1 col-sm-6 tdCustom font-weight-bold">{{dasd.code}}</td>
            <td class="col-12 col-md-6 col-lg-8 col-xl-8 col-sm-6 tdCustom font-weight-bold"><p style="margin:0"><span style="font-weight: bolder;vertical-align: middle;margin:0">{{dasd.label}}</span></p><p style="margin:0"> <span style="font-size: 11px;align-items: center;margin:0">{{dasd.description}}</span></p></td>
            <td class="col-12 col-md-1 col-lg-1 col-xl-1 col-sm-6 tdCustom font-weight-bold" ><span title="{{ActivityList[ACPdataForMaterialGroup[dasd.code].activity]}}">{{ACPdataForMaterialGroup[dasd.code].activity}}</span>
            <span class="pl-1" *ngIf="roleVariableHide" >
                <mat-icon class="edit" svgIcon="edit" alt="edit" data-toggle="modal" data-target="#activityEditPopup" (click)="setActivityValue(ACPdataForMaterialGroup[dasd.code].activity,ACPdataForMaterialGroup[dasd.code].rowId)" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (setActivityValue(ACPdataForMaterialGroup[dasd.code].activity,ACPdataForMaterialGroup[dasd.code].rowId))"></mat-icon>
            </span></td>

            <td class="col-12 col-md-1 col-lg-1 col-xl-1 col-sm-6 tdCustom font-weight-bold">

              <div class="m-0 d-flex">
              <span class="group-status pl-1 pr-1 py-1" style="min-width: 60px; font-size:10px ;" [ngStyle]="{'background' : colorStatus[ACPdataForMaterialGroup[dasd.code].status.toLowerCase()]}">
                {{ACPdataForMaterialGroup[dasd.code]?.status ? ACPdataForMaterialGroup[dasd.code].status : '-'}}
                </span>
                <span class="pl-1" *ngIf="roleVariableHide">
                  <mat-icon class="edit" svgIcon="edit" alt="edit" data-toggle="modal" data-target="#statusEditPopup" (click)="setStatus(ACPdataForMaterialGroup[dasd.code].status,ACPdataForMaterialGroup[dasd.code].rowId)" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (setStatus(ACPdataForMaterialGroup[dasd.code].status,ACPdataForMaterialGroup[dasd.code].rowId))"></mat-icon>
                </span>
                </div>
                <span>{{ACPdataForMaterialGroup[dasd.code].effectiveDate}}</span>

               </td>

          </tr>
        </tbody>
        <tbody *ngIf="dataForMaterialGroup.length==0">
          <tr>
            <td colspan="7" class="font-weight-bold text-darkblue text-center">No Results</td>
          </tr>
        </tbody>

   <ng-container *ngIf="MaterialGroupLoading">
              <div class="local-loading-overlay">
                <div class="custom-spinner-template">
                  <mat-spinner class="custom-spinner black-spinner" diameter="40"></mat-spinner>
                </div>
              </div>
            </ng-container>

        <tfoot style="position: sticky; bottom: 0; background-color: #F5F5F5;">
              <tr>
                <td colspan="8" style="padding: 0px;">
                  <ul *ngIf="pager.pages && pager.pages.length" class="pagination">
                    <li [ngClass]="{disabled:pager.currentPage === 1}">
                        <a (click)="loadMaterialGrpHomologation('','',1)" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (loadMaterialGrpHomologation('','',1))">First</a>
                    </li>
                    <li [ngClass]="{disabled:pager.currentPage === 1}">
                        <a (click)="loadMaterialGrpHomologation('','',pager.currentPage - 1)" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (loadMaterialGrpHomologation('','',pager.currentPage - 1))">Previous</a>
                    </li>
                    <li *ngFor="let page of pager.pages" [ngClass]="{active:pager.currentPage === page}">
                        <a (click)="loadMaterialGrpHomologation('','',page)" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (loadMaterialGrpHomologation('','',page))">{{page}}</a>
                    </li>
                    <li [ngClass]="{disabled:pager.currentPage === pager.totalPages}">
                        <a (click)="loadMaterialGrpHomologation('','',pager.currentPage + 1)" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (loadMaterialGrpHomologation('','',pager.currentPage + 1))">Next</a>
                    </li>
                    <li [ngClass]="{disabled:pager.currentPage === pager.totalPages}">
                        <a (click)="loadMaterialGrpHomologation('','',pager.totalPages)" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (loadMaterialGrpHomologation('','',pager.totalPages))">Last</a>
                    </li>
                  </ul>
                </td>
              </tr>
        </tfoot>
      </table>
    </div>
    <div class="modal-footer border-0 row">
      <section class="bg-white no-shadow m-0 row">

        <button type="button" class="btn btn-custom btn-blue btn-lg grpBtn" data-dismiss="modal" id="closeMatGroupHomo__2">
          Close
        </button>
      </section>
    </div>
  </div>
</div>
</div> -->


<div class="modal fade"  id="activityEditPopup" tabindex="-2" aria-modal="true" aria-labelledby="activityEditPopupLabel" aria-hidden="true">
<div class="modal-dialog modal-custom">
  <div class="modal-content">
    <div class="modal-header border-0">
      <h6 class="modal-title font-weight-bold text-center" id="activityEditPopupLabel">
       Edit Material Group Activity
        <button type="button" class="close" id="closeActivitymodal" #closeBtn data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </h6>
    </div>

    <div class="modal-body">
      <section class="row m-0 bg-white no-shadow">
        <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <mat-label class="label-control">Activity
          </mat-label>
            <mat-select class="form-control form-control-sm"  [(ngModel)]="activityValue" panelClass="dropdown-panel" [disableOptionCentering]="true">
              <mat-option *ngFor="let activity of activityValueOption" [value]="activity.code">{{activity.code}} - {{activity.name}}</mat-option>
            </mat-select>
          <span style="color: #cb4b32;" *ngIf="activityValueError==true">Please select Activity!!!</span>
        </div>
      </section>
    </div>

    <div class="modal-footer border-0">
      <section class="bg-white no-shadow m-0">
        <button type="button" class="btn btn-custom btn-link" data-dismiss="modal"> Cancel </button>
        <button type="button" class="btn btn-custom btn-custom-sm btn-blue" (click)="updateActivityValue()" [disabled]="activityValueBtn==true">
          <mat-icon svgIcon="mail" class="img-btn mr-2"></mat-icon><span class="float-right">{{saveDatas}}</span>
        </button>
      </section>
    </div>
  </div>
</div>
</div>

<div class="modal fade"  id="statusEditPopup" tabindex="-2" aria-modal="true" aria-labelledby="statusEditPopupLabel" aria-hidden="true">
<div class="modal-dialog modal-custom">
  <div class="modal-content">
    <div class="modal-header border-0">
      <h6 class="modal-title font-weight-bold text-center" id="statusEditPopupLabel">
       Edit Material Group Activity
        <button type="button" class="close" id="closestatusmodal" #closeBtn data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </h6>
    </div>

    <div class="modal-body">
      <section class="row m-0 bg-white no-shadow">
        <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <mat-label class="label-control">Material Group Status
          </mat-label>
            <mat-select class="form-control form-control-sm"  [(ngModel)]="statusData" panelClass="dropdown-panel" [disableOptionCentering]="true">
              <mat-option value=""></mat-option>
              <mat-option *ngFor="let statusValue of statusOption" [value]="statusValue">{{statusValue}}</mat-option>
            </mat-select>
          <span style="color: #cb4b32;" *ngIf="statusError==true">Please select Status!!!</span>
        </div>
      </section>
    </div>

    <div class="modal-footer border-0">
      <section class="bg-white no-shadow m-0">
        <button type="button" class="btn btn-custom btn-link" data-dismiss="modal"> Cancel </button>
        <button type="button" class="btn btn-custom btn-custom-sm btn-blue" (click)="updateStatus()" [disabled]="statusBtn==true">
          <mat-icon svgIcon="mail" class="img-btn mr-2"></mat-icon><span class="float-right">{{saveDatas}}</span>
        </button>
      </section>
    </div>
  </div>
</div>
</div>


<div class="modal fade"  id="siteQualifierStatusModalPopup" tabindex="-1" aria-modal="true" aria-labelledby="siteQualifierStatusModalPopupLabel" aria-hidden="true">
<div class="modal-dialog modal-custom">
 <div class="modal-content">
   <div class="modal-header border-0">
     <h6 class="modal-title font-weight-bold text-center" id="siteQualifierStatusModalPopupLabel">
      Edit Qualifier status by <span class="label-darkblue">ADMIN</span>
       <button type="button" class="close" id="closeQASBtn" #closeBtn data-dismiss="modal" aria-label="Close">
         <span aria-hidden="true">&times;</span>
       </button>
     </h6>
   </div>

   <div class="modal-body">
     <section class="row m-0 bg-white no-shadow">
       <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
         <mat-label class="label-control">Qualifier Status
         </mat-label>
           <mat-select class="form-control form-control-sm"  [(ngModel)]="qualifierAliasStatusModelvalUp" panelClass="dropdown-panel" [disableOptionCentering]="true">
             <mat-option *ngFor="let status of qualifierOption" [value]="status">{{status}}</mat-option>
           </mat-select>
         <span style="color: #cb4b32;" *ngIf="qualifierAliasStatusModelError==true">Please select status!!!</span>
       </div>

     </section>
   </div>

   <div class="modal-footer border-0">
     <section class="bg-white no-shadow m-0">
       <button type="button" class="btn btn-custom btn-link" data-dismiss="modal"> Cancel </button>
       <button type="button" class="btn btn-custom btn-custom-sm btn-blue" (click)="updateQualifierStatus()" [disabled]="disableEditQuaSiteStatusBtn==true">
        <mat-icon svgIcon="mail" class="img-btn mr-2"></mat-icon><span class="float-right">{{saveDatas}}</span>
       </button>
     </section>
   </div>
 </div>
</div>
</div>


<div class="modal fade"  id="siteQualifierc2bModalPopup" tabindex="-1" aria-modal="true" aria-labelledby="siteQualifierc2bModalPopupLabel">
  <div class="modal-dialog modal-custom">
   <div class="modal-content">
     <div class="modal-header border-0">
       <h6 class="modal-title font-weight-bold text-center" id="siteQualifierc2bModalPopupLabel">
        Edit C2B code by <span class="label-darkblue">ADMIN</span>
         <button type="button" class="close" id="closeC2bBtn" #closeBtn data-dismiss="modal" aria-label="Close">
           <span aria-hidden="true">&times;</span>
         </button>
       </h6>
     </div>

     <div class="modal-body">
       <section class="row m-0 bg-white no-shadow">
         <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
           <mat-label class="label-control">C2B Code
           </mat-label>
           <input style="padding-right: 2px" class="form-control form-control-sm form-control-paddings" maxlength="10" [(ngModel)]="editc2bAliasModel" (ngModelChange)="checkvalidatec2b($event,'edit')" type="text"/>
           <span class="ng-clear-wrapper datalistClearButton" title="Clear all"><span class="ng-clear" style="background-color: #fff;"  (click)="resetC2bAliasVal()" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (resetC2bAliasVal())">×</span></span>
           <span style="color: #cb4b32;" >{{c2bNameModelError}}</span>
         </div>
       </section>
     </div>

     <div class="modal-footer border-0">
       <section class="bg-white no-shadow m-0">
         <button type="button" class="btn btn-custom btn-link" data-dismiss="modal"> Cancel </button>
         <button type="button" class="btn btn-custom btn-custom-sm btn-blue" (click)="saveC2bAliasVal()" [disabled]="disableAddQualifierToSite==true">
          <mat-icon svgIcon="mail" class="img-btn mr-2"></mat-icon><span class="float-right">{{saveDatas}}</span>
         </button>
       </section>
     </div>
   </div>
  </div>
  </div>



<div class="modal fade"  id="siteQualifierNameModalPopup" tabindex="-1" aria-modal="true" aria-labelledby="siteQualifierNameModalPopupLabel" aria-hidden="true">
<div class="modal-dialog modal-custom">
 <div class="modal-content">
   <div class="modal-header border-0">
     <h6 class="modal-title font-weight-bold text-center" id="siteQualifierNameModalPopupLabel">
      Edit Qualifier Name
       <button type="button" class="close" id="closeQualifierNameEditBtn" #closeBtn data-dismiss="modal" aria-label="Close">
         <span aria-hidden="true">&times;</span>
       </button>
     </h6>
   </div>

   <div class="modal-body">
     <section class="row m-0 bg-white no-shadow">
       <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
         <mat-label class="label-control">Qualifier Name
         </mat-label>
           <input
            type="text"
            class="form-control form-control-sm form-control-paddings"
            [(ngModel)]="qualifierNameEdit"
            (keyup)="checkQualifierNameRegEx(qualifierNameEdit,'qualifierNameEdit','qualifierNameModelError','qualifierNameModelRegExError')"
            (ngModelChange)="qualifierNameEdit = $event.toUpperCase()"
            maxlength="35"/>
           <span class="ng-clear-wrapper datalistClearButton" title="Clear all"><span class="ng-clear" style="background-color: #fff;"  (click)="resetQualifierEdit()" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (resetQualifierEdit())">×</span></span>
         <span style="color: #cb4b32;" *ngIf="qualifierNameModelError==true">Please Enter Qualifier Name!!!</span>
         <span style="color: #cb4b32;" *ngIf="qualifierNameModelRegExError==true">A-Z 0-9 space () . , - /</span>
       </div>
     </section>
   </div>

   <div class="modal-footer border-0">
     <section class="bg-white no-shadow m-0">
       <button type="button" class="btn btn-custom btn-link" data-dismiss="modal"> Cancel </button>
       <button type="button" class="btn btn-custom btn-custom-sm btn-blue" (click)="updateQualifierName()" [disabled]="disableEditQuaNameBtn==true">
        <mat-icon svgIcon="mail" class="img-btn mr-2"></mat-icon><span class="float-right">{{saveDatas}}</span>
       </button>
     </section>
   </div>
 </div>
</div>
</div>


<div class="modal fade"  id="openEditBvdModal" tabindex="-1" aria-modal="true" aria-labelledby="openEditBvdModalLabel" aria-hidden="true">
<div class="modal-dialog modal-custom">
 <div class="modal-content">
   <div class="modal-header border-0">
     <h6 class="modal-title font-weight-bold text-center" id="openEditBvdModalLabel">
      Edit BVD ID by <span class="label-darkblue">ADMIN</span>
       <button type="button" class="close" id="closebvdmodal" #closeBtn data-dismiss="modal" aria-label="Close">
         <span aria-hidden="true">&times;</span>
       </button>
     </h6>
   </div>

   <div class="modal-body">
     <section class="row m-0 bg-white no-shadow">
       <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
         <mat-label class="label-control">BVD ID
         </mat-label>
          <input
            style="padding-right: 2px;"
            class="form-control form-control-sm form-control-paddings"
            [(ngModel)]="editBvdIdValueModel"
            type="text"
            (keyup)="checkForBvdId(editBvdIdValueModel,'editBvdIdValueModel','editBvdIdModalError')"
            (ngModelChange)="editBvdIdValueModel = $event.toUpperCase()" />
         <span class="ng-clear-wrapper datalistClearButton" title="Clear all"><span class="ng-clear" style="background-color: #fff;"  (click)="resetBvdId('bvdid')" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (resetBvdId('bvdid'))">×</span></span>
         <span style="color: #cb4b32;" *ngIf="editBvdIdModalError==true">Please Enter Bvd Id!!!</span>
       </div>
     </section>
   </div>

   <div class="modal-footer border-0">
     <section class="bg-white no-shadow m-0 w-100">
      <button type="button" style="background-color: #ec051d" class="btn btn-custom btn-custom-sm mr-1" (click)="openCnfArchiveModal('delete')">
        <mat-icon svgIcon="delete" class="mr-1 pb-1" alt="DEL"></mat-icon>
        <span class="float-right">
            Delete
        </span>
      </button>
      <button type="button" class="btn btn-custom btn-custom-sm btn-blue" (click)="openCnfArchiveModal('archive')" *ngIf="showArchivedBvdId==false">
             Archive
      </button>
      <button type="button" class="btn btn-custom btn-custom-sm btn-blue" (click)="openCnfArchiveModal('unarchive')" *ngIf="showArchivedBvdId==true">
        Unarchive
      </button>
      <article class="float-right">
       <button type="button" class="btn btn-custom btn-link" data-dismiss="modal"> Cancel </button>
       <button type="button" class="btn btn-custom btn-custom-sm btn-blue" [disabled]="disableSaveBvdBtn==true" (click)="saveBvdId()">
         <mat-icon svgIcon="mail" class="img-btn mr-2"></mat-icon><span class="float-right"> Save </span>
       </button>
      </article>
     </section>
   </div>
 </div>
</div>
</div>


<div class="modal fade mt-4" id="parentageStateModal" tabindex="-2" aria-modal="true" aria-labelledby="parentageStateModalLabel" aria-hidden="true">
<div class="modal-dialog modal-custom">
  <div class="modal-content" style="width: 800px;margin-left: -30% !important;">
    <div class="modal-header border-0">
      <h6 class="modal-title font-weight-bold text-center" id="parentageStateModalLabel">
        Parentage State
        <button type="button" class="close" id="closeGroupingState" #closeBtn data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </h6>
    </div>

    <div class="modal-title font-weight-bold ml-4 mt-3 mb-2"> <h6 class="font-weight-bold">Site name: <span class="label-darkblue">{{ siteName ? siteName : '' }}</span></h6></div>

    <div class="modal-body row m-0 p-0 table-responsive">
      <table class="table m-0">
        <thead style="background-color: #F5F5F5;">
          <tr class="col p-0">
            <th class="sortDecorationunderline" (click)="sort('legalName')" tabindex="0" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (sort('legalName'))">Company</th>
            <th class="sortDecorationunderline" (click)="sort('status')" tabindex="0" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (sort('status'))">Parentage status</th>
            <th class="sortDecorationunderline" (click)="sort('startDate')" tabindex="0" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (sort('startDate'))">Start Date</th>
            <th class="sortDecorationunderline" (click)="sort('endDate')" tabindex="0" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (sort('endDate'))">End Date</th>
          </tr>
        </thead>

        <tbody *ngIf="parentageOriData.length>0">
          <tr *ngFor="let da of parentageOriData | orderBy: key:reverse; let i = index" class="col forColor p-0">
              <td class="col-12 col-md-3 col-lg-3 col-xl-3 col-sm-6 tdCustom">{{da.legalName}}</td>
            <td class="col-12 col-md-3 col-lg-3 col-xl-3 col-sm-6 tdCustom">
              <span class= "group-status pl-4 pr-4" [ngStyle]="{'background':colorStatus[da.status.toLowerCase()]}">{{da.status}}</span>

            </td>
            <td class="col-12 col-md-3 col-lg-3 col-xl-3 col-sm-6 tdCustom">{{da.startDate ? da.startDate : '-'}}</td>
            <td class="col-12 col-md-3 col-lg-3 col-xl-3 col-sm-6 tdCustom">{{da.endDate ? da.endDate : '-'}}</td>
          </tr>
        </tbody>

        <tbody *ngIf="parentageOriData.length==0">
          <tr>
            <td colspan="7" class="font-weight-bold text-darkblue text-center"
              *ngIf="loadingQualifier==false">No Results</td>
          </tr>
        </tbody>


   <ng-container *ngIf="parentageLoading">
              <div class="local-loading-overlay">
                <div class="custom-spinner-template">
                  <mat-spinner class="custom-spinner black-spinner" diameter="40"></mat-spinner>
                </div>
              </div>
            </ng-container>

        <tfoot [hidden]=this.parentage>
              <tr>

                <td colspan="8"  style="background-color: #F5F5F5;padding: 0px;">

                  <ul *ngIf="parPager.pages && parPager.pages.length" class="pagination">
                    <li [ngClass]="{disabled:parPager.currentPage === 1}">
                        <a (click)="parentageTable(1)" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (parentageTable(1))">First</a>
                    </li>
                    <li [ngClass]="{disabled:parPager.currentPage === 1}">
                        <a (click)="parentageTable(parPager.currentPage - 1)" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (parentageTable(parPager.currentPage - 1))">Previous</a>
                    </li>
                    <li *ngFor="let page of parPager.pages" [ngClass]="{active:parPager.currentPage === page}">
                        <a (click)="parentageTable(page)" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (parentageTable(page))">{{page}}</a>
                    </li>
                    <li [ngClass]="{disabled:parPager.currentPage === parPager.totalPages}">
                        <a (click)="parentageTable(parPager.currentPage + 1)" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (parentageTable(parPager.currentPage + 1))">Next</a>
                    </li>
                    <li [ngClass]="{disabled:parPager.currentPage === parPager.totalPages}">
                        <a (click)="parentageTable(parPager.totalPages)" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (parentageTable(parPager.totalPages))">Last</a>
                    </li>
                  </ul>
                </td>
              </tr>
        </tfoot>
      </table>
    </div>

    <div class="modal-footer border-0 row">
      <section class="bg-white no-shadow m-0 row">
        <button type="button" class="btn btn-custom btn-blue btn-lg grpBtn" data-dismiss="modal" id="closeGroupingState__2">
          Close
        </button>
      </section>
    </div>
  </div>
</div>
</div>


<div class="modal fade"  id="openEditNameModal" tabindex="-1" aria-modal="true" aria-labelledby="openEditNameModalLabel" aria-hidden="true">
<div class="modal-dialog modal-custom">
 <div class="modal-content">
   <div class="modal-header border-0">
     <h6 class="modal-title font-weight-bold text-center" id="openEditNameModalLabel">
      Edit Site Name by <span class="label-darkblue">ADMIN</span>
       <button type="button" class="close" id="closeeditnamemodal" #closeBtn data-dismiss="modal" aria-label="Close">
         <span aria-hidden="true">&times;</span>
       </button>
     </h6>
   </div>

   <div class="modal-body">
     <section class="row m-0 bg-white no-shadow">
       <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
         <mat-label class="label-control">Site Name:
         </mat-label>
          <input
            style="padding-right: 2px;"
            class="form-control form-control-sm form-control-paddings"
            [(ngModel)]="editSiteNameValueModel"
            maxlength="100"
            type="text"
            (keyup)="checkQualifierNameRegEx(editSiteNameValueModel,'editSiteNameValueModel','editSiteNameModalError','editSiteNameModalRegExError')"
            (ngModelChange)="editSiteNameValueModel = $event.toUpperCase()" />
         <span class="ng-clear-wrapper datalistClearButton" title="Clear all"><span class="ng-clear" style="background-color: #fff;"  (click)="resetSiteName('name')" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (resetSiteName('name'))">×</span></span>
         <span style="color: #cb4b32;" *ngIf="editSiteNameModalError==true">Please Enter Site Name!!!</span>
         <span style="color: #cb4b32;" *ngIf="editSiteNameModalRegExError==true">A-Z 0-9 space () . , - /</span>
       </div>
     </section>
   </div>

   <div class="modal-footer border-0">
     <section class="bg-white no-shadow m-0">
       <button type="button" class="btn btn-custom btn-link" data-dismiss="modal"> Cancel </button>
       <button type="button" class="btn btn-custom btn-custom-sm btn-blue" (click)="saveNewSiteName()" [disabled]="disableEditSiteNameBtn==true">
        <mat-icon svgIcon="mail" class="img-btn mr-2"></mat-icon><span class="float-right"> {{saveDatas}} </span>
       </button>
     </section>
   </div>
 </div>
</div>
</div>



<div class="modal fade"  id="editRaftAliasValModal" tabindex="-1" aria-modal="true" aria-labelledby="editRaftAliasValModalLabel" aria-hidden="true">
<div class="modal-dialog modal-custom">
 <div class="modal-content">
   <div class="modal-header border-0">
     <h6 class="modal-title font-weight-bold text-center" id="editRaftAliasValModalLabel">
      Edit Raft Alias by <span class="label-darkblue">ADMIN</span>
       <button type="button" class="close" id="closeeditRaftAlias" #closeBtn data-dismiss="modal" aria-label="Close">
         <span aria-hidden="true">&times;</span>
       </button>
     </h6>
   </div>

   <div class="modal-body" *ngIf="hasMultipleRaftAlias==true">
     <section class="row m-0 bg-white no-shadow">
       <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
         <img src="assets/images/warning.png" class="img-btn mr-2"><span style="color: #cb4b32;" >RAFT Alias is not unique!!</span>
       </div>
     </section>
   </div>

   <div class="modal-footer border-0" *ngIf="hasMultipleRaftAlias==true">
     <section class="bg-white no-shadow m-0">
       <button type="button" class="btn btn-custom btn-custom-sm btn-blue" data-dismiss="modal">OK</button>
     </section>
   </div>
        <div class="modal-body" *ngIf="hasMultipleRaftAlias==false">
     <section class="row m-0 bg-white no-shadow">
       <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
         <mat-label class="label-control">RAFT Alias:
         </mat-label>
          <input style="padding-right: 2px;" class="form-control form-control-sm form-control-paddings" (change)="checkRaftAliasVal()" [(ngModel)]="editRaftAliasModel" type="text"/>
         <span class="ng-clear-wrapper datalistClearButton" title="Clear all"><span class="ng-clear" style="background-color: #fff;"  (click)="resetRaftAliasVal('val')" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (resetRaftAliasVal('val'))">×</span></span>
         <span style="color: #cb4b32;" *ngIf="editRaftAliasError==true">Please Enter Raft Alias!!!</span>
       </div>
     </section>
   </div>

   <div class="modal-footer border-0" *ngIf="hasMultipleRaftAlias==false">
     <section class="bg-white no-shadow m-0">
       <button type="button" class="btn btn-custom btn-link" data-dismiss="modal"> Cancel </button>
       <button type="button" class="btn btn-custom btn-custom-sm btn-blue" (click)="saveRaftAliasVal()" [disabled]="disableEditRaftCodeBtn==true">
        <mat-icon svgIcon="mail" class="img-btn mr-2"></mat-icon><span class="float-right"> {{saveDatas}} </span>
       </button>
     </section>
   </div>
 </div>
</div>
</div>



<div class="modal fade"  id="editLatamValModal" tabindex="-1" aria-modal="true" aria-labelledby="editLatamValModalLabel" aria-hidden="true">
<div class="modal-dialog modal-custom">
 <div class="modal-content">
   <div class="modal-header border-0">
     <h6 class="modal-title font-weight-bold text-center" id="editLatamValModalLabel">
      <span> Edit LATAM Code</span>
       <button type="button" class="close" id="closeeditLatamAlias" #closeBtn data-dismiss="modal" aria-label="Close">
         <span aria-hidden="true">&times;</span>
       </button>
     </h6>
   </div>

   <div class="modal-body" *ngIf="hasMultipleLatamAlias==true">
     <section class="row m-0 bg-white no-shadow">
       <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
         <img src="assets/images/warning.png" class="img-btn mr-2"><span style="color: #cb4b32;" >LATAM Alias is not unique!!</span>
       </div>
     </section>
   </div>

   <div class="modal-footer border-0" *ngIf="hasMultipleLatamAlias==true">
     <section class="bg-white no-shadow m-0">
       <button type="button" class="btn btn-custom btn-custom-sm btn-blue" data-dismiss="modal">OK</button>
     </section>
   </div>
        <div class="modal-body" *ngIf="hasMultipleLatamAlias==false">
     <section class="row m-0 bg-white no-shadow">
       <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
         <mat-label class="label-control">LATAM Code:
         </mat-label>
          <input style="padding-right: 2px;" class="form-control form-control-sm form-control-paddings" (input)="checkLatamAliasVal()" [(ngModel)]="editLatamAliasModel" type="text" minlength="2" maxlength="10" pattern="[A-Za-z0-9]{2,10}"/>
         <span class="ng-clear-wrapper datalistClearButton" title="Clear all"><span class="ng-clear" style="background-color: #fff;"  (click)="resetLatamAliasVal('val')" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (resetLatamAliasVal('val'))">×</span></span>
         <span style="color: #cb4b32;" *ngIf="editLatamAliasError">
          LATAM Code must be 2-10 characters long and contain only letters (A-Z) and numbers (0-9)!!!
        </span>
       </div>
     </section>
   </div>

   <div class="modal-footer border-0" *ngIf="hasMultipleLatamAlias==false">
     <section class="bg-white no-shadow m-0">
      <button type="button" *ngIf = "showArchivedLatamId" class="btn btn-custom btn-custom-sm btn-blue" (click)="openCnfLatamArchiveModal('archive')" style="margin-right:33px;">
        Archive
      </button>
      <button type="button" *ngIf = "!showArchivedLatamId" class="btn btn-custom btn-custom-sm btn-blue" (click)="openCnfLatamArchiveModal('unarchive')" style="margin-right:18px;">
        Unarchive
      </button>
      <article class = "float-right">
        <button type="button" class="btn btn-custom btn-link" [ngStyle]="{'margin-left' : showSwitch == true ? '20px' : '210px'}" data-dismiss="modal"> Cancel </button>
        <button type="button" class="btn btn-custom btn-custom-sm btn-blue" (click)="saveLatamAliasVal()" [disabled]="disableEditLatamCodeBtn==true">
          <mat-icon svgIcon="mail" class="img-btn mr-2"></mat-icon><span class="float-right"> {{saveDatas}} </span>
        </button>
      </article>
     </section>
   </div>
 </div>
</div>
</div>

<div class="modal fade mt-4"  id="CnfArchiveLATAM" tabindex="-1" aria-modal="true" aria-labelledby="CnfArchiveLATAMLabel" aria-hidden="true">
  <div class="modal-dialog modal-custom">
    <div class="modal-content">
      <div class="modal-header border-0">
        <h6 class="modal-title font-weight-bold text-center" id="CnfArchiveLATAMLabel">
          <span>Archive LATAM code</span>
          <button type="button" class="close" id="closeCnfArchiveLATAM" #closeBtn data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </h6>
      </div>

      <div class="modal-body">
        <section class="row m-0 bg-white no-shadow">
          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <span>Do you want to archive this LATAM code ? </span>
          </div>
        </section>
      </div>

      <div class="modal-footer border-0 row">
        <section class="bg-white no-shadow m-0 ">
          <button type="button" class="btn btn-custom btn-link" data-dismiss="modal"> Cancel </button>
          <button type="button" class="btn btn-custom btn-custom-sm btn-blue" (click)="archiveLatam()">
            Archive
          </button>
        </section>
      </div>
    </div>
  </div>
  </div>

  <div class="modal fade mt-4"  id="CnfUnArchiveLATAM" tabindex="-1" aria-modal="true" aria-labelledby="CnfUnArchiveLATAMLabel" aria-hidden="true">
    <div class="modal-dialog modal-custom">
      <div class="modal-content">
        <div class="modal-header border-0">
        <h6 class="modal-title font-weight-bold text-center" id="CnfUnArchiveLATAMLabel">
          <span>Unarchive LATAM code</span>
          <button type="button" class="close" id="closeCnfUnArchiveLATAM" #closeBtn data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </h6>
        </div>

        <div class="modal-body">
          <section class="row m-0 bg-white no-shadow">
            <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
              <span>Do you want to unarchive this LATAM code ? </span>
            </div>
          </section>
        </div>

        <div class="modal-footer border-0 row">
          <section class="bg-white no-shadow m-0 ">
            <button type="button" class="btn btn-custom btn-link" data-dismiss="modal"> Cancel </button>
            <button type="button" class="btn btn-custom btn-custom-sm btn-blue" (click)="unarchiveLatam()">
              Unarchive
            </button>
          </section>
        </div>
      </div>
    </div>
    </div>


<div class="modal fade"  id="editLatamNameValModal" tabindex="-1" aria-modal="true" aria-labelledby="editLatamNameValModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-custom">
    <div class="modal-content">
      <div class="modal-header border-0">
        <h6 class="modal-title font-weight-bold text-center" id="editLatamNameValModalLabel">
         Edit LATAM Name
          <button type="button" class="close" id="closeEditLatamName" #closeBtn data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </h6>
      </div>

      <div class="modal-body">
        <section class="row m-0 bg-white no-shadow">
          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <mat-label class="label-control">LATAM Name:
            </mat-label>
             <input style="padding-right: 2px;" class="form-control form-control-sm form-control-paddings" (change)="checkLatamName()"  [(ngModel)]="latamNameHolder" maxlength="10" (ngModelChange)="latamNameHolder = $event.toUpperCase()"  type="text"/>
             <span class="ng-clear-wrapper datalistClearButton" title="Clear all"><span class="ng-clear" style="background-color: #fff;"  (click)="resetLatamName()" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (resetLatamName())">×</span></span>
             <span style="color: #cb4b32;" *ngIf="editLatamNameError==true">Please Enter Latam Name!!!</span>
          </div>
        </section>
       </div>

       <div class="modal-footer border-0">
        <section class="bg-white no-shadow m-0">
          <button type="button" class="btn btn-custom btn-link" data-dismiss="modal"> Cancel </button>
          <button type="button" class="btn btn-custom btn-custom-sm btn-blue" (click)="saveLatamAliasName()" [disabled]="disableEditLatamNameBtn==true">
            <mat-icon svgIcon="mail" class="img-btn mr-2"></mat-icon><span class="float-right"> {{saveDatas}} </span>
          </button>
        </section>
      </div>
    </div>
  </div>
  </div>



<div class="modal fade"  id="showValidateAcp" tabindex="-1" aria-modal="true" aria-labelledby="showValidateAcpLabel" aria-hidden="true">
<div class="modal-dialog modal-custom" *ngIf="displayParam=='loading'">
  <div class="modal-content">
     <div class="modal-header border-0">
      <h6 class="modal-title font-weight-bold text-center" id="showValidateAcpLabel">
        Please Wait Loading Data....
       <button type="button" class="close" id="closeValidateAcp" #closeBtn data-dismiss="modal" aria-label="Close">
         <span aria-hidden="true">&times;</span>
       </button>
     </h6>
   </div>
       <div class="modal-body">
     <section class="row m-0 bg-white no-shadow">

   <ng-container *ngIf="loadingValidateAcp">
              <div class="local-loading-overlay">
                <div class="custom-spinner-template">
                  <mat-spinner class="custom-spinner black-spinner" diameter="40"></mat-spinner>
                </div>
              </div>
            </ng-container>

     </section>
   </div>
        <div class="modal-footer border-0">
     <section class="bg-white no-shadow m-0">
       <button type="button" class="btn btn-custom btn-custom-sm btn-blue" data-dismiss="modal">Cancel</button>
     </section>
   </div>
   </div>
</div>
<div class="modal-dialog modal-custom" *ngIf="displayParam=='nocpy'">
 <div class="modal-content">
   <div class="modal-header border-0">
    <h6 class="modal-title font-weight-bold text-center" id="showValidateAcpNoCompanyLabel">
      Qualifier Validation
       <button type="button" class="close" id="closeValidateAcp__2" #closeBtn data-dismiss="modal" aria-label="Close">
         <span aria-hidden="true">&times;</span>
       </button>
     </h6>
   </div>

   <div class="modal-body">
     <section class="row m-0 bg-white no-shadow">
       <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
         <img src="assets/images/warning.png" class="img-btn mr-2"><span>No Company associated to the Site !</span>
       </div>
     </section>
   </div>

   <div class="modal-footer border-0">
     <section class="bg-white no-shadow m-0">
       <button type="button" class="btn btn-custom btn-custom-sm btn-blue" data-dismiss="modal">Cancel</button>
     </section>
   </div>
 </div>
</div>






<div class="modal-dialog modal-custom" *ngIf="displayParam=='100raftalias'">
 <div class="modal-content">
   <div class="modal-header border-0">
    <h6 class="modal-title font-weight-bold text-center" id="showValidateAcpRaftAliasLabel">
      Qualifier Validation
       <button type="button" class="close" id="closeValidateAcp__3" #closeBtn data-dismiss="modal" aria-label="Close">
         <span aria-hidden="true">&times;</span>
       </button>
     </h6>
   </div>

   <div class="modal-body">
     <section class="row m-0 bg-white no-shadow">
       <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
         <img src="assets/images/warning.png" class="img-btn mr-2"><span>Already 100 RAFT alias for this ALCOR !</span>
       </div>
     </section>
   </div>

   <div class="modal-footer border-0">
     <section class="bg-white no-shadow m-0">
       <button type="button" class="btn btn-custom btn-custom-sm btn-blue" data-dismiss="modal">Cancel</button>
     </section>
   </div>
 </div>
</div>

<div class="modal-dialog modal-custom" *ngIf="displayParam=='alcornotset'">
 <div class="modal-content">
   <div class="modal-header border-0">
    <h6 class="modal-title font-weight-bold text-center" id="showValidateAcpAlcorLabel">
      Qualifier Validation
       <button type="button" class="close" id="closeValidateAcp__4" #closeBtn data-dismiss="modal" aria-label="Close">
         <span aria-hidden="true">&times;</span>
       </button>
     </h6>
   </div>

   <div class="modal-body">
     <section class="row m-0 bg-white no-shadow">
       <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
         <img src="assets/images/warning.png" class="img-btn mr-2"><span class="font-weight-bold">ALCOR <span class="font-weight-bold label-darkblue">{{alcorVal}}</span> is not set for the Company <span class="label-darkblue ">{{businessEntityCompanyLegalName}}</span> !</span>
       </div>
     </section>
   </div>

   <div class="modal-footer border-0">
     <section class="bg-white no-shadow m-0">
       <button type="button" class="btn btn-custom btn-custom-sm btn-blue" data-dismiss="modal">Cancel</button>
     </section>
   </div>
 </div>
</div>



</div>



<div class="modal fade" id="changeCompanyModal" tabindex="1" aria-modal="true" aria-labelledby="changeCompanyModalLabel" aria-hidden="true">
<div class="modal-dialog modal-custom">
 <div class="modal-content">
   <div class="modal-header border-0">
    <h6 class="modal-title font-weight-bold text-center" id="changeCompanyModalLabel">
      Update Company link
       <button type="button" class="close" id="closeChangeCompany" #closeBtn data-dismiss="modal" aria-label="Close">
         <span aria-hidden="true">&times;</span>
       </button>
     </h6>
   </div>

   <div class="modal-body">
     <section class="row m-0 bg-white no-shadow">
       <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
         <mat-label class="label-control">Company
         </mat-label>
         <div class="form-control form-control-sm matformheight">
          <form style="width: 325px;">
            <mat-form-field style="width:409px;">
              <input style="width:409px;" matInput aria-label="State" [matAutocomplete]="auto" [formControl]="delayCpyResponse">
              <mat-autocomplete #auto="matAutocomplete" style="display: block;" class="custom-autocomplete">
                <ng-container *ngIf="changeCpyData.length > 0; else noResults">
                  <mat-option *ngFor="let value of changeCpyData" (click)="onIdentivalueSelectUpdateCpy(value)" [value]="value">
                    <span>{{ value }}</span>
                  </mat-option>
                </ng-container>
                <ng-container *ngIf="changeCpyData.length == 0;" #noResults>
                  <mat-option class="noResults" disabled *ngIf="editCompanyField.length >= 3">
                    <span>No results</span>
                  </mat-option>
                </ng-container>
              </mat-autocomplete>
            </mat-form-field>
          </form>
         </div>
         <small class="ng-clear-wrapper datalistClearButton" style="padding-left: 25px;" title="Clear"><u style="color: black;" (click)="resetcpyfield('cpy')" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (resetcpyfield('cpy'))">X</u></small>

         <span style="color: #cb4b32;" *ngIf="companyfielderror==true">Please Enter Company!!!</span>
         <span *ngIf="companyfielderror==false"></span>


         <mat-label class="label-control mt-3">Company ID
         </mat-label>
         <div class="form-control form-control-sm matformheight">
          <form style="width: 325px;">
            <mat-form-field style="width:409px;">
              <input style="width:409px;" matInput aria-label="State" [matAutocomplete]="auto1" [formControl]="delayCpyResponseAllianceId">
              <mat-autocomplete #auto1="matAutocomplete" style="display: block;" class="custom-autocomplete">
                <ng-container *ngIf="changeCpyDataAllianceId.length > 0; else noResults1">
                  <mat-option *ngFor="let value of changeCpyDataAllianceId" (click)="onIdentivalueSelectUpdateAlliance(value)" [value]="value">
                    <span>{{ value }}</span>
                  </mat-option>
                </ng-container>
                <ng-template  #noResults1>
                  <ng-container *ngIf="changeCpyDataAllianceId.length == 0;">
                    <mat-option class="noResults" disabled *ngIf="editAllianceIdField.length >= 5">
                      <span>No results</span>
                    </mat-option>
                  </ng-container>
                </ng-template>
              </mat-autocomplete>
            </mat-form-field>
          </form>
         </div>
         <small class="ng-clear-wrapper datalistClearButton" style="padding-left: 25px;" title="Clear"><u style="color: black;" (click)="resetcpyfield('allianceId')" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (resetcpyfield('allianceId'))">X</u></small>


         <mat-label class="label-control mt-3">ALCOR
         </mat-label>
         <div class="form-control form-control-sm matformheight">
          <form style="width: 325px;">
            <mat-form-field style="width:409px;">
              <input style="width:409px;" matInput aria-label="State" [matAutocomplete]="auto2" [formControl]="delayCpyAlcorResponse">
              <mat-autocomplete #auto2="matAutocomplete" style="display: block;" class="custom-autocomplete">
                <ng-container *ngIf="changeCpyDataAlcor.length > 0; else noResults">
                  <mat-option *ngFor="let value of changeCpyDataAlcor" (click)="onIdentivalueSelect(value)" [value]="value">
                    <span>{{ value }}</span>
                  </mat-option>
                </ng-container>
                <ng-container *ngIf="changeCpyDataAlcor.length == 0" #noResults>
                  <mat-option class="noResults" disabled *ngIf="editAlcorField.length >= 4">
                    <span>No results</span>
                  </mat-option>
                </ng-container>
              </mat-autocomplete>
            </mat-form-field>
          </form>
         </div>
         <small class="ng-clear-wrapper datalistClearButton" style="padding-left: 25px;" title="Clear"><u style="color: black;" (click)="resetcpyfield('alcor')" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (resetcpyfield('alcor'))">X</u></small>


          <div>
            <mat-label class="label-control mt-3">BVD ID
            </mat-label>
            <input style="padding-right: 2px;" class="form-control form-control-sm form-control-paddings" (keyup)="checkBvdIdChange(changeCpyBvdModel,'changeCpyBvdModel')" [(ngModel)]="changeCpyBvdModel" type="text"/>
            <span class="ng-clear-wrapper datalistClearButton" title="Clear all"><span class="ng-clear" style="background-color: #fff;"  (click)="resetChangeCpyBvdId()" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (resetChangeCpyBvdId())">×</span></span>
            <span style="color: #cb4b32;" *ngIf="bvdidchangecpyfielderror==true">Please Enter BVD ID!!!</span>
            <span style="color: #cb4b32;" *ngIf="bvdIdRegExError==true">Please Enter Alphanumeric in CAPS!!!</span>
          </div>
       </div>
     </section>
   </div>

   <div class="modal-footer border-0">
     <section class="bg-white no-shadow m-0">
       <button type="button" class="btn btn-custom btn-link" data-dismiss="modal"> Cancel </button>
       <button type="button" class="btn btn-custom btn-custom-sm btn-blue" [disabled]="disableUpdateCpyBtn==true" (click)="checkCpyLinkToSite(1,'')">
        <mat-icon svgIcon="mail" class="img-btn mr-2"></mat-icon><span class="float-right"> {{saveDatas}} </span>
       </button>
     </section>
   </div>
 </div>
</div>
</div>


<div class="modal fade"  id="editGpsCoordinatesModal" tabindex="-1" aria-modal="true" aria-labelledby="editGpsCoordinatesModalLabel" aria-hidden="true">
<div class="modal-dialog modal-custom">
 <div class="modal-content">
   <div class="modal-header border-0">
     <h6 class="modal-title font-weight-bold text-center" id="editGpsCoordinatesModalLabel">
      Edit GPS data
       <button type="button" class="close" id="closeEditGps" #closeBtn data-dismiss="modal" aria-label="Close">
         <span aria-hidden="true">&times;</span>
       </button>
     </h6>
   </div>

   <div class="modal-body">
     <section class="row m-0 bg-white no-shadow">
        <div class="col col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 pr-0">
          <mat-label class="label-control">Latitude :</mat-label>
          <p style="position: relative;padding: 0;">
            <span style="width: 18%;display: inline-block;">
              <input id="latitude_degres__2" type="text" (keyup)="dmsversdd()" class="form-control form-control-sm form-control-paddings pr-1" [(ngModel)]="latDegVal">

            </span>
            <label class="font-weight-bold" style="position: absolute;top: 0;" for="latitude_degres">&deg;</label>&nbsp;
            <span style="width: 18%;display: inline-block;">
              <input id="latitude_minutes__2" type="text" (keyup)="dmsversdd()" class="form-control form-control-sm form-control-paddings pr-1" [(ngModel)]="latMinVal">

            </span>
            <label class="font-weight-bold" style="position: absolute;top: 0;" for="latitude_minutes">'</label>&nbsp;
            <span style="width: 35%;display: inline-block;">
              <input id="latitude_secondes__2" type="text" (keyup)="dmsversdd()" class="form-control form-control-sm form-control-paddings pr-1" [(ngModel)]="latSecVal">

            </span>
            <mat-label class="font-weight-bold" style="position: absolute;top: 0;" for="latitude_secondes">''</mat-label>&nbsp;
            <span style="width: 17%;display: inline-block;">
            <mat-select class="form-control form-control-sm p-0 dropdown-select"  [(ngModel)]="northSouthModel" (ngModelChange)="dmsversdd()" panelClass="dropdown-panel" [disableOptionCentering]="true">
                <mat-option value="North">N</mat-option>
                <mat-option value="South">S</mat-option>
            </mat-select>
            </span>
          </p>
        </div>
        <div class="col col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 pr-0">
          <mat-label class="label-control">Longitude :</mat-label>
          <p style="position: relative;padding: 0;">
            <span style="width: 18%;display: inline-block;">
              <input id="longitude_degres__2" type="text" (keyup)="dmsversdd()" class="form-control form-control-sm form-control-paddings pr-1" [(ngModel)]="longDegVal">

            </span>
            <label class="font-weight-bold" style="position: absolute;top: 0;" for="longitude_degres">&deg;</label>&nbsp;
            <span style="width: 18%;display: inline-block;">
              <input id="longitude_minutes__2" type="text" (keyup)="dmsversdd()" class="form-control form-control-sm form-control-paddings pr-1" [(ngModel)]="longMinVal">

            </span>
            <label class="font-weight-bold" style="position: absolute;top: 0;" for="longitude_minutes">'</label>&nbsp;
            <span style="width: 35%;display: inline-block;">
              <input id="longitude_secondes__2" type="text" (keyup)="dmsversdd()" class="form-control form-control-sm form-control-paddings pr-1" [(ngModel)]="longSecVal">

            </span>
            <mat-label class="font-weight-bold" style="position: absolute;top: 0;" for="longitude_secondes">''</mat-label>&nbsp;
            <span style="width: 17%;display: inline-block;">
            <mat-select class="form-control form-control-sm p-0 dropdown-select"  [(ngModel)]="eastWestModel" (ngModelChange)="dmsversdd()" panelClass="dropdown-panel" [disableOptionCentering]="true">
                <mat-option value="East">E</mat-option>
                <mat-option value="West">W</mat-option>
            </mat-select>
            </span>
          </p>
        </div>
     </section>
     <section class="row m-0 bg-white no-shadow">
         <div class="col col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 pr-0">
            <mat-label class="label-control">Latitude :</mat-label>
            <input type="text" class="form-control form-control-sm form-control-paddings" [(ngModel)]="latitudeVal" (keyup)="ddversdms()">
            <span class="ng-clear-wrapper datalistClearButton" title="Clear all"><span class="ng-clear" style="background-color: #fff;"  (click)="resetGpsVals('lat')" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (resetGpsVals('lat'))">×</span></span>
            <span style="color: #cb4b32;" *ngIf="editGpsCoordinatesError1==true">Please Enter Latitude!!!</span>
         </div>
         <div class="col col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 pr-0">
            <mat-label class="label-control">Longitude :</mat-label>
            <input type="text" class="form-control form-control-sm form-control-paddings" [(ngModel)]="longitudeVal" (keyup)="ddversdms()">
            <span class="ng-clear-wrapper datalistClearButton" title="Clear all"><span class="ng-clear" style="background-color: #fff;"  (click)="resetGpsVals('lon')" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (resetGpsVals('lon'))">×</span></span>
            <span style="color: #cb4b32;" *ngIf="editGpsCoordinatesError2==true">Please Enter Longitude!!!</span>
         </div>
     </section>
   </div>
   <div class="modal-footer border-0">
    <section class="bg-white no-shadow m-0" style="width: 100%;">
          <button type="button"  class="btn btn-custom btn-blue" (click)="copyGpsdata('latval')" *ngIf="roleVariableHide ==true && latitudeVal=='' && longitudeVal==''" >
            Copy city Gps data
          </button>
        <div style="float: right;">
       <button type="button" class="btn btn-custom btn-link" data-dismiss="modal"> Cancel </button>
       <button type="button" class="btn btn-custom btn-custom-sm btn-blue" (click)="saveNewGps()" [disabled]="disableEditGpsCorBtn==true">
        <mat-icon svgIcon="mail" class="img-btn mr-2"></mat-icon><span class="float-right"> {{saveDatas}} </span>
       </button>
      </div>
     </section>
   </div>
 </div>
</div>
</div>



<div class="modal fade"  id="openEditSiteStatus" tabindex="-1" aria-modal="true" aria-labelledby="openEditSiteStatusLabel" aria-hidden="true">
<div class="modal-dialog modal-custom">
 <div class="modal-content">
   <div class="modal-header border-0">
    <h6 class="modal-title font-weight-bold text-center" id="openEditSiteStatusLabel">
      Edit Physical state
       <button type="button" class="close" id="closeSiteStatusmodal" #closeBtn data-dismiss="modal" aria-label="Close">
         <span aria-hidden="true">&times;</span>
       </button>
     </h6>
   </div>

   <div class="modal-body">
     <section class="row m-0 bg-white no-shadow">
       <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
         <mat-label class="label-control">Physical State
         </mat-label>
          <mat-select class="form-control form-control-sm"  [(ngModel)]="editSiteStatusModel" panelClass="dropdown-panel" [disableOptionCentering]="true">
              <mat-option value="Greenfield">Greenfield</mat-option>
              <mat-option value="Brownfield">Brownfield</mat-option>
              <mat-option value="Built">Built</mat-option>
              <mat-option value="Destroyed">Destroyed</mat-option>
          </mat-select>
         <span style="color: #cb4b32;" *ngIf="editSiteStatusError==true">Please select Site Physical state!</span>
       </div>
     </section>
   </div>

   <div class="modal-footer border-0">
     <section class="bg-white no-shadow m-0">
       <button type="button" class="btn btn-custom btn-link" data-dismiss="modal"> Cancel </button>
       <button type="button" class="btn btn-custom btn-custom-sm btn-blue" (click)="updateSiteStatus()" [disabled]="disableEditSiteStatusBtn==true">
        <mat-icon svgIcon="mail" class="img-btn mr-2"></mat-icon><span class="float-right"> {{saveDatas}} </span>
       </button>
     </section>
   </div>
 </div>
</div>
</div>



<div class="modal fade"  id="openblankStatusUpdate" tabindex="-1" aria-modal="true" aria-labelledby="openblankStatusUpdateLabel" aria-hidden="true">
<div class="modal-dialog modal-custom">
 <div class="modal-content">
   <div class="modal-header border-0">
     <h6 class="modal-title font-weight-bold text-center" id="openblankStatusUpdateLabel">
      Blank status Update
       <button type="button" class="close" id="closeblankStatusUpdate" #closeBtn data-dismiss="modal" aria-label="Close">
         <span aria-hidden="true">&times;</span>
       </button>
     </h6>
   </div>

   <div class="modal-body">
     <h6>Do you really want to make a blank Status update on Site {{siteIdentifier}} {{siteName}}  and its belongings ?</h6>
   </div>

   <div class="modal-footer border-0">
     <section class="bg-white no-shadow m-0">
       <button type="button" class="btn btn-custom btn-link" data-dismiss="modal"> Close </button>
       <button type="button" class="btn btn-custom btn-custom-sm btn-blue" (click)="blankStatusUpdate()" >
        <span class="float-right"> Update </span>
       </button>
     </section>
   </div>
 </div>
</div>
</div>


<div class="modal fade" id="showBlankUpdateProcess" tabindex="-1" aria-modal="true" aria-labelledby="showBlankUpdateProcessLabel" aria-hidden="true" data-backdrop="static" data-keyboard="false">
  <div class="modal-dialog modal-custom">
    <div class="modal-content">
      <div class="modal-header border-0">
        <h6 class="modal-title font-weight-bold text-center" id="showBlankUpdateProcessLabel">
          Blank status Update Process
          <button type="button" class="close" id="closeImportIpnProcess" #closeBtn data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </h6>
      </div>

      <div class="modal-body">
        <section class="row m-0 bg-white no-shadow">
          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">


            <div class="py-2">
              <span class="label-darkblue">{{TextForCompleteUpload}}</span>
            </div>
            <div class="py-2" *ngIf="blankUpdateCompleted">
              <span class="label-darkblue">Loading</span><small><img src="assets/images/loading.gif" class="loadingheight" alt="Updating..."></small>
            </div>
            <div class="py-2" *ngIf="!blankUpdateCompleted">
              <button class="btn btn-custom btn-blue btn-tax" (click)="downloadUploadLogFile()">
                Download Log File
              </button>
            </div>

          </div>
        </section>
      </div>

      <div class="modal-footer border-0">
        <section class="bg-white no-shadow m-0">
          <button type="button" class="btn btn-custom btn-link" data-dismiss="modal"> Cancel </button>
        </section>
      </div>
    </div>
  </div>
</div>



<div class="modal fade"  id="openEditSiteValStatus" tabindex="-1" aria-modal="true" aria-labelledby="openEditSiteValStatusLabel" aria-hidden="true">
<div class="modal-dialog modal-custom">
 <div class="modal-content">
   <div class="modal-header border-0">
    <h6 class="modal-title font-weight-bold text-center" id="openEditSiteValStatusLabel">
      Edit Site status
       <button type="button" class="close" id="closeSiteValStatusmodal" #closeBtn data-dismiss="modal" aria-label="Close">
         <span aria-hidden="true">&times;</span>
       </button>
     </h6>
   </div>

   <div class="modal-body">
     <section class="row m-0 bg-white no-shadow">
       <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
         <mat-label class="label-control">Site status
         </mat-label>
          <mat-select class="form-control form-control-sm"  [(ngModel)]="editSiteValStatusModel" panelClass="dropdown-panel" [disableOptionCentering]="true">
              <mat-option value="CREATED">Identified</mat-option>
              <mat-option value="ACTIVE">Active</mat-option>
              <mat-option value="PENDING">Inactive</mat-option>
              <mat-option value="ARCHIVED">Archived</mat-option>
          </mat-select>
         <span style="color: #cb4b32;" *ngIf="editSiteValStatusError==true">Please select Site Validity status!</span>
       </div>
     </section>
   </div>

   <div class="modal-footer border-0">
     <section class="bg-white no-shadow m-0">
       <button type="button" class="btn btn-custom btn-link" data-dismiss="modal"> Cancel </button>
       <button type="button" class="btn btn-custom btn-custom-sm btn-blue" (click)="updateSiteValStatus()" [disabled]="disableEditSiteValStatusBtn==true">
        <mat-icon svgIcon="mail" class="img-btn mr-2"></mat-icon><span class="float-right"> {{saveDatas}} </span>
       </button>
     </section>
   </div>
 </div>
</div>
</div>



<div class="modal fade"  id="lookForCpyModal" tabindex="-1" aria-modal="true" aria-labelledby="lookForCpyModalLabel" aria-hidden="true">
 <div class="modal-dialog modal-custom">
 <div class="modal-content" style="width: 800px;margin-left: -30% !important;">
    <div class="modal-header border-0">
      <h6 class="modal-title font-weight-bold text-center" id="lookForCpyModalLabel">
        Look for Company
        <button type="button" class="close" id="closeCpyGrpModal" #closeBtn data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </h6>
    </div>
    <div class="modal-title mx-1 mt-3 mb-2 row">
      <div class="col-xl-6">
        <h6 class="font-weight-bold">Site name: <span class="label-darkblue">{{ siteName ? siteName : '' }}</span></h6>
      </div>
      <div class="col-xl-6">
        <button type="button" *ngIf="toggleChangeCpyModal" class="btn btn-custom float-right d-flex align-center bgcolor" (click)="resetInputField('fromLook')" data-dismiss="modal">
          <span style="color: white;"><mat-icon svgIcon="edit" alt="updatecompany" class="img-btn pb-1"></mat-icon> <span style="margin-right: 10px;height: 20px;">Update Company link</span></span>
        </button>
      </div>
    </div>


   <div class="modal-body px-0">
     <section class="row m-0 bg-white no-shadow">
       <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 p-0">
         <div class="modal-body row m-0 p-0 table-responsive">
          <table class="table m-0">
            <thead style="background-color: #F5F5F5;">
              <tr class="col p-0">
                <th class="thCustom" style="width: 1% !important;" (click)="sort('')" tabindex="0" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (sort(''))"></th>
                <th class="thCustom" (click)="sort('raft')" tabindex="0" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (sort('raft'))">RAFT account</th>
                <th class="thCustom" (click)="sort('raft_name')" tabindex="0" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (sort('raft_name'))">RAFT name</th>
                <th class="thCustom" (click)="sort('company')" tabindex="0" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (sort('company'))">Company</th>
                <th class="thCustom" (click)="sort('group')" tabindex="0" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (sort('group'))">Group</th>
              </tr>
            </thead>

            <tbody *ngIf="raftCpyGroupData.length>0 && showLoadedLookCpyData==true && lookCpyLoading==false">
              <tr *ngFor="let cpygrp of raftCpyGroupData; let i = index" class="forColor p-0">
                <td class="text-left tdCustom" style="width: 0% !important;">
                  <span *ngIf="raftCpyGroupData3[raftCpyRowIdsOnVal[cpygrp.businessIdentifierValue]]">
                    <input
                      class="edit"
                      [disabled]="raftCpyGroupData3[raftCpyRowIdsOnVal[cpygrp.businessIdentifierValue]]==undefined || raftCpyGroupData3[raftCpyRowIdsOnVal[cpygrp.businessIdentifierValue]]==''"
                      value="{{raftCpyGroupData3[raftCpyRowIdsOnVal[cpygrp.businessIdentifierValue]].row_id}}@@{{raftCpyGroupData3[raftCpyRowIdsOnVal[cpygrp.businessIdentifierValue]].allianceIdentifier}}@@{{raftCpyGroupData3[raftCpyRowIdsOnVal[cpygrp.businessIdentifierValue]].legalName}}@@{{cpygrp.businessIdentifierValue}}"
                      [(ngModel)]="raftCpyGroupModel"
                      name="sameAlcor"
                      (change)="toggleChangeCpyModal=true"
                      type="radio">
                  </span>
                </td>
                <td class="tdCustom font-weight-bold">
                  {{cpygrp.businessIdentifierValue ? cpygrp.businessIdentifierValue : '-'}}
                </td>
                <td class="tdCustom font-weight-bold">
                  {{cpygrp.businessIdentifierName ? cpygrp.businessIdentifierName : '-'}}
                </td>
                <td class="tdCustom font-weight-bold">
                  <span *ngIf="raftCpyGroupData3.length>0">
                    {{raftCpyGroupData3[raftCpyRowIdsOnVal[cpygrp.businessIdentifierValue]] ? raftCpyGroupData3[raftCpyRowIdsOnVal[cpygrp.businessIdentifierValue]].legalName : 'No Company'}}
                  </span>
                  <span *ngIf="raftCpyGroupData3.length==0">
                    No Company
                  </span>

                 </td>
                <td class="tdCustom font-weight-bold">
                  <span *ngIf="raftCpyGroupData4.length>0">
                    {{raftCpyGroupData4[raftCpyRowIdsOnVal[cpygrp.businessIdentifierValue]] ? raftCpyGroupData4[raftCpyRowIdsOnVal[cpygrp.businessIdentifierValue]].groupName : 'No Group'}}
                  </span>
                  <span *ngIf="raftCpyGroupData4.length==0">
                    No Group
                  </span>

                </td>

              </tr>
            </tbody>
            <tbody *ngIf="raftCpyGroupData.length==0">
              <tr>
                <td colspan="7" class="font-weight-bold text-darkblue text-center">No Results</td>
              </tr>
            </tbody>

             <ng-container *ngIf="lookCpyLoading">
              <div class="local-loading-overlay">
                <div class="custom-spinner-template">
                  <mat-spinner class="custom-spinner black-spinner" diameter="40"></mat-spinner>
                </div>
              </div>
            </ng-container>

            <tfoot>
                 <tr>
                    <td colspan="8">

                    </td>
                 </tr>
            </tfoot>
          </table>
      </div>
       </div>
     </section>
   </div>

   <div class="modal-footer border-0">
     <section class="bg-white no-shadow m-0">
       <button type="button" class="btn btn-custom btn-link" data-dismiss="modal"> Cancel </button>
       <button type="button" class="btn btn-custom btn-custom-sm btn-blue ml-2" data-dismiss="modal">
        OK
       </button>
     </section>
   </div>
 </div>
</div>
</div>



<div class="modal fade"  id="showAssociatedPickingModal" tabindex="-1" aria-modal="true" aria-labelledby="showAssociatedPickingModalLabel" aria-hidden="true">
<div class="modal-dialog modal-custom">
 <div class="modal-content" style="width: 800px;margin-left: -30% !important;">
   <div class="modal-header border-0">
     <h6 class="modal-title font-weight-bold text-center" id="showAssociatedPickingModalLabel">
       Associated Picking Qualifier
       <button type="button" class="close" id="closeAssnPickingModal" #closeBtn data-dismiss="modal" aria-label="Close">
         <span aria-hidden="true">&times;</span>
       </button>
     </h6>
   </div>

   <div class="modal-body px-0">
     <section class="row m-0 bg-white no-shadow">
       <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 p-0">
         <div class="modal-body row m-0 p-0 table-responsive">
          <table class="table m-0">
            <thead style="background-color: #F5F5F5;">
              <tr class="col p-0">
                <th class="thCustom" (click)="sort('acp1Identifier')" tabindex="0" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (sort('acp1Identifier'))">Manufacturing</th>

              </tr>
            </thead>
            <tbody *ngIf="identifierManufacturing.length>0">
              <tr *ngFor="let picks of identifierManufacturing; let i = index" class="forColor p-0" style="height: 70px;">
                <td class="tdCustom border-right">
                  <div class="row">
                    <span class="col-xl-6 font-weight-bold label-darkblue">
                      {{picks.acp1Identifier ? picks.acp1Identifier : '-'}}
                    </span>
                    <div class="col-xl-6 text-left">
                      <p class="mb-2" *ngIf="associatedPickingDataPoints[picks.acp1Id]">
                        <span>
                          {{associatedPickingDataPoints[picks.acp1Id]['label'] ? associatedPickingDataPoints[picks.acp1Id]['label'] : '-'}}
                        </span>
                      </p>
                      <p class="mb-2" *ngIf="associatedPickingDataPoints[picks.acp1Id]">
                        <span class="font-weight-bold">RAFT code :</span>
                        <span class="pl-2">{{associatedPickingDataPoints[picks.acp1Id]['raft_alias'] ? associatedPickingDataPoints[picks.acp1Id]['raft_alias'] : '-'}}&nbsp;
                        </span>
                      </p>
                      <p class="mb-2" *ngIf="associatedPickingDataPoints[picks.acp1Id]">
                        <span class="font-weight-bold">Name :</span>
                        <span class="pl-2">{{associatedPickingDataPoints[picks.acp1Id]['raft_name'] ? associatedPickingDataPoints[picks.acp1Id]['raft_name'] : '-'}}&nbsp;
                        </span>
                      </p>
                      <p class="mb-2" *ngIf="associatedPickingDataPoints[picks.acp1Id]">
                        <span class="font-weight-bold">Country :</span>
                        <span class="pl-2">{{associatedPickingDataPoints[picks.acp1Id]['country'] ? associatedPickingDataPoints[picks.acp1Id]['country'] : '-'}}&nbsp;
                        </span>
                      </p>
                      <p class="mb-2" *ngIf="associatedPickingDataPoints[picks.acp1Id]">
                        <span class="font-weight-bold">City :</span>
                        <span class="pl-2">{{associatedPickingDataPoints[picks.acp1Id]['city'] ? associatedPickingDataPoints[picks.acp1Id]['city'] : '-'}}&nbsp;
                        </span>
                      </p>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
            <thead style="background-color: #F5F5F5;">
              <tr class="col p-0">

                <th class="thCustom" (click)="sort('acp2Identifier')" tabindex="0" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (sort('acp2Identifier'))">Picking
                  <button type="button" class="btn btn-custom btn-custom-sm btn-blue float-right mt-1" data-toggle="modal" data-target="#showAddPickingQua" (click)="addAssociatedPicking()" *ngIf="(showForConsult == true && showBuyerProfile == true && roleIsManager == false) && manufacturingAcpStatus.toLowerCase() == 'pending'">
                    <mat-icon svgIcon="add" class="img-btn img-btn-md pb-1"></mat-icon><span class="float-right"> Add associated picking </span>
                  </button>
                </th>
              </tr>
            </thead>
            <tbody *ngIf="associatedPickingData.length>0">
              <tr *ngFor="let picks of associatedPickingData | orderBy: key:reverse; let i = index" class="forColor p-0" style="height: 70px;">
                <td class="tdCustom">
                  <div class="row">
                    <div class="col-xl-4 ">
                      <P class="mb-2">
                      <span class="font-weight-bold label-darkblue">
                      {{picks.acp2Identifier ? picks.acp2Identifier : '-'}}
                      </span></P>
                    </div>
                    <div class="col-xl-4 text-left">
                      <p class="mb-2" *ngIf="associatedPickingDataPoints[picks.acp2Id]">
                        <span>
                          {{associatedPickingDataPoints[picks.acp2Id]['label'] ? associatedPickingDataPoints[picks.acp2Id]['label'] : '-'}}
                        </span>
                      </p>
                      <p class="mb-2" *ngIf="associatedPickingDataPoints[picks.acp2Id]">
                        <span class="font-weight-bold">RAFT code :</span>
                        <span class="pl-2">{{associatedPickingDataPoints[picks.acp2Id]['raft_alias'] ? associatedPickingDataPoints[picks.acp2Id]['raft_alias'] : '-'}}&nbsp;
                        </span>
                      </p>
                      <p class="mb-2" *ngIf="associatedPickingDataPoints[picks.acp2Id]">
                        <span class="font-weight-bold">Name :</span>
                        <span class="pl-2">{{associatedPickingDataPoints[picks.acp2Id]['raft_name'] ? associatedPickingDataPoints[picks.acp2Id]['raft_name'] : '-'}}&nbsp;
                        </span>
                      </p>
                      <p class="mb-2" *ngIf="associatedPickingDataPoints[picks.acp2Id]">
                        <span class="font-weight-bold">Country :</span>
                        <span class="pl-2">{{associatedPickingDataPoints[picks.acp2Id]['country'] ? associatedPickingDataPoints[picks.acp2Id]['country'] : '-'}}&nbsp;
                        </span>
                      </p>
                      <p class="mb-2" *ngIf="associatedPickingDataPoints[picks.acp2Id]">
                        <span class="font-weight-bold">City :</span>
                        <span class="pl-2">{{associatedPickingDataPoints[picks.acp2Id]['city'] ? associatedPickingDataPoints[picks.acp2Id]['city'] : '-'}}&nbsp;
                        </span>
                      </p>
                    </div>
                    <div class="col-xl-4 text-left">
                      <p class="mb-2 " *ngFor="let val of alcornameandvalue[picks.acp2Identifier]">
                        <span>
                          {{val.value}}
                        </span>&nbsp;
                        <span  class="label-darkblue">
                          {{val.label}}
                        </span>&nbsp;
                        <span class="mb-2 group-status pl-2 pr-2" *ngIf="val.alcorEffectiveDate == '2222-01-01'" [ngStyle]="{'background':colorStatus['pending']}">
                          pending
                        </span>
                      </p>
                      <p class="mb-2">
                        <span class="mb-2 group-status pl-2 pr-2" *ngIf="(picks.effectiveDate == '2222-01-01') && (!alcornameandvalue[picks.acp2Identifier])"
                        [ngStyle]="{'background':colorStatus['pending']}">
                        Pending
                        </span>
                      </p>
                      <p class="mt-2" *ngIf="(showForConsult == true && showBuyerProfile == true && roleIsManager == false) && manufacturingAcpStatus == 'Pending'">
                        <button type="button" class="btn btn-custom btn-blue" data-toggle="modal" data-target="#openFactoriesModal" (click)="FactoriesCodedisp(picks.acp1Identifier,picks.acp2Identifier,picks.rowId,picks.acp2Id)">
                          <mat-icon svgIcon="add" class="img-btn img-btn-md pb-1"></mat-icon><span class="float-right"> Add Factory </span>
                        </button>
                      </p>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
            <tbody *ngIf="associatedPickingData.length==0">
              <tr>
                <td colspan="7" class="font-weight-bold text-darkblue text-center">No Results</td>
              </tr>
            </tbody>

             <ng-container *ngIf="assnPickingLoading">
              <div class="local-loading-overlay">
                <div class="custom-spinner-template">
                  <mat-spinner class="custom-spinner black-spinner" diameter="40"></mat-spinner>
                </div>
              </div>
            </ng-container>

            <tfoot>
              <tr>
                <td colspan="8">

                </td>
              </tr>
            </tfoot>
          </table>
      </div>
       </div>
     </section>
   </div>

   <div class="modal-footer border-0">
     <section class="bg-white no-shadow m-0">

       <button type="button" class="btn btn-custom btn-custom-md btn-blue" data-dismiss="modal">
        Close
       </button>
     </section>
   </div>
 </div>
</div>
</div>



<div class="modal fade"  id="openFactoriesModal" tabindex="-1" aria-modal="true" aria-labelledby="openFactoriesModalLabel" aria-hidden="true">
<div class="modal-dialog modal-custom">
  <div class="modal-content" style="width: 800px;margin-left: -30% !important;">
    <div class="modal-header border-0">
      <h6 class="modal-title font-weight-bold text-center" id="openFactoriesModalLabel">
       Factories
        <button type="button" class="close" id="closeFactoriesModal" #closeBtn data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </h6>
    </div>
    <div class="modal-title font-weight-bold ml-4 mt-3 mb-2 text-right"> <h6 class="font-weight-bold">Filter: <span class="form-group col col-12 col-sm-12 col-md-6 col-lg-3 col-xl-3 mt-3">
      <input type="text" id="myInput"  [(ngModel)]="filtername" (keyup)="FilterFunction()">
      <span class="ng-clear custom-clear" title="Clear all" (click)="clearfields('clear')" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (clearfields('clear'))">x</span>
      </span></h6>
    </div>
    <div class="modal-body row m-0 p-0 table-responsive" style="height: 300px;overflow-y: auto;">
      <table class="table m-0"id="myTable">
        <thead style="background-color: #F5F5F5;">
          <tr class="col p-0">
            <th class="thCustom" style="width: 1%;"></th>
            <th class="col-12 col-md-3 col-lg-3 col-xl-3 col-sm-4 text-center text-darkblue label-darkblue thCustom sortDecorationunderline">Code</th>
            <th class="col-12 col-md-3 col-lg-3 col-xl-3 col-sm-4 text-center thCustom sortDecorationunderline">Name</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let datsa of uniquefactNameAndCode | orderBy:key:reverse; let i = index" class="col forColor p-0">
            <td class="tdCustom font-weight-bold" style="width: 1%;">
              <input type="checkbox" class="mt-1 edit" style="position: absolute;" [disabled]="datsa.disableuniquefactNameCode" (click)="selectAddFactoryCodeName(datsa.value)" />
            </td>
            <td class="col-12 col-md-3 col-lg-3 col-xl-3 col-sm-6 tdCustom font-weight-bold text-center" style="color: #60504A;">{{datsa.value }}</td>
            <td class="col-12 col-md-3 col-lg-3 col-xl-3 col-sm-6 tdCustom font-weight-bold text-center">{{datsa.label}}</td>
          </tr>
        </tbody>

   <ng-container *ngIf="FactoriescodeLoading">
              <div class="local-loading-overlay">
                <div class="custom-spinner-template">
                  <mat-spinner class="custom-spinner black-spinner" diameter="40"></mat-spinner>
                </div>
              </div>
            </ng-container>


      </table>
    </div>
    <div class="modal-footer border-0">
      <section class="bg-white no-shadow m-0">
        <button type="button" class="btn btn-custom btn-custom-md btn-blue" data-dismiss="modal">
         Cancel
        </button>&nbsp;&nbsp;
        <button type="button" class="btn btn-custom btn-custom-md btn-blue" (click)="AddFactoryCodeName()" >
          Add
         </button>
      </section>
    </div>
  </div>
</div>
</div>



<div class="modal fade"  id="openNoAssociatedQualifier" tabindex="-1" aria-modal="true" aria-labelledby="openNoAssociatedQualifierLabel" aria-hidden="true">
<div class="modal-dialog modal-custom">
  <div class="modal-content">
    <div class="modal-header border-0">
      <h6 class="modal-title font-weight-bold text-center" id="openNoAssociatedQualifierLabel">
       Associated Picking Qualifier
        <button type="button" class="close" id="closeNoAssociatedQualifier" #closeBtn data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </h6>
    </div>

    <div class="modal-body">
      <section class="row m-0 bg-white no-shadow">
        <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <img src="assets/images/warning.png" class="img-btn mr-2"><span style="color: #cb4b32;" >No associated picking qualifier!</span>
        </div>
      </section>

      <div class="modal-footer border-0">
      <section class="col bg-white no-shadow m-0 p-0">
        <button type="button" class="btn btn-custom btn-blue" data-toggle="modal" data-dismiss="modal" data-target="#showAddPickingQua" (click)="addAssociatedPicking()">
          <mat-icon svgIcon="add" class="img-btn img-btn-md pb-1"></mat-icon><span class="float-right"> Add associated picking </span>
        </button>
        <button type="button" class="btn btn-custom btn-custom-sm btn-blue float-right mt-1" data-dismiss="modal">
          OK
        </button>
      </section>
      </div>
  </div>
  </div>
</div>
</div>



<div class="modal fade"  id="siteEditAddress" tabindex="-1" aria-modal="true" aria-labelledby="siteEditAddressLabel" aria-hidden="true">
<div class="modal-dialog modal-custom">
<div class="modal-content">
  <div class="modal-header border-0">
    <h6 class="modal-title font-weight-bold text-center" id="siteEditAddressLabel">
      Edit Address
      <button type="button" class="close" id="closeEditAddressBtn" #closeBtn data-dismiss="modal" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </h6>
  </div>

  <div class="modal-body">
    <section class="row m-0 bg-white no-shadow">

        <div class="form-group col col-12 col-sm-3 col-md-3 col-lg-3 col-xl-3">
          <label class="label-control">N°
          </label>
          <div>
            <input
              style="padding-right: 2px;"
              class="form-control form-control-sm form-control-paddings"
              (keyup)="checkForRegExAddressUpdate($event,wayNumberModel,'wayNumberModel')"
              [(ngModel)]="wayNumberModel"
              type="text"
              (ngModelChange)="wayNumberModel = $event.toUpperCase()"
              maxlength="9"/>
            <span class="ng-clear-wrapper datalistClearButton" title="Clear all"><span class="ng-clear" style="background-color: #fff;" (click)="resetAddressField('wayNumberModel')" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (resetAddressField('wayNumberModel'))">×</span></span>
            <span style="color: #cb4b32;" *ngIf="wayNumberModelRegExError==true">A-Z 0-9 space () . , - /</span>
          </div>
        </div>

        <div class="form-group col col-12 col-sm-9 col-md-9 col-lg-9 col-xl-9">
          <label class="label-control">Street<span class="element_astrick">*</span>
          </label>
          <div>
            <input
              style="padding-right: 2px;"
              class="form-control form-control-sm form-control-paddings"
              (keyup)="checkForRegExAddressUpdate($event,streetModel,'streetModel')"
              [(ngModel)]="streetModel"
              type="text"
              (ngModelChange)="streetModel = $event.toUpperCase()"
              maxlength="35"/>
            <span class="ng-clear-wrapper datalistClearButton" title="Clear all"><span class="ng-clear" style="background-color: #fff;" (click)="resetAddressField('streetModel')" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (resetAddressField('streetModel'))">×</span></span>
            <span style="color: #cb4b32;" *ngIf="streetModelError==true">Please enter street</span>
            <span style="color: #cb4b32;" *ngIf="streetModelRegExError==true">A-Z 0-9 space () . , - /</span>
          </div>
        </div>

        <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <label class="label-control">Additional Address information
          </label>
          <div>
            <div>
              <input style="padding-right: 2px;" class="form-control form-control-sm form-control-paddings"
                type="text" [(ngModel)]="additional"
                maxlength="35"
                (ngModelChange)="additional = $event.toUpperCase()"
                (keyup)="checkForRegExAddressUpdate($event,additional,'additional')"/>
                <span class="ng-clear-wrapper datalistClearButton" title="Clear all"><span class="ng-clear" style="background-color: #fff;"  (click)="resetAddressField('additional')" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (resetAddressField('additional'))">×</span></span>
            </div>
            <span style="color: #cb4b32;" *ngIf="additionalRegExError==true">A-Z 0-9 space () . , - /</span>
            <div>
              <input style="padding-right: 2px;" class="form-control form-control-sm form-control-paddings"
                type="text" [(ngModel)]="additionalInfo"
                maxlength="35"
                (ngModelChange)="additionalInfo = $event.toUpperCase()"
                (keyup)="checkForRegExAddressUpdate($event,additionalInfo,'additionalInfo')" />
                <span class="ng-clear-wrapper datalistClearButton" title="Clear all"><span class="ng-clear" style="background-color: #fff;"  (click)="resetAddressField('additionalInfo')" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (resetAddressField('additionalInfo'))">×</span></span>
            </div>
            <span style="color: #cb4b32;" *ngIf="additionalInfoRegExError==true">A-Z 0-9 space () . , - /</span>
          </div>
        </div>

        <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <label class="label-control">Postal Code
          </label>
          <div>
            <input
              style="padding-right: 2px;"
              class="form-control form-control-sm form-control-paddings"
              (keyup)="checkForRegExAddressUpdate($event,updatePostalCodeModel,'updatePostalCodeModel')"
              [(ngModel)]="updatePostalCodeModel"
              type="text"
              (ngModelChange)="updatePostalCodeModel = $event.toUpperCase()"
              maxlength="9"/>
            <span class="ng-clear-wrapper datalistClearButton" title="Clear all"><span class="ng-clear" style="background-color: #fff;"  (click)="resetAddressField('updatePostalCodeModel')" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (resetAddressField('updatePostalCodeModel'))">×</span></span>
            <span style="color: #cb4b32;" *ngIf="updatePostalCodeModelRegExError==true">A-Z 0-9 space () . , - /</span>
          </div>
        </div>

        <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <label class="label-control">Territorial Division
          </label>
          <div>
            <input
              style="padding-right: 2px;"
              class="form-control form-control-sm form-control-paddings"
              (keyup)="checkForRegExAddressUpdate($event,territorialDivModel,'territorialDivModel')"
              [(ngModel)]="territorialDivModel"
              type="text"
              (ngModelChange)="territorialDivModel = $event.toUpperCase()"
              maxlength="35"/>
            <span class="ng-clear-wrapper datalistClearButton" title="Clear all"><span class="ng-clear" style="background-color: #fff;" (click)="resetAddressField('territorialDivModel')" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (resetAddressField('territorialDivModel'))">×</span></span>
            <span style="color: #cb4b32;" *ngIf="territorialDivModelRegExError==true">A-Z 0-9 space () . , - /</span>
          </div>
        </div>
          <div class="col col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 pr-0">
            <label class="label-control">Latitude :</label>
            <p style="position: relative;padding: 0;">
              <span style="width: 18%;display: inline-block;">
                <input id="latitude_degres__3" type="text" (keyup)="dmsversdd()" class="form-control form-control-sm form-control-paddings pr-1" [(ngModel)]="latDegVal">

              </span>
              <label class="font-weight-bold" style="position: absolute;top: 0;" for="latitude_degres">&deg;</label>&nbsp;
              <span style="width: 18%;display: inline-block;">
                <input id="latitude_minutes__3" type="text" (keyup)="dmsversdd()" class="form-control form-control-sm form-control-paddings pr-1" [(ngModel)]="latMinVal">

              </span>
              <label class="font-weight-bold" style="position: absolute;top: 0;" for="latitude_minutes">'</label>&nbsp;
              <span style="width: 35%;display: inline-block;">
                <input id="latitude_secondes__3" type="text" (keyup)="dmsversdd()" class="form-control form-control-sm form-control-paddings pr-1" [(ngModel)]="latSecVal">

              </span>
              <mat-label class="font-weight-bold" style="position: absolute;top: 0;" for="latitude_secondes">''</mat-label>&nbsp;
              <span style="width: 17%;display: inline-block;">
              <mat-select class="form-control form-control-sm p-0 dropdown-select" [(ngModel)]="northSouthModel" (ngModelChange)="dmsversdd()" panelClass="dropdown-panel" [disableOptionCentering]="true">
                  <mat-option value="North">N</mat-option>
                  <mat-option value="South">S</mat-option>
              </mat-select>
              </span>
            </p>
          </div>
          <div class="col col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 pr-0">
            <label class="label-control">Longitude :</label>
            <p style="position: relative;padding: 0;">
              <span style="width: 18%;display: inline-block;">
                <input id="longitude_degres__3" type="text" (keyup)="dmsversdd()" class="form-control form-control-sm form-control-paddings pr-1" [(ngModel)]="longDegVal">

              </span>
              <label class="font-weight-bold" style="position: absolute;top: 0;" for="longitude_degres">&deg;</label>&nbsp;
              <span style="width: 18%;display: inline-block;">
                <input id="longitude_minutes__3" type="text" (keyup)="dmsversdd()" class="form-control form-control-sm form-control-paddings pr-1" [(ngModel)]="longMinVal">

              </span>
              <mat-label class="font-weight-bold" style="position: absolute;top: 0;" for="longitude_secondes">''</mat-label>&nbsp;
              <span style="width: 17%;display: inline-block;">
              <mat-select class="form-control form-control-sm p-0 dropdown-select" [(ngModel)]="eastWestModel" (ngModelChange)="dmsversdd()" panelClass="dropdown-panel" [disableOptionCentering]="true">
                  <mat-option value="East">E</mat-option>
                  <mat-option value="West">W</mat-option>
              </mat-select>
              </span>
            </p>
          </div>
          <div class="form-group col col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
            <label class="label-control">Latitude
            </label>
            <div>
            <input style="padding-right: 2px;" class="form-control form-control-sm form-control-paddings" [(ngModel)]="latitudeVal"  (keyup)="ddversdms()" type="text"/>
            <span class="ng-clear-wrapper datalistClearButton" title="Clear all"><span class="ng-clear" style="background-color: #fff;" (click)="resetGpsVals('lat')" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (resetGpsVals('lat'))">×</span></span>
            </div>
          </div>

          <div class="form-group col col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
            <label class="label-control">Longitude
            </label>
            <div>
            <input style="padding-right: 2px;" class="form-control form-control-sm form-control-paddings" [(ngModel)]="longitudeVal" (keyup)="ddversdms()" type="text"/>
            <span class="ng-clear-wrapper datalistClearButton" title="Clear all"><span class="ng-clear" style="background-color: #fff;" (click)="resetGpsVals('lon')" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (resetGpsVals('lon'))">×</span></span>
            </div>
          </div>
    </section>
  </div>

  <div class="modal-footer border-0">
    <section class="bg-white no-shadow m-0" style="width: 100%;">
      <button type="button"  class="btn btn-custom btn-blue" (click)="copyGpsdata('latval')" *ngIf="roleVariableHide ==true && latitudeVal=='' && longitudeVal==''" >
        Copy city Gps data
      </button>
    <div style="float: right;">
   <button type="button" class="btn btn-custom btn-link" data-dismiss="modal"> Cancel </button>
   <button type="button" class="btn btn-custom btn-custom-sm btn-blue" (click)="updateAddressDetails()" [disabled]="disableEditAddressBtn">
    <mat-icon svgIcon="mail" class="img-btn mr-2"></mat-icon><span class="float-right"> {{saveDatas}} </span>
   </button>
  </div>
 </section>
  </div>
</div>
</div>
</div>



<div class="modal fade"  id="showNoMainEntranceModal" tabindex="-1" aria-modal="true" aria-labelledby="showNoMainEntranceModalLabel" aria-hidden="true">
<div class="modal-dialog modal-custom">
<div class="modal-content">
  <div class="modal-header border-0">
    <h6 class="modal-title font-weight-bold text-center" id="showNoMainEntranceModalLabel">
      Add Main Entrance
      <button type="button" class="close" id="closeMainEntranceSelectModal__2" #closeBtn data-dismiss="modal" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </h6>
  </div>

  <div class="modal-body">
    <section class="row m-0 bg-white no-shadow">
      <div class="section-scroll" style="height: 350px;">
        <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <label for="" class="label-control font-weight-bold h6">
            Name :
          </label>
          <table class="mt-2 border-0">
            <tbody *ngIf="labelValueArrays">
              <tr *ngFor="let leb of labelValueArrays" class="forColor">
                <td style="width: 50px;">
                  <label class="containers">
                    <input type="radio" value="{{leb}}" [(ngModel)]="inputNameForLabel" class="edit">
                    <span class="checkmark"></span>
                  </label>
                </td>
                <td style="width: 385px;">
                  <span>
                    {{leb}}
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
          <span style="color: #cb4b32;" *ngIf="inputLabelError">Please Select Value!</span>
        </div>
        <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <label class="label-control font-weight-bold h6">Geographical addresses :
          </label>
          <table class="mt-2 border-0" *ngIf="allAddressGeoData && geo1Loading==false">
            <tbody *ngIf="allAddressGeoData.length>0">
              <tr *ngFor="let geo1 of allAddressGeoData" class="forColor">
                <td style="width: 50px;">
                  <label class="containers">
                    <input style="padding-right: 2px;" value="{{geo1.rowId}}" id="geoLoc1Radio" [(ngModel)]="inputForGeo1" class="edit" type="radio" name="geolocation1">
                    <span class="checkmark"></span>
                  </label>
                </td>
                <td style="width: 185px;">
                  {{geo1.identifier}}
                </td>
                <td style="width: 200px;">
                  <div *ngIf="geo1.wayNumber || geo1.streetName">
                    <span *ngIf="geo1.wayNumber">
                      {{geo1.wayNumber}}
                    </span>
                    <span *ngIf="geo1.wayNumber && geo1.streetName">,</span>
                    <span *ngIf="geo1.streetName">
                    {{geo1.streetName}}
                    </span>
                  </div>
                  <div>
                    {{geo1.additionalInformation}}
                  </div>
                  <div>
                    <span *ngIf="geo1.postalCode" class="font-weight-bold">Postal Code:</span>
                    <span>{{geo1.postalCode}}</span>
                  </div>
                  <div>
                    <span *ngIf="geo1.territorialDivision" class="font-weight-bold">Territorial Division :</span>
                    <span>{{geo1.territorialDivision}}</span>
                  </div>
                </td>
              </tr>
            </tbody>
            <tbody *ngIf="allAddressGeoData.length==0" class="font-weight-bold text-center">
              No Results Found
            </tbody>
          </table>
          <span style="color: #cb4b32;" *ngIf="geo1AddressError">Please Select a Value!</span>
          <span *ngIf="geo1Loading">
            <img src="assets/images/loading.gif" alt="loading...">
          </span>
        </div>

        <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <label class="label-control font-weight-bold h6"> Postal addresses :
          </label>
            <table class="mt-2 border-0" *ngIf="allAddressPostalData && geo2Loading==false">
              <tbody *ngIf="allAddressPostalData.length>0">
                <tr *ngFor="let geo2 of allAddressPostalData" class="forColor">
                  <td style="width: 50px;">
                    <label class="containers">
                      <input style="padding-right: 2px;" value="{{geo2.rowId}}" [(ngModel)]="inputForGeo2" class="edit" type="radio" name="geolocation2">
                      <span class="checkmark"></span>
                    </label>
                  </td>
                  <td style="width: 185px;">
                    <span>
                      {{geo2.identifier}}
                    </span>
                  </td>
                  <td style="width: 200px;">
                    <ng-container>
                      <div *ngIf="geo2.line1">
                        {{geo2.line1}}
                      </div>
                      <div *ngIf="geo2.line2">
                        {{geo2.line2}}
                      </div>
                      <div *ngIf="geo2.line3">
                        {{geo2.line3}}
                      </div>
                      <div *ngIf="geo2.line4">
                        {{geo2.line4}}
                      </div>
                      <div *ngIf="geo2.line5">
                        {{geo2.line5}}
                      </div>
                      <div *ngIf="geo2.line6">
                        {{geo2.line6}}
                      </div>
                      <div *ngIf="geo2.line7">
                        {{geo2.line7}}
                      </div>
                    </ng-container>
                  </td>
                </tr>
              </tbody>
              <tbody *ngIf="allAddressPostalData.length==0" class="font-weight-bold text-center">
                No Results Found
              </tbody>
            </table>

            <span *ngIf="geo2Loading">
              <img src="assets/images/loading.gif" alt="loading...">
            </span>
        </div>

        <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <label class="label-control font-weight-bold h6">Geolocation coordinates :
          </label>
            <table class="mt-2 border-0" *ngIf="allAddressGeoLocData && geo3Loading==false">
              <tbody *ngIf="allAddressGeoLocData.length>0">
                <tr *ngFor="let geo3 of allAddressGeoLocData" class="forColor">
                  <td style="width: 50px;">
                    <label class="containers">
                      <input style="padding-right: 2px;" value="{{geo3.rowId}}" [(ngModel)]="inputForGeo3" class="edit" type="radio" name="geolocation3">
                      <span class="checkmark"></span>
                    </label>
                  </td>
                  <td style="width: 185px;">
                    <span>
                      {{geo3.identifier}}
                    </span>
                  </td>
                  <td style="width: 200px;">
                    <span>
                      {{geo3.coordinates}}
                    </span>
                  </td>
                </tr>
              </tbody>
              <tbody *ngIf="allAddressGeoLocData.length==0" class="font-weight-bold text-center">
                No Results Found
              </tbody>
            </table>
            <span style="color: #cb4b32;" *ngIf="geo3AddressError">Please Select a Value!</span>
            <span *ngIf="geo3Loading">
              <img src="assets/images/loading.gif" alt="loading...">
            </span>
        </div>
      </div>
    </section>
  </div>

  <div class="modal-footer border-0">
    <section class="bg-white no-shadow m-0" >
      <button type="button" class="btn btn-custom btn-link" data-dismiss="modal"> Cancel </button>
      <button type="button" class="btn btn-custom btn-custom-sm btn-blue" (click)="createMainEntraceAcp()"> Copy </button>
    </section>
  </div>
</div>
</div>
</div>



<div class="modal fade"  id="showWarningForAddQualifier" tabindex="-1" aria-modal="true" aria-labelledby="showWarningForAddQualifierLabel" aria-hidden="true">
<div class="modal-dialog modal-custom">
<div class="modal-content">
  <div class="modal-header border-0">
    <h6 class="modal-title font-weight-bold text-center" id="showWarningForAddQualifierLabel">
      Warning
      <button type="button" class="close" id="closeMainEntranceSelectModal__2" #closeBtn data-dismiss="modal" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </h6>
  </div>

  <div class="modal-body">
    <section class="row m-0 bg-white no-shadow">
      <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
        <p class="font-weight-bold text-center h6">
          It is neccesary to link the Site to a
        </p>
        <p class="font-weight-bold text-center h6">
          Company prior to add Qualifiers
        </p>
      </div>
      <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 m-0">
        <p class="font-weight-bold text-center h6">
          Thank You
        </p>
      </div>
    </section>
  </div>

  <div class="modal-footer border-0">
    <section class="bg-white no-shadow m-0" >
      <button type="button" class="btn btn-custom btn-link" data-dismiss="modal"> Cancel </button>
      <button type="button" class="btn btn-custom btn-custom-sm btn-blue" data-dismiss="modal"> OK </button>
    </section>
  </div>
</div>
</div>
</div>



<div class="modal fade"  id="showWarningNoMainEntrance" tabindex="-1" aria-modal="true" aria-labelledby="showWarningNoMainEntranceLabel" aria-hidden="true">
<div class="modal-dialog modal-custom">
  <div class="modal-content">
    <div class="modal-header border-0">
      <h6 class="modal-title font-weight-bold text-center" id="showWarningNoMainEntranceLabel">
      Warning
      <button type="button" class="close" id="closeMainEntranceSelectModal" #closeBtn data-dismiss="modal" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
      </h6>
    </div>

    <div class="modal-body">
      <section class="row m-0 bg-white no-shadow" *ngIf="showParam=='mainEntrance'">
        <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <p class="font-weight-bold text-center h6">
            It is neccesary to add a Main Entrance to
          </p>
          <p class="font-weight-bold text-center h6">
            the Site prior to link it to a Company
          </p>
        </div>
        <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 m-0">
          <p class="font-weight-bold text-center h6">
            Thank You
          </p>
        </div>
      </section>

      <section class="row m-0 bg-white no-shadow" *ngIf="showParam=='existAlcor'">
        <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <p class="font-weight-bold text-center h6">
            This Site is already associated to an ALCOR code,
          </p>
          <p class="font-weight-bold text-center h6">
            please update the Company link using Look for Sites
          </p>
        </div>
        <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 m-0">
          <p class="font-weight-bold text-center h6">
            Thank You
          </p>
        </div>
      </section>
    </div>

    <div class="modal-footer border-0">
      <section class="bg-white no-shadow m-0" >
        <button type="button" class="btn btn-custom btn-link" data-dismiss="modal"> Cancel </button>
        <button type="button" class="btn btn-custom btn-custom-sm btn-blue" data-dismiss="modal"> OK </button>
      </section>
    </div>
  </div>
</div>
</div>



<div class="modal fade"  id="showNotAllArchived" tabindex="-1" aria-modal="true" aria-labelledby="showNotAllArchivedLabel" aria-hidden="true">
<div class="modal-dialog modal-custom">
<div class="modal-content">
  <div class="modal-header border-0">
    <h6 class="modal-title font-weight-bold text-center" id="showNotAllArchivedLabel">
      Warning
      <button type="button" class="close" id="closeNotAllArchived" #closeBtn data-dismiss="modal" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </h6>
  </div>

  <div class="modal-body">
    <section class="row m-0 bg-white no-shadow">
      <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
        <p class="font-weight-bold text-center h6">
          Prior to archive a site, please archive all its qualifiers
        </p>
      </div>
      <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 m-0">
        <p class="font-weight-bold text-center h6">
          Thank You
        </p>
      </div>
    </section>
  </div>

  <div class="modal-footer border-0">
    <section class="bg-white no-shadow m-0" >
      <button type="button" class="btn btn-custom btn-link" data-dismiss="modal"> Cancel </button>
      <button type="button" class="btn btn-custom btn-custom-sm btn-blue" data-dismiss="modal"> OK </button>
    </section>
  </div>
</div>
</div>
</div>



<div class="modal fade"  id="AddnewSiteContacts" tabindex="-1" aria-modal="true" aria-labelledby="AddnewSiteContactsLabel" aria-hidden="true">
<div class="modal-dialog modal-custom">
  <div class="modal-content">
    <div class="modal-header border-0">
      <h6 class="modal-title font-weight-bold text-center" id="AddnewSiteContactsLabel">
        Add Site Contact
        <button type="button" class="close" id="closeSiteContacts" #closeBtn data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </h6>
    </div>

    <div class="modal-body">
      <div class="mb-2 pl-3"> <span style="font-weight: bold;">Site : </span>  {{ siteName ? siteName : '' }} </div>
      <section class="row m-0 bg-white no-shadow">

        <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-0" >
          <label class="label-control">Email<span style="color:#cb4b32;">*</span></label>
          <input type="email" class="form-control form-control-sm" [(ngModel)]="SiteConEmail"  (change)="checkEmailChanged()" (keyup)="SiteCntemptyCheck('Email')" (focusout)="focusOutFunctionEmail()" [disabled]="disableEmail==true">
          <span class="ng-clear-wrapper datalistClearButton" title="Clear"><span class="ng-clear" (click)="resetSiteContact('Email')" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (resetSiteContact('Email'))">×</span></span>
          <span style="color: #cb4b32;" *ngIf="SiteConEmailError==true">Please Enter the Email.</span>
          <span style="color: #cb4b32;" *ngIf="SiteConEmailFormatError==true">Please Enter a Valid Email.</span>


        </div>

        <div class="mb-2 pl-3 col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12" *ngIf="site_modelLabelName"> <span style="font-weight: bold;">Name : </span>  {{ siteModelName}} </div>
        <div class="mb-2 pl-3 col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12" *ngIf="site_modelIpn"> <span style="font-weight: bold;">IPN : </span>  {{ siteModelIpn }} </div>

        <div class="col col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6" *ngIf="site_modelFname">
          <label class="label-control">First Name<span style="color:#cb4b32;">*</span></label>
          <input type="text" autocomplete="off" class="form-control form-control-sm" [(ngModel)]="SiteConFname" (keyup)="SiteCntemptyCheck('Fname')" >
          <span class="ng-clear-wrapper datalistClearButton" title="Clear"><span class="ng-clear" (click)="resetSiteContact('Fname')" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (resetSiteContact('Fname'))">×</span></span>
          <span style="color: #cb4b32;" *ngIf="CmpConFnameError==true">Please Enter the First Name.</span>
        </div>

        <div class="col col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6" *ngIf="site_modelLname">
          <label class="label-control">Last Name<span style="color:#cb4b32;">*</span></label>
          <input type="text" class="form-control form-control-sm" [(ngModel)]="SiteConLname" (keyup)="SiteCntemptyCheck('Lname')"  >
          <span class="ng-clear-wrapper datalistClearButton" title="Clear"><span class="ng-clear" (click)="resetSiteContact('Lname')" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (resetSiteContact('Lname'))">×</span></span>
          <span style="color: #cb4b32;" *ngIf="CmpConLnameError==true">Please Enter the Last Name.</span>
        </div>

        <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-0" *ngIf="site_modelCellphone">
          <label class="label-control">Cellphone
          </label>
          <input type="text" class="form-control form-control-sm" [(ngModel)]="SiteConCellphone" (keyup)="SiteCntemptyCheck('Cellphone')">
          <span class="ng-clear-wrapper datalistClearButton" title="Clear"><span class="ng-clear" (click)="resetSiteContact('Cellphone')" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (resetSiteContact('Cellphone'))">×</span></span>
          <span style="color: #cb4b32;" *ngIf="SiteConCellphoneError==true">Please Enter the Cellphone value.</span>
          <span style="color: #cb4b32;" *ngIf="SiteConCellphoneError2==true">Cellphone value is not valid.</span>
        </div>

        <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-0" *ngIf="site_modelPhone">
          <label class="label-control">Phone
          </label>
          <input type="text" class="form-control form-control-sm" [(ngModel)]="SiteConPhone" (keyup)="SiteCntemptyCheck('Phone')">
          <span class="ng-clear-wrapper datalistClearButton" title="Clear"><span class="ng-clear" (click)="resetSiteContact('Phone')" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (resetSiteContact('Phone'))">×</span></span>
          <span style="color: #cb4b32;" *ngIf="SiteConPhoneError==true">Please Enter the Phone value.</span>
          <span style="color: #cb4b32;" *ngIf="SiteConPhoneError2==true">Phone value is not valid.</span>
        </div>

        <div class="col col-12 col-sm-12 col-md-12 col-lg-6 col-xl-12" *ngIf="site_modelRole">
          <mat-label class="label-control">Role<span style="color:#cb4b32;">*</span></mat-label>
          <mat-select class="form-control form-control-sm" [(ngModel)]="SiteConRole" (selectionChange)="SiteCntRoleSelected($event)" panelClass="dropdown-panel" [disableOptionCentering]="true">
            <ng-container *ngIf="PersonRoleSelectOp.length>0"></ng-container>
            <mat-option *ngFor="let pRole of PersonRoleSelectOp" [value]="pRole.row_id">{{pRole.label}}</mat-option>
          </mat-select>
          <span style="color: #cb4b32;" *ngIf="siteConRoleError==true">Please Select the Role.</span>
          <span style="color: #cb4b32;" *ngIf="siteConRoleexists==true">The Role already for this user</span>

        </div>
      </section>
    </div>

    <div class="modal-footer border-0">
      <section class="bg-white no-shadow m-0">
        <button type="button" class="btn btn-custom btn-link" data-dismiss="modal"> Cancel </button>
        <button type="button" class="btn btn-custom btn-custom-sm btn-blue" (click)="AddEditSaveSiteCnt('add')" *ngIf="site_ShowSave">
          <mat-icon svgIcon="mail" class="img-btn mr-2"></mat-icon><span class="float-right"> {{saveDatas}} </span>
        </button>

        <button type="button" class="btn btn-custom btn-custom-sm btn-blue" (click)="AddEditSaveSiteCnt('next')"  *ngIf="site_ShowNext">
          Next
        </button>
      </section>
    </div>
  </div>
</div>
</div>



<div class="modal fade"  id="openContactAndRole" tabindex="-1" aria-modal="true" aria-labelledby="openContactAndRoleLabel" aria-hidden="true" >
<div class="modal-dialog modal-custom">
  <div class="modal-content">
    <div class="modal-header border-0">
      <h6 class="modal-title font-weight-bold text-center" id="openContactAndRoleLabel">
        Contact
        <button type="button" class="close" id="closeContactAndRole" #closeBtn data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </h6>
    </div>

    <div class="modal-body pb-1">
      <div class="mb-2">
        <button type="button" class="openContactAndRole" (click)="switchVisible('btn1')" [ngClass]="{ 'btnCss' : openData == true}">
           DATA
        </button>
        <button type="button" class="openContactAndRole" (click)="switchVisible('btn2')" [ngClass]="{ 'btnCss' : openRole == true}">
           ROLE
        </button>
      </div>

      <div *ngIf="openData==true">
        <div class="row mb-2 pl-3"> <span class="pr-2" style="font-weight: bold;padding-left:15px;">Name : </span>  <span class="pl-1">{{ SiteConFname ? SiteConFname : '' }} {{ SiteConLname ? SiteConLname : '' }}</span>
          <span class="col edit pl-2" *ngIf="(((roleVariableHide || roleIsManager || showBuyerProfile==false) && CmpConIpn==''  ) || superUserShow==true || showForSupplier==false)  && endDateisPresent ==false">
            <mat-icon svgIcon="edit" alt="edit" data-toggle="modal" data-target="#editSiteConNameDetails" (click)="setEditConDetails('name')" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (setEditConDetails('name'))"></mat-icon> </span>
        </div>
        <div class="mb-3 pl-3"> <span style="font-weight: bold;">Email : </span>  {{ SiteConEmail ? SiteConEmail : '' }} </div>
        <div class="mb-3 pl-3" *ngIf="endDateisPresent==true"> <span style="font-weight: bold;">IPN : </span>  {{ SiteConIpn ? SiteConIpn : '' }} </div>
        <div class="mb-3 pl-3" *ngIf="cellPhoneEdit==false"> <span class="pr-2" style="font-weight: bold;">Cellphone : </span>
          <span class="pl-1">{{ SiteConCellphone ? SiteConCellphone : '' }}</span>
          <span class="col edit pl-2" *ngIf="(((roleVariableHide || roleIsManager || showBuyerProfile==false) && CmpConIpn=='') || superUserShow==true || showForSupplier==false)&& endDateisPresent ==false">
             <mat-icon svgIcon="edit" alt="edit" (click)="setEditConDetails('cellPhone')" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (setEditConDetails('cellPhone'))"></mat-icon>
            </span>
        </div>
        <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12" *ngIf="cellPhoneEdit==true">
          <label class="label-control" style="font-weight: bold;">Cellphone : </label>
          <input type="text" class="form-control form-control-sm" [(ngModel)]="SiteConCellphone" (keyup)="SiteCntemptyCheck('Cellphone')">
          <span class="ng-clear-wrapper datalistClearButton" title="Clear"><span class="ng-clear" (click)="resetSiteContact('Cellphone')" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (resetSiteContact('Cellphone'))">×</span></span>
          <span style="color: #cb4b32;" *ngIf="SiteConCellphoneError==true">Please Enter the Cellphone value.</span>
          <span style="color: #cb4b32;" *ngIf="SiteConCellphoneError2==true">Cellphone value is not valid.</span>
          <section class="bg-white no-shadow m-0 d-flex justify-content-end align-items-center">
            <button type="button" class="btn btn-custom btn-link" (click)="toggleSiteConEdit()"> Cancel </button>
            <span>|</span>
            <button type="button" class="btn btn-custom btn-link" (click)="editSiteConDetails('phone')"> Save </button>
          </section>
        </div>

        <div class="row mb-2 pl-3"  *ngIf="fixedPhoneEdit==false"> <span class="pr-2" style="font-weight: bold;padding-left:15px;">Phone : </span>
          <span class="pl-1">{{ SiteConPhone ? SiteConPhone : '' }} </span>
          <span class="col edit pl-2" *ngIf="(((roleVariableHide || roleIsManager || showBuyerProfile==false) && CmpConIpn=='') || superUserShow==true || showForSupplier==false) && endDateisPresent ==false">
            <mat-icon svgIcon="edit" alt="edit" (click)="setEditConDetails('fixedPhone')" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (setEditConDetails('fixedPhone'))"></mat-icon>
          </span>
        </div>
        <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-0" *ngIf="fixedPhoneEdit==true">
          <label class="label-control" style="font-weight: bold;">Phone : </label>
          <input type="text" class="form-control form-control-sm" [(ngModel)]="SiteConPhone" (keyup)="SiteCntemptyCheck('Phone')">
          <span class="ng-clear-wrapper datalistClearButton" title="Clear"><span class="ng-clear" (click)="resetSiteContact('Phone')" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (resetSiteContact('Phone'))">×</span></span>
          <span style="color: #cb4b32;" *ngIf="SiteConPhoneError==true">Please Enter the Phone value.</span>
          <span style="color: #cb4b32;" *ngIf="SiteConPhoneError2==true">Phone value is not valid.</span>
          <section class="bg-white no-shadow m-0 d-flex justify-content-end align-items-center">
            <button type="button" class="btn btn-custom btn-link" (click)="toggleSiteConEdit()"> Cancel </button>
            <span>|</span>
            <button type="button" class="btn btn-custom btn-link" (click)="editSiteConDetails('phone')"> Save </button>
          </section>
        </div>
      </div>

      <div *ngIf="openRole==true">
        <div class="mb-3 pl-3"> <span style="font-weight: bold;">Company : </span>  {{ businessEntityCompanyLegalName }} </div>
        <div class="mb-3 pl-3"> <span style="font-weight: bold;">Site : </span>  {{ siteName ? siteName : '' }} </div>
        <div class="mb-3 pl-3"> <span style="font-weight: bold;">Name : </span>  {{ SiteConFname ? SiteConFname : '' }} {{ SiteConLname ? SiteConLname : '' }}</div>
        <div class="mb-3 pl-3"> <span style="font-weight: bold;">Email : </span>  {{ SiteConEmail ? SiteConEmail : '' }} </div>
        <div class="mb-3 pl-3" *ngIf="SiteConIpn!='' "> <span style="font-weight: bold;">IPN : </span>  {{ SiteConIpn ? SiteConIpn : '' }} </div>
        <section class="row m-0 bg-white no-shadow">
          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-6 col-xl-12">
            <mat-label class="label-control" style="font-weight: bold;">Role
            </mat-label>
            <mat-select class="form-control form-control-sm dropdown-select" [disabled]="disableContactRoleEdit==true" [(ngModel)]="SiteConRole" (selectionChange)="SiteCntRoleSelected($event)" panelClass="dropdown-panel" [disableOptionCentering]="true">
              <ng-container *ngIf="PersonRoleSelectOp.length>0"></ng-container>
              <mat-option *ngFor="let pRole of PersonRoleSelectOp" [value]="pRole.row_id">{{pRole.label}}</mat-option>
            </mat-select>
            <span style="color: #cb4b32;" *ngIf="SiteConRoleError==true">Please Select the Role.</span>
          </div>
        </section>
      </div>
    </div>

    <div class="modal-footer border-0 m-0" *ngIf="openData==true">
      <section class="bg-white no-shadow m-0">
        <button type="button" style="background: #cb4b32;margin-right: 245px;" class="btn btn-custom btn-custom-sm btn-red" data-toggle="modal" data-target="#DeleteContact" *ngIf="roleVariableHide || superUserShow || roleIsManager || showBuyerProfile==false">
          <mat-icon svgIcon="delete" class="img-btn mr-2"></mat-icon><span class="float-right"> Delete Contact </span>
        </button>
        <button type="button" class="btn btn-custom btn-custom-sm btn-blue" data-dismiss="modal"> Close </button>
      </section>
    </div>

    <div class="modal-footer border-0 m-0" *ngIf="openRole==true">
      <section class="bg-white no-shadow m-0">
        <button type="button" style="background: #cb4b32;margin-right: 180px;" class="btn btn-custom btn-custom-sm btn-red" data-toggle="modal" data-target="#ccompanyContactRemoveModalPopup" *ngIf="roleVariableHide || superUserShow || roleIsManager || showBuyerProfile==false">
          <mat-icon svgIcon="delete" class="img-btn mr-2"></mat-icon> <span class="float-right"> Delete Role </span></button>
        <button type="button" class="btn btn-custom btn-link"  data-dismiss="modal"> Cancel </button>
        <button type="button" class="btn btn-custom btn-custom-sm btn-blue"   (click)="AddEditSaveSiteCnt('edit')">
          <mat-icon svgIcon="mail" class="img-btn mr-2"></mat-icon><span class="float-right"> {{saveDatas}} </span>
        </button>
      </section>
    </div>
  </div>
</div>
</div>



<div class="modal fade"  id="editSiteConNameDetails" tabindex="-1" aria-modal="true" aria-labelledby="editSiteConNameDetailsLabel" aria-hidden="true">
<div class="modal-dialog modal-custom">
  <div class="modal-content">
    <div class="modal-header border-0">
      <h6 class="modal-title font-weight-bold text-center" id="editSiteConNameDetailsLabel">
        Edit Contact Name
        <button type="button" class="close" id="closeEditSiteConNameDetails" #closeBtn data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </h6>
    </div>

    <div class="modal-body pb-1">
      <section class="row m-0 bg-white no-shadow">
        <div class="form-grroup col col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 mb-0">
          <label class="label-control" style="font-weight: bold;">First Name<span style="color:#cb4b32;">*</span></label>
          <input type="text" autocomplete="off" class="form-control form-control-sm" [(ngModel)]="editSiteConFname" (keyup)="SiteEditCntemptyCheck('Fname')">
          <span class="ng-clear-wrapper datalistClearButton" title="Clear"><span class="ng-clear" (click)="resetSiteEditContact('Fname')" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (resetSiteEditContact('Fname'))">×</span></span>
          <span style="color: #cb4b32;" *ngIf="SiteConFnameError==true">Please Enter the First Name.</span>
        </div>

        <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 mb-0">
          <label class="label-control" style="font-weight: bold;">Last Name<span style="color:#cb4b32;">*</span></label>
          <input type="text" class="form-control form-control-sm" [(ngModel)]="editSiteConLname" (keyup)="SiteEditCntemptyCheck('Lname')">
          <span class="ng-clear-wrapper datalistClearButton" title="Clear"><span class="ng-clear" (click)="resetSiteEditContact('Lname')" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (resetSiteEditContact('Lname'))">×</span></span>
          <span style="color: #cb4b32;" *ngIf="SiteConLnameError==true">Please Enter the Last Name.</span>
        </div>
      </section>
    </div>

    <div class="modal-footer border-0 m-0">
      <section class="bg-white no-shadow m-0">
        <button type="button" class="btn btn-custom btn-link" data-dismiss="modal"> Cancel </button>
        <button type="button" class="btn btn-custom btn-custom-sm btn-blue" (click)="editSiteConDetails('name')">
          <mat-icon svgIcon="mail" class="img-btn mr-2"></mat-icon><span class="float-right"> {{saveDatas}} </span>
        </button>
      </section>
    </div>
  </div>
</div>
</div>



<div class="modal fade"  id="DeleteContact" tabindex="-1" aria-modal="true" aria-labelledby="DeleteContactLabel" aria-hidden="true">
<div class="modal-dialog modal-custom">
  <div class="modal-content">
    <div class="modal-header border-0">
      <h6 class="modal-title font-weight-bold text-center" id="DeleteContactLabel">
        Delete Contact
        <button type="button" class="close" id="closeDelCont" #closeBtn data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </h6>
    </div>

    <div class="modal-body">
      <section class="row m-0 bg-white no-shadow">
        <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <label class="label-control" style="font-size: 14px;font-weight: bold;margin-bottom: 7px;"> Do you want to delete this contact?</label>
        </div>
      </section>
    </div>

    <div class="modal-footer border-0">
      <section class="bg-white no-shadow m-0">
        <button type="button" class="btn btn-custom btn-link" data-dismiss="modal"> Cancel </button>
        <button type="button" class="btn btn-custom btn-custom-sm btn-orange" style="background-color: #cb4b32;" (click)="delContact()">
          <img src="assets/images/del-wt-sm.png" class="img-btn mr-2"> Delete
        </button>
      </section>
    </div>
  </div>
</div>
</div>



<div class="modal fade"  id="ccompanyContactRemoveModalPopup" tabindex="-1" aria-modal="true" aria-labelledby="ccompanyContactRemoveModalPopupLabel" aria-hidden="true">
<div class="modal-dialog modal-custom">
  <div class="modal-content">
    <div class="modal-header border-0">
      <h6 class="modal-title font-weight-bold text-center" id="ccompanyContactRemoveModalPopupLabel">
        Remove Role for this Site
        <button type="button" class="close" id="closeCCBtn__2" #closeBtn data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </h6>
    </div>

    <div class="modal-body">
      <section class="row m-0 bg-white no-shadow">
        <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <label class="label-control" style="font-size: 15px; font-weight: bold;">Do you want to remove this role for this Site? </label>
        </div>
      </section>
    </div>

    <div class="modal-footer border-0">
      <section class="bg-white no-shadow m-0">
        <button type="button" class="btn btn-custom btn-link" data-dismiss="modal"> Cancel </button>
        <button type="button" class="btn btn-custom btn-custom-sm btn-orange" style="background-color: #cb4b32;" (click)="delRole()">
          <img src="assets/images/mail-wt.png" class="img-btn mr-2"> {{removeDatas}}
        </button>
      </section>
    </div>
  </div>
</div>
</div>



<div class="modal fade"  id="openWarningForRoleUpdate" tabindex="-1" aria-modal="true" aria-labelledby="openWarningForRoleUpdateLabel" aria-hidden="true">
<div class="modal-dialog modal-custom">
  <div class="modal-content" style="margin-left: -4px;">
    <div class="modal-header border-0">
      <h6 class="modal-title font-weight-bold text-center" id="openWarningForRoleUpdateLabel">
        Warning
        <button type="button" class="close" id="closeArchiveCpy" #closeBtn data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </h6>
    </div>

    <div class="modal-body">
      <section class="row m-0 bg-white no-shadow">
        <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <p class="font-weight-bold text-center h6">
            The Role selected already exists for the person.
          </p>
        </div>
      </section>
    </div>

    <div class="modal-footer border-0">
      <section class="bg-white no-shadow m-0" >
        <button type="button" class="btn btn-custom btn-custom-sm btn-blue" data-dismiss="modal"> OK </button>
      </section>
    </div>
  </div>
</div>
</div>


<div class="modal fade"  id="editRaftNameValModal" tabindex="-1" aria-modal="true" aria-labelledby="editRaftNameValModalLabel" aria-hidden="true">
<div class="modal-dialog modal-custom">
 <div class="modal-content">
   <div class="modal-header border-0">
     <h6 class="modal-title font-weight-bold text-center" id="editRaftNameValModalLabel">
      Edit Raft Name by <span class="label-darkblue">ADMIN</span>
       <button type="button" class="close" id="closeEditRaftName" #closeBtn data-dismiss="modal" aria-label="Close">
         <span aria-hidden="true">&times;</span>
       </button>
     </h6>
   </div>

   <div class="modal-body">
     <section class="row m-0 bg-white no-shadow">
       <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
         <label class="label-control">RAFT Name:
         </label>
          <input style="padding-right: 2px;" class="form-control form-control-sm form-control-paddings" disabled value="{{raftNameHolder}}" type="text"/>
       </div>
     </section>
    </div>

    <div class="modal-footer border-0 row">
      <section class="bg-white no-shadow col m-0">
        <button class="btn btn-custom btn-custom-sm btn-blue mr-3" (click)="updateRaftName(raftNameHolder,editRaftAliasModel)" [disabled]="disableEditRaftNameBtn==true">
          <mat-icon class="img-btn pb-1 pt-1 px-0 mr-2" svgIcon="edit" alt="edit"></mat-icon>
          <span class="float-right">
          Update
        </span>
        </button>
        <button type="button" class="btn btn-custom btn-link float-right" data-dismiss="modal"> Close </button>

      </section>
    </div>
 </div>
</div>
</div>



<div class="modal fade"  id="showNoShortNameOrCityModal" tabindex="-1" aria-modal="true" aria-labelledby="showNoShortNameOrCityModalLabel" aria-hidden="true">
<div class="modal-dialog modal-custom">
  <div class="modal-content">
    <div class="modal-header border-0">
      <h6 class="modal-title font-weight-bold text-center" id="showNoShortNameOrCityModalLabel">
        Warning
        <button type="button" class="close" id="closeNoShortNameOrCity__2" #closeBtn data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </h6>
    </div>

    <div class="modal-body">
      <section class="row m-0 bg-white no-shadow">
        <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <p class="font-weight-bold text-center h6" *ngIf="showNoCompanyShortName">
            Company Short Name is null.
          </p>
          <p class="font-weight-bold text-center h6" *ngIf="showNoSiteCity">
            City is null.
          </p>
        </div>
      </section>
    </div>

    <div class="modal-footer border-0">
      <section class="bg-white no-shadow m-0" >
        <button type="button" class="btn btn-custom btn-link" data-dismiss="modal"> Cancel </button>
        <button type="button" class="btn btn-custom btn-custom-sm btn-blue" data-dismiss="modal"> OK </button>
      </section>
    </div>
  </div>
</div>
</div>



<div class="modal fade"  id="showBvdIdStatus" tabindex="-1" aria-modal="true" aria-labelledby="showBvdIdStatusLabel" aria-hidden="true">
<div class="modal-dialog modal-custom">
  <div class="modal-content">
    <div class="modal-header border-0">
      <h6 class="modal-title font-weight-bold text-center" id="showBvdIdStatusLabel">
        Warning
        <button type="button" class="close" id="closeNoShortNameOrCity" #closeBtn data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </h6>
    </div>

    <div class="modal-body">
      <section class="row m-0 bg-white no-shadow">
        <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <p class="font-weight-bold text-center h6">
            {{bvdIdStatusText}}
          </p>
        </div>
      </section>
    </div>

    <div class="modal-footer border-0">
      <section class="bg-white no-shadow m-0" >
        <button type="button" class="btn btn-custom btn-link" data-dismiss="modal"> Cancel </button>
        <button type="button" class="btn btn-custom btn-custom-sm btn-blue" data-dismiss="modal"> OK </button>
      </section>
    </div>
  </div>
</div>
</div>



<div class="modal fade"  id="showSameCpyLink" tabindex="-1" aria-modal="true" aria-labelledby="showSameCpyLinkLabel" aria-hidden="true">
<div class="modal-dialog modal-custom">
  <div class="modal-content">
    <div class="modal-header border-0">
      <h6 class="modal-title font-weight-bold text-center" id="showSameCpyLinkLabel">
        Warning
        <button type="button" class="close" id="closeNoShortNameOrCity__3" #closeBtn data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </h6>
    </div>

    <div class="modal-body">
      <section class="row m-0 bg-white no-shadow">
        <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <p class="font-weight-bold text-center h6">
            The Site is already linked to this Company.
          </p>
        </div>
      </section>
    </div>

    <div class="modal-footer border-0">
      <section class="bg-white no-shadow m-0" >

        <button type="button" class="btn btn-custom btn-custom-sm btn-blue" data-dismiss="modal"> OK </button>
      </section>
    </div>
  </div>
</div>
</div>



<div class="modal fade" id="openEditShortModal" tabindex="-1" aria-modal="true" aria-labelledby="openEditShortModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-custom">
    <div class="modal-content">
      <div class="modal-header border-0">
        <h6 class="modal-title font-weight-bold text-center" id="openEditShortModalLabel">Edit Site Short Name
        <button type="button" class="close" id="closeEditShortModal" #closeBtn data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
        </h6>
      </div>
      <div class="modal-body">
        <section class="row m-0 bg-white no-shadow">
          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
         <label class="label-control">Site Short Name
         </label>
         <input
            style="padding-right: 2px;"
            class="form-control form-control-sm form-control-paddings"
            [(ngModel)]="editNameModel"
            (keyup)="checkForShortName()"
            (ngModelChange)="editNameModel = $event.toUpperCase()" />
              <span class="ng-clear-wrapper datalistClearButton" title="Clear all"><span class="ng-clear" style="background-color: #fff;" (click)="resetBvdId('name')" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (resetBvdId('name'))">×</span></span>
              <span style="color: #cb4b32;" *ngIf="editNameModelError==true">Please Enter Site Short Name!!!</span>
          </div>
        </section>
      </div>
      <div class="modal-footer border-0">
        <section class="bg-white no-shadow m-0">
          <button type="button" class="btn btn-custom btn-link" data-dismiss="modal"> Cancel </button>
          <button type="button" class="btn btn-custom btn-custom-sm btn-blue" (click)="saveNewName()">
           <mat-icon svgIcon="mail" class="img-btn mr-2"></mat-icon><span class="float-right"> {{saveDatas}} </span>
          </button>
        </section>
      </div>
    </div>
  </div>
</div>



  <div class="modal fade"  id="openEditTaxIdentifiers" tabindex="-1" aria-modal="true" aria-labelledby="openEditTaxIdentifiersLabel" aria-hidden="true">
    <div class="modal-dialog modal-custom">
     <div class="modal-content">
       <div class="modal-header border-0">
         <h6 class="modal-title font-weight-bold text-center" id="openEditTaxIdentifiersLabel">
          Edit Tax Identifiers by <span class="label-darkblue">ADMIN</span>
           <button type="button" class="close" id="closetaxmodal" #closeBtn data-dismiss="modal" aria-label="Close">
             <span aria-hidden="true">&times;</span>
           </button>
         </h6>
       </div>

       <div class="modal-body">
         <section class="row m-0 bg-white no-shadow">
           <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
             <label class="label-control">Tax ID
             </label>
              <input
                style="padding-right: 2px;"
                class="form-control form-control-sm form-control-paddings"
                [(ngModel)]="taxIdModel"
                type="text"
                (keyup)="checkForBvdId(editBvdIdValueModel,'editBvdIdValueModel','editBvdIdModalError')"
                (ngModelChange)="taxIdModel = $event.toUpperCase()" />
             <span class="ng-clear-wrapper datalistClearButton" title="Clear all"><span class="ng-clear" style="background-color: #fff;"  (click)="resetBvdId('bvdid')" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (resetBvdId('bvdid'))">×</span></span>

           </div>
         </section>
       </div>

       <div class="modal-footer border-0">
         <section class="bg-white no-shadow m-0 w-100">
          <button type="button" style="background-color: #ec051d" class="btn btn-custom btn-custom-sm mr-1" data-target="#CnfDeleteTaxId"  data-toggle="modal" >
            <mat-icon svgIcon="delete" class="mr-1 pb-1" alt="DEL"></mat-icon>
            <span class="float-right">
                Delete
            </span>
          </button>
          <button type="button" class="btn btn-custom btn-custom-sm btn-blue" (click)="openCnfArchiveTaxModal('archive')" *ngIf="showArchivedTax==false">
            Archive
          </button>
          <button type="button" class="btn btn-custom btn-custom-sm btn-blue" (click)="openCnfArchiveTaxModal('unarchive')" *ngIf="showArchivedTax==true">
            Unarchive
          </button>
          <article class="float-right">
           <button type="button" class="btn btn-custom btn-link" data-dismiss="modal"> Cancel </button>
           <button type="button" class="btn btn-custom btn-custom-sm btn-blue"  (click)="saveTaxId()">
             <mat-icon svgIcon="mail" class="img-btn mr-2"></mat-icon><span class="float-right"> Save </span>
           </button>
          </article>
         </section>
       </div>
     </div>
    </div>
    </div>


<div class="modal fade mt-4"  id="CnfArchiveTax" tabindex="-1" aria-modal="true" aria-labelledby="CnfArchiveTaxLabel" aria-hidden="true">
<div class="modal-dialog modal-custom">
<div class="modal-content">
  <div class="modal-header border-0">
    <h6 class="modal-title font-weight-bold text-center" id="CnfArchiveTaxLabel">
      Archive TAX IDENTIFIERS
      <button type="button" class="close" id="closeCnfArchiveTax" #closeBtn data-dismiss="modal" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </h6>
  </div>

  <div class="modal-body">
    <section class="row m-0 bg-white no-shadow">
      <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
        Do you want to archive this TAX IDENTIFIER ?
      </div>
    </section>
  </div>

  <div class="modal-footer border-0 row">
    <section class="bg-white no-shadow m-0 ">
      <button type="button" class="btn btn-custom btn-link" data-dismiss="modal"> Cancel </button>
      <button type="button" class="btn btn-custom btn-custom-sm btn-blue" (click)="archiveTax()">
        Archive
      </button>
    </section>
  </div>
</div>
</div>
</div>



<div class="modal fade mt-4"  id="CnfUnArchiveTax" tabindex="-1" aria-modal="true" aria-labelledby="CnfUnArchiveTaxLabel" aria-hidden="true">
<div class="modal-dialog modal-custom">
<div class="modal-content">
  <div class="modal-header border-0">
    <h6 class="modal-title font-weight-bold text-center" id="CnfUnArchiveTaxLabel">
      Unarchive TAX IDENTIFIERS
      <button type="button" class="close" id="closeCnfUnArchiveTax" #closeBtn data-dismiss="modal" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </h6>
  </div>

  <div class="modal-body">
    <section class="row m-0 bg-white no-shadow">
      <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
        Do you want to unarchive this TAX IDENTIFIER ?
      </div>
    </section>
  </div>

  <div class="modal-footer border-0 row">
    <section class="bg-white no-shadow m-0 ">
      <button type="button" class="btn btn-custom btn-link" data-dismiss="modal"> Cancel </button>
      <button type="button" class="btn btn-custom btn-custom-sm btn-blue" (click)="UnarchiveTax()">
        Unarchive
      </button>
    </section>
  </div>
</div>
</div>
</div>




<div class="modal fade"  id="openEditCityModal" tabindex="-1" aria-modal="true" aria-labelledby="openEditCityModalLabel" aria-hidden="true">
<div class="modal-dialog modal-custom">
 <div class="modal-content">
   <div class="modal-header border-0">
     <h6 class="modal-title font-weight-bold text-center" id="openEditCityModalLabel">
      Edit City by <span class="label-darkblue">ADMIN</span>
       <button type="button" class="close" id="closeEditCityModal" #closeBtn data-dismiss="modal" aria-label="Close">
         <span aria-hidden="true">&times;</span>
       </button>
     </h6>
   </div>

   <div class="modal-body">
     <section class="row m-0 bg-white no-shadow">
       <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
      <label class="label-control">City
      </label>
      <div class="form-control form-control-sm matformheight">
        <form style="width: 325px;">
          <mat-form-field style="width:409px;">
            <input style="width:409px;text-transform: uppercase;" matInput aria-label="State" [matAutocomplete]="auto3" [formControl]="delaySiteSearchResCity">
            <mat-autocomplete #auto3="matAutocomplete" [panelWidth]="'750px'" class="custom-autocomplete">
              <ng-container *ngIf="editCityDropDown.length > 0; else noResults">
                <mat-option *ngFor="let value of editCityDropDown" (click)="editOnCityeSelect(value)" [value]="value.name">
                  <div class="table-row">
                    <div class="cell name">{{ value.name }}</div>
                    <div class="cell lat">{{ value.latitude }}</div>
                    <div class="cell long">{{ value.longitude }}</div>
                    <div class="cell zone">{{ value.adminZoneCode }}</div>
                    <div class="cell zone-name">{{ value.adminZoneName }}</div>
                    <div class="cell zone2">{{ value.adminZoneCode2 }}</div>
                    <div class="cell zone-name2">{{ value.adminZoneName2 }}</div>
                  </div>
                </mat-option>
              </ng-container>
              <ng-container *ngIf="editCityDropDown.length == 0" #noResults>
                <mat-option class="noResults" disabled *ngIf="editCityModel.length >= 4">
                  <span>No results</span>
                </mat-option>
              </ng-container>
            </mat-autocomplete>
          </mat-form-field>


        </form>
       </div>
       <small class="ng-clear-wrapper datalistClearButton" style="padding-left: 22px;" title="Clear"><u (click)="resetBvdId('city')" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (resetBvdId('city'))">X</u></small>




         <span style="color: #cb4b32;" *ngIf="editCityModelError==true">Please Enter City!!!</span>
       </div>
     </section>
   </div>

   <div class="modal-footer border-0">
     <section class="bg-white no-shadow m-0">
       <button type="button" class="btn btn-custom btn-link" data-dismiss="modal"> Cancel </button>
       <button type="button" class="btn btn-custom btn-custom-sm btn-blue" (click)="saveNewCity()">
        <mat-icon svgIcon="mail" class="img-btn mr-2"></mat-icon><span class="float-right"> {{saveDatas}} </span>
       </button>
     </section>
   </div>
 </div>
</div>
</div>




  <div class="modal fade" id="openEditCountryModal" tabindex="-1" aria-modal="true" aria-labelledby="openEditCountryModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-custom">
    <div class="modal-content">
      <div class="modal-header border-0">
        <h6 class="modal-title font-weight-bold text-center" id="openEditCountryModalLabel">Edit Country</h6>
        <button type="button" class="close" id="closeEditCountryModal" #closeBtn data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <section class="row m-0 bg-white no-shadow">
          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
         <label class="label-control">Country
         </label>
         <div class="form-control form-control-sm matformheight" style="position: relative;">
          <form style="width: 325px;">
            <mat-form-field style="width: 325px; min-width: 132%;">
              <input style="width: 365px;" matInput aria-label="State" [matAutocomplete]="autoCountry" [formControl]="delayResCountry">
              <mat-autocomplete #autoCountry="matAutocomplete" style="display: block;" class="custom-autocomplete">
                <ng-container *ngIf="CaptCountry && CaptCountry.length > 0; else noResults">
                  <mat-option style="width: 325px; min-width: 132%;" *ngFor="let value of CaptCountry" (click)="onCountryeSelect(value)" [value]="value">
                    <span>{{ value }}</span>
                  </mat-option>
                </ng-container>
                <ng-template #noResults>
                  <mat-option class="noResults" disabled *ngIf="siteCountryModel.length >= 2 && !countryLoad1">
                    <span>No results</span>
                  </mat-option>
                </ng-template>
              </mat-autocomplete>
            </mat-form-field>
          </form>
        </div>
        <small class="datalistClearButton" style="padding-left: 12px;" *ngIf="countryLoad1"><img src="assets/images/loading.gif" class="loadingheight" alt="Updating..."></small>
        <small class="ng-clear-wrapper datalistClearButton" *ngIf="!countryLoad1" style="position: relative; right: 10px;" title="Clear all"><span (click)="resetCreateSiteFields('siteCountryModel')" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (resetCreateSiteFields('siteCountryModel'))">x</span></small>
        <span style="color: #cb4b32;" *ngIf="siteCountryModelError==true">Please select country name</span>
          </div>
          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12" *ngIf="showCityForCountryEdit">
            <mat-label class="label-control">City <span style="color: #cb4b32;">*</span></mat-label>
            <div class="form-control form-control-sm matformheight">
              <form style="width: 325px;">
                <mat-form-field style="width:409px;">
                  <input style="width:409px;text-transform: uppercase;" matInput aria-label="City" [matAutocomplete]="autoCountryCity" [formControl]="delaySiteSearchResCountryCity">
                  <mat-autocomplete #autoCountryCity="matAutocomplete" [panelWidth]="'750px'" class="custom-autocomplete">
                    <ng-container *ngIf="editCountryCityDropDown.length > 0; else noCountryCityResults">
                      <mat-option *ngFor="let value of editCountryCityDropDown" (click)="onCountryCitySelect(value)" (keydown.enter)="onCountryCitySelect(value)" [value]="value.name">
                        <div class="table-row">
                          <div class="cell name">{{ value.name }}</div>
                          <div class="cell lat">{{ value.latitude }}</div>
                          <div class="cell long">{{ value.longitude }}</div>
                          <div class="cell zone">{{ value.adminZoneCode }}</div>
                          <div class="cell zone-name">{{ value.adminZoneName }}</div>
                          <div class="cell zone2">{{ value.adminZoneCode2 }}</div>
                          <div class="cell zone-name2">{{ value.adminZoneName2 }}</div>
                        </div>
                      </mat-option>
                    </ng-container>
                    <ng-template #noCountryCityResults>
                      <mat-option class="noResults" disabled *ngIf="editCountryCityModel && editCountryCityModel.length >= 2 && !cityLoad1">
                        <span>No results</span>
                      </mat-option>
                    </ng-template>
                  </mat-autocomplete>
                </mat-form-field>
              </form>
            </div>
            <small class="datalistClearButton" *ngIf="cityLoad1" style="padding-left: 12px;"><img src="assets/images/loading.gif" class="loadingheight" alt="Updating..."></small>
            <small class="ng-clear-wrapper datalistClearButton" *ngIf="!cityLoad1" style="padding-left: 22px;" title="Clear all"><span (click)="resetCreateSiteFields('siteCityModel')" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (resetCreateSiteFields('siteCityModel'))">x</span></small>
            <span style="color: #cb4b32;" *ngIf="editCountryCityModelError==true">Please select a city</span>
          </div>

        </section>
      </div>
      <div class="modal-footer border-0">
        <section class="bg-white no-shadow m-0">
          <button type="button" class="btn btn-custom btn-link" data-dismiss="modal"> Cancel </button>
          <button type="button" class="btn btn-custom btn-custom-sm btn-blue" (click)="saveNewCountry()">
           <mat-icon svgIcon="mail" class="img-btn mr-2"></mat-icon><span class="float-right"> {{saveDatas}} </span>
          </button>
        </section>
      </div>
    </div>
  </div>
</div>




<div class="modal fade mt-4"  id="CnfArchiveBvdId" tabindex="-1" aria-modal="true" aria-labelledby="CnfArchiveBvdIdLabel" aria-hidden="true">
<div class="modal-dialog modal-custom">
<div class="modal-content">
  <div class="modal-header border-0">
    <h6 class="modal-title font-weight-bold text-center" id="CnfArchiveBvdIdLabel">Archive BVD ID
      <button type="button" class="close" id="closeCnfArchiveBvdId" #closeBtn data-dismiss="modal" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </h6>
  </div>

  <div class="modal-body">
    <section class="row m-0 bg-white no-shadow">
      <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
        Do you want to archive this BVD ID ?
      </div>
    </section>
  </div>

  <div class="modal-footer border-0 row">
    <section class="bg-white no-shadow m-0 ">
      <button type="button" class="btn btn-custom btn-link" data-dismiss="modal"> Cancel </button>
      <button type="button" class="btn btn-custom btn-custom-sm btn-blue" (click)="archiveBvDID()">
        Archive
      </button>
    </section>
  </div>
</div>
</div>
</div>



<div class="modal fade mt-4"  id="CnfUnArchiveBvdId" tabindex="-1" aria-modal="true" aria-labelledby="CnfUnArchiveBvdIdLabel" aria-hidden="true">
<div class="modal-dialog modal-custom">
<div class="modal-content">
  <div class="modal-header border-0">
    <h6 class="modal-title font-weight-bold text-center" id="CnfUnArchiveBvdIdLabel">
      Unarchive BVD ID
      <button type="button" class="close" id="closeCnfUnArchiveBvdId" #closeBtn data-dismiss="modal" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </h6>
  </div>

  <div class="modal-body">
    <section class="row m-0 bg-white no-shadow">
      <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
        Do you want to unarchive this BVD ID ?
      </div>
    </section>
  </div>

  <div class="modal-footer border-0 row">
    <section class="bg-white no-shadow m-0 ">
      <button type="button" class="btn btn-custom btn-link" data-dismiss="modal"> Cancel </button>
      <button type="button" class="btn btn-custom btn-custom-sm btn-blue" (click)="UnarchiveBvDID()">
        Unarchive
      </button>
    </section>
  </div>
</div>
</div>
</div>



<div class="modal fade mt-4"  id="CnfDeleteBvdId" tabindex="-1" aria-modal="true" aria-labelledby="CnfDeleteBvdIdLabel" aria-hidden="true">
<div class="modal-dialog modal-custom">
  <div class="modal-content">
    <div class="modal-header border-0">
      <h6 class="modal-title font-weight-bold text-center" id="CnfDeleteBvdIdLabel">Delete BVD ID
        <button type="button" class="close" id="closeCnfDeleteBvdId" #closeBtn data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </h6>
    </div>

    <div class="modal-body">
      <section class="row m-0 bg-white no-shadow">
        <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
          Do you want to Delete this BVD ID ?
        </div>
      </section>
    </div>

    <div class="modal-footer border-0 row">
      <section class="bg-white no-shadow m-0 ">
        <button type="button" class="btn btn-custom btn-link" data-dismiss="modal"> Cancel </button>
        <button type="button" class="btn btn-custom btn-custom-sm btn-blue" (click)="DeleteBvDID()">
          Delete
        </button>
      </section>
    </div>
  </div>
</div>
</div>


<div class="modal fade mt-4"  id="CnfDeleteTaxId" tabindex="-1" aria-modal="true" aria-labelledby="CnfDeleteTaxIdLabel" aria-hidden="true">
  <div class="modal-dialog modal-custom">
    <div class="modal-content">
      <div class="modal-header border-0">
        <h6 class="modal-title font-weight-bold text-center" id="CnfDeleteTaxIdLabel">
          Delete Tax ID
          <button type="button" class="close" id="closeCnfDeleteTaxId" #closeBtn data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </h6>
      </div>

      <div class="modal-body">
        <section class="row m-0 bg-white no-shadow">
          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            Do you want to Delete this Tax ID ?
          </div>
        </section>
      </div>

      <div class="modal-footer border-0 row">
        <section class="bg-white no-shadow m-0 ">
          <button type="button" class="btn btn-custom btn-link" data-dismiss="modal"> Cancel </button>
          <button type="button" class="btn btn-custom btn-custom-sm btn-blue" (click)="DeleteTaxID()">
            Delete
          </button>
        </section>
      </div>
    </div>
  </div>
  </div>

  <!-- Document Validation Modal -->
<div class="modal fade" tabindex="-1" aria-modal="true" id="documentValidationModal" aria-labelledby="documentValidationModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header" style="background-color: #f0eeeb; color: #333;">
        <h5 class="modal-title font-weight-bold text-center" id="documentValidationModalLabel">
          Document Validation Required
        </h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body" style="background-color: #fff; color: #333;">
        <div style="padding: 12px; border-radius: 4px; background-color: #fff; color: #333;" role="alert">
          <strong>Missing Documents!</strong>
          <p class="mb-2">Please upload your documents to proceed with sending to buyer.</p>
          <p class="mb-0">At least one non-archived document is required in the documents section of the company.</p>
        </div>
        <div class="text-center">
          <a href="https://suppliers-new.renault.com/isa-information-page"
             target="_blank"
             class="btn btn-custom btn-blue">
            <i class="label"></i> User Guide
          </a>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-custom btn-blue" data-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>

<!-- Qualifier Validation Modal -->
<div id="qualifierValidationModal" class="modal fade" tabindex="-1" aria-modal="true" aria-labelledby="qualifierValidationModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header" style="background-color: #f0eeeb; color: #333;">
        <h5 class="modal-title font-weight-bold text-center" id="qualifierValidationModalLabel">
          <i class="label"></i> Qualifier Validation Required
        </h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body" style="background-color: #fff; color: #333;">
        <div class="alert" role="alert">
          <p class="mb-2">At least one qualifier (other than Main Entrance) must be present on at least one site of the company.</p>
          <p class="mb-0"><em>Note: Main Entrance qualifier alone is not sufficient for validation.</em></p>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn" style="background-color: #9e8b7a; color: #fff; border: none; padding: 6px 20px; border-radius: 4px;" data-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>

<!-- Edit Site Workflow Status Modal -->
<div class="modal fade" id="editSiteWorkflowStatusModal" tabindex="-1" aria-modal="true" aria-labelledby="editSiteWorkflowStatusModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-custom">
    <div class="modal-content">
      <div class="modal-header border-0">
        <h6 class="modal-title font-weight-bold text-center" id="editSiteWorkflowStatusModalLabel">Edit Workflow Status
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" id="closeSiteWorkflowStatusModal">
          <span aria-hidden="true">&times;</span>
        </button>
      </h6>
      </div>
      <div class="modal-body">
        <div class="form-group col-12">
          <mat-label class="font-weight-bold">Workflow Status</mat-label>
          <mat-select class="form-control form-control-sm dropdown-select" [(ngModel)]="siteWorkflowStatusModel" panelClass="dropdown-panel" [disableOptionCentering]="true" placeholder="-- Select --">
            <mat-option *ngFor="let opt of siteWorkflowStatusOptions" [value]="opt">{{opt}}</mat-option>
          </mat-select>
        </div>
      </div>
      <div class="modal-footer border-0">
        <section class="bg-white no-shadow m-0">
          <button type="button" class="btn btn-custom btn-link" data-dismiss="modal">Cancel</button>
          <button type="button" class="btn btn-custom btn-custom-sm btn-blue" (click)="updateSiteWorkflowStatus()"
            [disabled]="disableSiteWorkflowStatusBtn || siteWorkflowStatusModel === ''">
            <mat-icon svgIcon="mail" class="img-btn mr-2"></mat-icon><span class="float-right"> {{saveDatas}} </span>
          </button>
        </section>
      </div>
    </div>
  </div>
</div>

<div class="modal fade"  id="openCreateCityModal" tabindex="-1" aria-modal="true" aria-labelledby="openCreateCityModalLabel" aria-hidden="true">
<div class="modal-dialog modal-custom">
 <div class="modal-content">
   <div class="modal-header border-0">
     <h6 class="modal-title font-weight-bold text-center" id="openCreateCityModalLabel">Create City
       <button type="button" class="close" id="closeCreateCityModal" #closeBtn data-dismiss="modal" aria-label="Close">
         <span aria-hidden="true">&times;</span>
       </button>
     </h6>
   </div>

   <div class="modal-body px-0">
     <section class="row m-0 bg-white no-shadow">

        <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <label class="label-control">Country<span class="element_astrick">*</span>
          </label>
          <div class="form-control form-control-sm matformheight">
            <form style="width: 325px;">
              <mat-form-field style="width:409px;">
                <input style="width: 105%" matInput aria-label="State" [matAutocomplete]="auto4" [formControl]="delaycityCreateResCountry">
                <mat-autocomplete #auto4="matAutocomplete" [panelWidth]="'455px'" style="display: block;" class="custom-autocomplete">
                  <ng-container *ngIf="cityCreateCountryDropDown.length > 0; else noResultsCoun">
                    <mat-option *ngFor="let value of cityCreateCountryDropDown" (click)="cityCreateonCountryeSelect(value)" [value]="value">
                      <span>{{ value }}</span>
                    </mat-option>
                  </ng-container>
                  <ng-template #noResultsCoun>
                    <mat-option class="noResults" disabled *ngIf="cityCreateCountryModel.length >= 2">
                      <span>No results</span>
                    </mat-option>
                  </ng-template>
                </mat-autocomplete>
              </mat-form-field>
            </form>
           </div>
           <small class="ng-clear-wrapper datalistClearButton" style="padding-left: 25px;" title="Clear"><u style="color: black;" (click)="resetSelectedFields('cityCreateCountryModel')" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (resetSelectedFields('cityCreateCountryModel'))">X</u></small>

          <span style="color: #cb4b32;" *ngIf="editCreateCityCountryModelError==true">Please Enter Country!!</span>
        </div>

        <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <label class="label-control">City<span class="element_astrick">*</span>
          </label>
          <input
            type="text"
            [(ngModel)]="cityCreateCityModel"
            [disabled]="cityCreateCityDisable"
            class="form-control form-control-sm"
            (ngModelChange)="cityCreateCityModel = $event.toUpperCase()" />
          <small class="ng-clear-wrapper datalistClearButton" title="Clear">
            <span style="background-color: #fff;" class="ng-clear" (click)="resetSelectedFields('cityCreateCityModel')" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (resetSelectedFields('cityCreateCityModel'))">×</span>
          </small>
          <span style="color: #cb4b32;" *ngIf="editCreateCityCityModelError==true">Please Enter City!!!</span>
          <span style="color: #cb4b32;" *ngIf="cityAlreadyExistsError==true">City already exists!!!</span>
        </div>
        <div class="col col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 pr-0">
          <label class="label-control">Latitude :<span class="element_astrick">*</span></label>
          <p style="position: relative;padding: 0;">
            <span style="width: 18%;display: inline-block;">
              <input id="latitude_degres__4" type="text" (keyup)="dmsversdd()" class="form-control form-control-sm form-control-paddings pr-1" [(ngModel)]="latDegVal">

            </span>
            <label class="font-weight-bold" style="position: absolute;top: 0;" for="latitude_degres">&deg;</label>&nbsp;
            <span style="width: 18%;display: inline-block;">
              <input id="latitude_minutes__4" type="text" (keyup)="dmsversdd()" class="form-control form-control-sm form-control-paddings pr-1" [(ngModel)]="latMinVal">

            </span>
            <label class="font-weight-bold" style="position: absolute;top: 0;" for="latitude_minutes">'</label>&nbsp;
            <span style="width: 35%;display: inline-block;">
              <input id="latitude_secondes__4" type="text" (keyup)="dmsversdd()" class="form-control form-control-sm form-control-paddings pr-1" [(ngModel)]="latSecVal">

            </span>
            <mat-label class="font-weight-bold" style="position: absolute;top: 0;" for="latitude_secondes">''</mat-label>&nbsp;
            <span style="width: 17%;display: inline-block;">
            <mat-select class="form-control form-control-sm p-0 dropdown-select"  [(ngModel)]="northSouthModel" (ngModelChange)="dmsversdd()" panelClass="dropdown-panel" [disableOptionCentering]="true">
                <mat-option value="North" selected="selected">N</mat-option>
                <mat-option value="South">S</mat-option>
            </mat-select>
            </span>
          </p>
        </div>
        <div class="col col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 pr-0">
          <label class="label-control">Longitude :<span class="element_astrick">*</span></label>
          <p style="position: relative;padding: 0;">
            <span style="width: 18%;display: inline-block;">
              <input id="longitude_degres__4" type="text" (keyup)="dmsversdd()" class="form-control form-control-sm form-control-paddings pr-1" [(ngModel)]="longDegVal">

            </span>
            <label class="font-weight-bold" style="position: absolute;top: 0;" for="longitude_degres">&deg;</label>&nbsp;
            <span style="width: 18%;display: inline-block;">
              <input id="longitude_minutes__4" type="text" (keyup)="dmsversdd()" class="form-control form-control-sm form-control-paddings pr-1" [(ngModel)]="longMinVal">

            </span>
            <label class="font-weight-bold" style="position: absolute;top: 0;" for="longitude_minutes">'</label>&nbsp;
            <span style="width: 35%;display: inline-block;">
              <input id="longitude_secondes__3" type="text" (keyup)="dmsversdd()" class="form-control form-control-sm form-control-paddings pr-1" [(ngModel)]="longSecVal">

            </span>
            <mat-label class="font-weight-bold" style="position: absolute;top: 0;" for="longitude_secondes">''</mat-label>&nbsp;
            <span style="width: 17%;display: inline-block;">
            <mat-select class="form-control form-control-sm p-0 dropdown-select"  [(ngModel)]="eastWestModel" (ngModelChange)="dmsversdd()" panelClass="dropdown-panel" [disableOptionCentering]="true">
                <mat-option value="East" selected="selected">E</mat-option>
                <mat-option value="West">W</mat-option>
            </mat-select>
            </span>
          </p>
        </div>
        <div class="form-group col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
          <label class="label-control">Latitude</label>
          <div>
            <input class="form-control form-control-sm" [(ngModel)]="latitudeVal" (keyup)="ddversdms()" type="text"/>
            <span class="ng-clear-wrapper datalistClearButton" title="Clear all">
              <span class="ng-clear" style="background-color: #fff;" (click)="resetSelectedFields('gpslat')" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (resetSelectedFields('gpslat'))">×</span>
            </span>
          </div>
        </div>

        <div class="form-group col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
          <label class="label-control">Longitude</label>
          <div>
            <input class="form-control form-control-sm" [(ngModel)]="longitudeVal"  (keyup)="ddversdms()" type="text"/>
            <span class="ng-clear-wrapper datalistClearButton" title="Clear all">
              <span class="ng-clear" style="background-color: #fff;" (click)="resetSelectedFields('gpslon')" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (resetSelectedFields('gpslon'))">×</span>
            </span>
          </div>
        </div>
        <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <span style="color: #cb4b32;" *ngIf="gpsModelError==true">Please Enter Gps!!</span>
        </div>



     </section>
   </div>

   <div class="modal-footer border-0">
     <section class="bg-white no-shadow m-0">
       <button type="button" class="btn btn-custom btn-link" data-dismiss="modal"> Cancel </button>
       <button type="button" class="btn btn-custom btn-custom-sm btn-blue" (click)="createNewCity()" [disabled]="disableCreateCityBtn">
        <mat-icon svgIcon="mail" class="img-btn mr-2"></mat-icon><span class="float-right"> {{saveDatas}} </span>
       </button>
     </section>
   </div>
 </div>
</div>
</div>



<div class="modal fade"  id="openCheckBvdModal" tabindex="-1" aria-modal="true" aria-labelledby="openCheckBvdModalLabel" aria-hidden="true">
<div class="modal-dialog modal-custom">
 <div class="modal-content" style="width: 900px;margin-left: -34% !important;">
   <div class="modal-header border-0">
     <h5 class="modal-title font-weight-bold text-center" id="openCheckBvdModalLabel">
       Check BvD
       <button type="button" class="close" id="closeCheckBvdModal" #closeBtn data-dismiss="modal" aria-label="Close">
         <span aria-hidden="true">&times;</span>
       </button>
     </h5>
   </div>

   <div class="modal-body px-0 pb-0">
     <section class="row m-0 bg-white no-shadow">
       <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 p-0">
         <div class="modal-body row m-0 p-0 table-responsive">
          <table class="table m-0">
            <thead style="background-color: #F5F5F5;">
              <tr class="col p-0">
                <th class="text-center" style="text-decoration: none;">
                  {{sitebvidid}}
                  <mat-icon *ngIf="noSiteAssn==false && roleVariableHide" svgIcon="edit" class="img-btn pl-2 pb-1 edit" role="button" (click)="resetBvdId('modal')" data-target="#openEditBvdModal" data-toggle="modal" data-dismiss="modal" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (resetBvdId('modal'))"></mat-icon>
                </th>
                <th class="text-center" style="text-decoration: none;">
                  Renault database
                </th>
                <th class="text-center" style="text-decoration: none;">
                  Orbis database
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style="width: 20%;" class="p-1">
                  <div>
                    <ul class="row m-0 list-group p-0">
                      <li class="list-group-item border-0 height50">
                        <span class="font-weight-bold">
                          Group :
                        </span>
                      </li>
                      <li class="list-group-item border-0 height50">
                        <span class="font-weight-bold">
                          Company Name :
                        </span>
                      </li>
                      <li class="list-group-item border-0 height50">
                        <span class="font-weight-bold">
                          Country :
                        </span>
                      </li>
                      <li class="list-group-item border-0 height50">
                        <span class="font-weight-bold">
                          City :
                        </span>

                      </li>
                      <li class="list-group-item border-0 height50">
                        <span class="font-weight-bold">
                          Street :
                        </span>
                      </li>
                      <li class="list-group-item border-0 height50">
                        <span class="font-weight-bold">
                          Additional Address information :
                        </span>
                      </li>
                      <li class="list-group-item border-0 height50">
                        <span class="font-weight-bold">
                          Territorial Division :
                        </span>

                      </li>
                      <li class="list-group-item border-0 height50">
                        <span class="font-weight-bold">
                          Postal Code :
                        </span>
                      </li>
                      <li class="list-group-item border-0 height50">
                        <div>
                          <mat-icon svgIcon="{{qualifierTypes['P14']}}" class="p-0 pr-1" style="width: 40px !important;height: 40px !important;" alt=""></mat-icon>
                        </div>
                        <span class="font-weight-bold">
                          {{qualifierTypesText['P14']}} name :
                        </span>
                      </li>
                    </ul>
                  </div>
                </td>
                <td style="width: 40%;" class="p-1">
                  <div>
                    <ul class="row m-0 list-group p-0">
                      <li class="list-group-item border-0 height50">
                        &nbsp;{{groupAssignToCpy ? groupAssignToCpy : '-'}}
                      </li>
                      <li class="list-group-item border-0 height50">
                        <span class="font-weight-bold label-darkblue">
                          {{businessEntityCompanyLegalName ? businessEntityCompanyLegalName : '-'}}
                        </span>
                      </li>
                      <li class="list-group-item border-0 height50">
                        <span>
                          {{siteCountry ? siteCountry : '-'}}
                        </span>
                      </li>
                      <li class="list-group-item border-0 height50">
                        <span>
                          {{siteCity ? siteCity : '-'}}
                          <mat-icon *ngIf="siteCity != '' && roleVariableHide" svgIcon="edit" class="img-btn pl-2 pb-1 edit" role="button" data-target="#openEditCityModal" (click)="resetEditCity()" data-toggle="modal" data-dismiss="modal" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (resetEditCity())"></mat-icon>
                        </span>

                      </li>
                      <li class="list-group-item border-0 height50">
                        <span>
                          {{mainEntranceVals.wayNumber ? mainEntranceVals.wayNumber+', ' : ''}}{{mainEntranceVals.streetName ? mainEntranceVals.streetName : '-'}}
                          <span *ngIf="mainEntranceVals.streetName != ''">
                            <mat-icon class="edit pl-2 pb-1" svgIcon="edit" alt="edit" data-toggle="modal" data-target="#siteEditAddress" (click)="loadAddressModalDetails(mainEntranceVals.addressEditRowId,mainEntranceData.rowId,mainEntranceVals)" data-dismiss="modal" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (loadAddressModalDetails(mainEntranceVals.addressEditRowId,mainEntranceData.rowId,mainEntranceVals))"></mat-icon>
                          </span>
                        </span>
                      </li>
                      <li class="list-group-item border-0 height50">
                        <span>
                          {{mainEntranceVals.additionalInformation ? mainEntranceVals.additionalInformation : '-'}}
                        </span>
                      </li>
                      <li class="list-group-item border-0 height50">
                        <span>
                          {{mainEntranceVals.territorialDivision ? mainEntranceVals.territorialDivision : '-'}}
                        </span>

                      </li>
                      <li class="list-group-item border-0 height50">
                        <span>
                          {{mainEntranceVals.postalCode ? mainEntranceVals.postalCode : '-'}}
                        </span>
                      </li>
                      <li class="list-group-item border-0 height50">
                        <span>
                          {{mainEntranceData.label ? mainEntranceData.label : '-'}}
                          <span *ngIf="mainEntranceData != '' && mainEntranceData.label !=''">
                            <mat-icon class="edit pl-2 pb-1" svgIcon="edit" alt="edit" data-toggle="modal" data-target="#siteQualifierNameModalPopup" data-dismiss="modal" (click)="saveMainEntranceEdit(mainEntranceData.label,mainEntranceData.rowId)" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (saveMainEntranceEdit(mainEntranceData.label,mainEntranceData.rowId))"></mat-icon>
                          </span>
                        </span>
                      </li>
                    </ul>
                  </div>
                </td>
                <td  style="width: 40%;" class="p-1">
                  <div *ngIf="orbisBvdDataLoading==false && orbisBvdData !='' && orbisBvdData != undefined">
                    <ul class="row m-0 list-group p-0">
                      <li class="list-group-item border-0 height50">
                        {{orbisBvdData['GUO_NAME'] ? (orbisBvdData['GUO_NAME'][0] ? orbisBvdData['GUO_NAME'][0] : '-') : '-'}}
                      </li>
                      <li class="list-group-item border-0 height50">
                        {{!!orbisBvdData['BRANCH_INDICATOR'] ? (orbisBvdData['NAME'] ? orbisBvdData['NAME'] : '-') : (orbisBvdData['BRANCH_NAME'] ? orbisBvdData['BRANCH_NAME'] : '-')}}
                      </li>
                      <li class="list-group-item border-0 height50">
                        {{orbisBvdData['COUNTRY'] ? orbisBvdData['COUNTRY'] : '-'}}
                      </li>
                      <li class="list-group-item border-0 height50">
                        {{this.apiService.hasNoSpecialCharacters(orbisBvdData['CITY_STANDARDIZED'],orbisBvdData['CITY'])}}

                      </li>
                      <li class="list-group-item border-0 height50">
                        {{orbisBvdData['ADDRESS_LINE1'] ? orbisBvdData['ADDRESS_LINE1'] : '-'}}
                      </li>
                      <li class="list-group-item border-0 height50">
                        {{orbisBvdData['ADDRESS_LINE2'] ? orbisBvdData['ADDRESS_LINE2'] : '-'}}
                      </li>
                      <li class="list-group-item border-0 height50">
                        {{orbisBvdData['ADDRESS_LINE3'] ? orbisBvdData['ADDRESS_LINE3'] : '-'}}
                      </li>
                      <li class="list-group-item border-0 height50">
                        {{orbisBvdData['POSTCODE'] ? orbisBvdData['POSTCODE'] : '-'}}
                      </li>
                      <li class="list-group-item border-0 height50">
                        {{orbisBvdData['NAME'] ? orbisBvdData['NAME'] : '-'}}
                      </li>
                    </ul>
                  </div>
                  <div *ngIf="orbisBvdDataLoading==true" class="loading-container">

                    <ng-container *ngIf="loading">
              <div class="local-loading-overlay">
                <div class="custom-spinner-template">
                  <mat-spinner class="custom-spinner black-spinner" diameter="40"></mat-spinner>
                    </div>
                  </div>
            </ng-container>

                  </div>
                </td>
              </tr>
            </tbody>
          </table>
      </div>
       </div>
     </section>
   </div>

   <div class="modal-footer border-0 pt-0 pr-3">
     <section class="bg-white no-shadow m-0">

       <button type="button" class="btn btn-custom btn-custom-md btn-blue" data-dismiss="modal">
        Close
       </button>
     </section>
   </div>
 </div>
</div>
</div>



<div class="modal fade mt-4"  id="alreadyAttachedToSiteModal" tabindex="-1" aria-modal="true" aria-labelledby="alreadyAttachedToSiteModalLabel" aria-hidden="true">
<div class="modal-dialog modal-custom">
<div class="modal-content">
  <div class="modal-header border-0">
    <h6 class="modal-title font-weight-bold text-center" id="alreadyAttachedToSiteModalLabel">
      Warning
      <button type="button" class="close" id="closealreadyAttachedToSiteModal" #closeBtn data-dismiss="modal" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </h6>
  </div>

  <div class="modal-body">
    <section class="row m-0 bg-white no-shadow">
      <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
        <p class="font-weight-bold text-center h6">
          Site already actively linked to Company
        </p>
      </div>
    </section>
  </div>

  <div class="modal-footer border-0 row">
    <section class="bg-white no-shadow m-0 ">
      <button type="button" class="btn btn-custom btn-custom-md btn-blue" data-dismiss="modal"> Cancel </button>
    </section>
  </div>
</div>
</div>
</div>



<div class="modal fade" id="showAddQualifierSteps" tabindex="-1" aria-modal="true" aria-labelledby="showAddQualifierStepsLabel" aria-hidden="true">
<div class="modal-dialog modal-custom">
  <div class="modal-content">
    <div class="modal-header border-0">
      <h6 class="modal-title font-weight-bold text-center" id="showAddQualifierStepsLabel">
        Add Qualifier to Site
        <button type="button" class="close" id="closeShowAddQualifierSteps" #closeBtn data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </h6>
    </div>

    <div class="modal-body">
      <section class="row m-0 bg-white no-shadow">
        <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <ul class="row m-0 nav list-view p-0 pt-1">
            <li class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
              <span class="font-weight-bold">
                Field Validation -
              </span>
              <span>
                <img src="assets/images/loading.gif" alt="loading..." *ngIf="!validationSuccess">
                <span class="text-success" *ngIf="validationSuccess==true">Success</span>
              </span>
            </li>

            <li class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
              <span class="font-weight-bold">
                Access Point -
              </span>
              <span [innerHtml]="acpMainCreation">
              </span>
            </li>

            <li class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
              <span class="font-weight-bold">
                Address -
              </span>
              <span [innerHtml]="acpAddressCreation">
              </span>
            </li>

            <li class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
              <span class="font-weight-bold">
                GPS Co-ordinates -
              </span>
              <span [innerHtml]="gpsCreation">
              </span>
            </li>

            <li class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
              <span class="font-weight-bold">
                New ACP Created -
              </span>
              <span [innerHtml]="finalAcpCreated">
              </span>
            </li>
          </ul>
        </div>
      </section>
    </div>
    <div class="modal-footer border-0 col">
      <section class="bg-white no-shadow row">
        <button type="button" class="btn btn-custom btn-blue" data-dismiss="modal"> Close </button>
      </section>
    </div>
  </div>
</div>
</div>



<div class="modal fade" id="showCreateCitySteps" tabindex="-1" aria-modal="true" aria-labelledby="showCreateCityStepsLabel" aria-hidden="true">
<div class="modal-dialog modal-custom">
  <div class="modal-content">
    <div class="modal-header border-0">
      <h6 class="modal-title font-weight-bold text-center" id="showCreateCityStepsLabel">
        Create City
        <button type="button" class="close" id="closeShowCreateCitySteps" #closeBtn data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </h6>
    </div>

    <div class="modal-body">
      <section class="row m-0 bg-white no-shadow">
        <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <ul class="row m-0 nav list-view p-0 pt-1">
            <li class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
              <span class="font-weight-bold">
                Field Validation -
              </span>
              <span>
                <img src="assets/images/loading.gif" alt="loading..." *ngIf="!validationSuccessCity">
                <span class="text-success" *ngIf="validationSuccessCity==true">Success</span>
              </span>
            </li>

            <li class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
              <span class="font-weight-bold">
                City Creation -
              </span>
              <span [innerHtml]="cityCreation">
              </span>
            </li>
          </ul>
        </div>
      </section>
    </div>
    <div class="modal-footer border-0 col">
      <section class="bg-white no-shadow row">
        <button type="button" class="btn btn-custom btn-blue" data-dismiss="modal"> Close </button>
      </section>
    </div>
  </div>
</div>
</div>



<div class="modal fade" id="showUpdateCpySteps" tabindex="-1" aria-modal="true" aria-labelledby="showUpdateCpyStepsLabel" aria-hidden="true">
<div class="modal-dialog modal-custom">
  <div class="modal-content">
    <div class="modal-header border-0">
      <h6 class="modal-title font-weight-bold text-center" id="showUpdateCpyStepsLabel">
        Update Company
        <button type="button" class="close" id="closeshowUpdateCpySteps" #closeBtn data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </h6>
    </div>

    <div class="modal-body">
      <section class="row m-0 bg-white no-shadow">
        <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <ul class="row m-0 nav list-view p-0 pt-1">
            <li class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
              <span class="font-weight-bold">
                Field Validation -
              </span>
              <span>
                <img src="assets/images/loading.gif" alt="loading..." *ngIf="!validationSuccessUpdateCpy">
                <span class="text-success" *ngIf="validationSuccessUpdateCpy==true">Success</span>
              </span>
            </li>

            <li class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
              <span class="font-weight-bold">
                Checking Duplicate link -
              </span>
              <span [innerHtml]="UCcheckDupLink">
              </span>
            </li>

            <li class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
              <span class="font-weight-bold">
                Archive previous link -
              </span>
              <span [innerHtml]="UCarchiveLink">
              </span>
            </li>

            <li class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
              <span class="font-weight-bold">
                Create new Business entity -
              </span>
              <span [innerHtml]="UCnewBusinessE">
              </span>
            </li>

            <li class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
              <span class="font-weight-bold">
                Create new BvD ID -
              </span>
              <span [innerHtml]="UCnewBvdId">
              </span>
            </li>

            <li class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
              <span class="font-weight-bold">
                Create new Site Assignment -
              </span>
              <span [innerHtml]="UCnewSiteAssn">
              </span>
            </li>

            <li class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
              <span class="font-weight-bold">
                Change site name -
              </span>
              <span [innerHtml]="UCchangeSiteName">
              </span>
            </li>

            <li class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
              <span class="font-weight-bold">
                Delete previous raft accounts -
              </span>
              <span [innerHtml]="UCdelRaftAcc">
              </span>
            </li>

            <li class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
              <span class="font-weight-bold">
                Delete alcor associated to site of previous cpy -
              </span>
              <span [innerHtml]="UCdelAlcorPrevCpy">
              </span>
            </li>

            <li class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
              <span class="font-weight-bold">
                Search for alcor real estate idens and manage data -
              </span>
              <span [innerHtml]="UCrealEstateIdens">
              </span>
            </li>

            <li class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
              <span class="font-weight-bold">
                Update the category name or set end date -
              </span>
              <span [innerHtml]="UCcatergoryName">
              </span>
            </li>

            <li class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
              <span class="font-weight-bold">
                Create or archive legal entity -
              </span>
              <span [innerHtml]="UClegalEntity">
              </span>
            </li>
          </ul>
        </div>
      </section>
    </div>
    <div class="modal-footer border-0 col">
      <section class="bg-white no-shadow row">
        <button type="button" class="btn btn-custom btn-blue" data-dismiss="modal"> Close </button>
      </section>
    </div>
  </div>
</div>
</div>



<div class="modal fade" id="showValidateAcpSteps" tabindex="-1" aria-modal="true" aria-labelledby="showValidateAcpStepsLabel" aria-hidden="true">
<div class="modal-dialog modal-custom">
  <div class="modal-content">
    <div class="modal-header border-0">
      <h6 class="modal-title font-weight-bold text-center" id="showValidateAcpStepsLabel">
        Validate ACP
        <button type="button" class="close" id="closeshowValidateAcpSteps" #closeBtn data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </h6>
    </div>

    <div class="modal-body">
      <section class="row m-0 bg-white no-shadow">
        <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <ul class="row m-0 nav list-view p-0 pt-1">
            <li class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
              <span class="font-weight-bold">
                Field Validation -
              </span>
              <span>
                <img src="assets/images/loading.gif" alt="loading..." *ngIf="!validationSuccessValidateacp">
                <span class="text-success" *ngIf="validationSuccessValidateacp==true">Success</span>
              </span>
            </li>



            <li class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
              <span class="font-weight-bold">
                Create New Raft Code -
              </span>
              <span [innerHtml]="raftCodeAddin">
              </span>
            </li>

            <li class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
              <span class="font-weight-bold">
                Add Raft name -
              </span>
              <span [innerHtml]="raftNameAddin">
              </span>
            </li>

            <li class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
              <span class="font-weight-bold">
                Change ACP Status to Active -
              </span>
              <span [innerHtml]="acpStatusChange">
              </span>
            </li>
          </ul>
        </div>
      </section>
    </div>
    <div class="modal-footer border-0 col">
      <section class="bg-white no-shadow row">
        <button type="button" class="btn btn-custom btn-blue" data-dismiss="modal"> Close </button>
      </section>
    </div>
  </div>
</div>
</div>



<div class="modal fade"  id="openAddEditNissanCodeModal" tabindex="-1" aria-modal="true" aria-labelledby="openAddEditNissanCodeModalLabel" aria-hidden="true">
<div class="modal-dialog modal-custom">
  <div class="modal-content">
    <div class="modal-header border-0">
      <h6 class="modal-title font-weight-bold text-center" id="openAddEditNissanCodeModalLabel">
       {{addOrEdit}} NISSAN Code
        <button type="button" class="close" id="closeAddEditNissanCodeModal" #closeBtn data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </h6>
    </div>

    <div class="modal-body px-0">
      <section class="row m-0 bg-white no-shadow">
       <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
         <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
           <label class="label-control">Plant code<span class="element_astrick">*</span>
           </label>
           <input
             type="text"
             [(ngModel)]="nissanPlantCodeModel"
             class="form-control form-control-sm"
             />
           <small class="ng-clear-wrapper datalistClearButton" title="Clear">
             <span style="background-color: #fff;" class="ng-clear" (click)="resetSelectedFields('nissanPlantCodeModel')" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (resetSelectedFields('nissanPlantCodeModel'))">×</span>
           </small>
           <span style="color: #cb4b32;" *ngIf="nissanPlantCodeModelError==true">Please Enter plant code!!</span>
         </div>

         <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
           <label class="label-control">Vendor code<span class="element_astrick">*</span>
           </label>
           <input
             type="text"
             [(ngModel)]="nissanVendorCodeModel"
             class="form-control form-control-sm"
             />
           <small class="ng-clear-wrapper datalistClearButton" title="Clear">
             <span style="background-color: #fff;" class="ng-clear" (click)="resetSelectedFields('nissanVendorCodeModel')" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (resetSelectedFields('nissanVendorCodeModel'))">×</span>
           </small>
           <span style="color: #cb4b32;" *ngIf="nissanVendorCodeModelError==true">Please Enter Vendor Code!!!</span>
         </div>

         <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
           <label class="label-control">Warehouse</label>
           <input type="checkbox"
           class="form-check-input m-0"
           [(ngModel)]="nissanWarehouseModel"
           style="width: 1.2rem;height: 1.2rem;"/>
         </div>
       </div>
      </section>
    </div>

    <div class="modal-footer border-0">
      <button type="button" class="btn btn-custom btn-custom-sm btn-blue mr-auto" *ngIf="addOrEdit == 'Edit'" (click)="deleteNissanCode()" [disabled]="disableDeleteNissanBtn">
        <mat-icon svgIcon="delete" class="img-btn mr-2"></mat-icon><span class="float-right"> Delete </span>
      </button>
      <section class="bg-white no-shadow m-0">
        <button type="button" class="btn btn-custom btn-link" data-dismiss="modal"> Cancel </button>
        <button type="button" class="btn btn-custom btn-custom-sm btn-blue" (click)="addOrEditNissanCode()" [disabled]="disableSaveNissanBtn">
          <mat-icon svgIcon="mail" class="img-btn mr-2"></mat-icon><span class="float-right"> {{saveDatas}} </span>
        </button>
      </section>
    </div>
  </div>
</div>
</div>



<div class="modal fade" id="addTaxIdentifier" tabindex="-1" aria-modal="true" aria-labelledby="addTaxIdentifierLabel" aria-hidden="true">
<div class="modal-dialog modal-custom">
  <div class="modal-content">
    <div class="modal-header border-0">
      <h6 class="modal-title font-weight-bold text-center" id="addTaxIdentifierLabel">
        Add Tax Identifier
        <button type="button" class="close" id="closeaddTaxIdentifier" #closeBtn data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </h6>
    </div>

    <div class="modal-body">
      <section class="row m-0 bg-white no-shadow" style="height: 30px;">
        <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">

           <ng-container *ngIf="addTaxIdentifierLoading">
              <div class="local-loading-overlay">
                <div class="custom-spinner-template">
                  <mat-spinner class="custom-spinner black-spinner" diameter="40"></mat-spinner>
                </div>
              </div>
            </ng-container>

          <div style="color: #cb4b32;" class="text-center" *ngIf="noTaxIdentifierData == true && addTaxIdentifierLoading==false">
            TAX identifiers not found !
          </div>
        </div>
      </section>
    </div>
    <div class="modal-footer border-0 col">
      <section class="bg-white no-shadow row">
        <button type="button" class="btn btn-custom btn-blue" data-dismiss="modal"> Close </button>
      </section>
    </div>
  </div>
</div>
</div>



<div class="modal fade"  id="openShortNoteEdit" tabindex="-1" aria-modal="true" aria-labelledby="openShortNoteEditLabel" aria-hidden="true">
<div class="modal-dialog modal-custom">
  <div class="modal-content">
    <div class="modal-header border-0">
      <h6 class="modal-title font-weight-bold text-center" id="openShortNoteEditLabel">
        Edit Notes
        <button type="button" class="close" id="closeEditShortNote" #closeBtn data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </h6>
    </div>

    <div class="modal-body">
      <section class="row m-0 bg-white no-shadow">
        <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">

            <textarea name="notesEdit" id="" cols="60" rows="10" [(ngModel)]="siteNoteval" style="resize: none;position: relative;"></textarea>
            <span class="ng-clear-wrapper datalistClearButton" style="position: absolute;top: 0px;right: 14px;" title="Clear"><span class="ng-clear" (click)="resetEditNotes('notes')" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (resetEditNotes('notes'))">x</span></span>
            <span style="color: #cb4b32;" *ngIf="EditNoteValueError==true">Please enter the value.</span>
        </div>
       </section>
    </div>

    <div class="modal-footer border-0">
      <section class="bg-white no-shadow m-0" style="width: 100%;">
         <div style="float: right;">
        <button type="button" class="btn btn-custom btn-link" data-dismiss="modal"> Cancel </button>
        <button type="button" class="btn btn-custom btn-custom-sm btn-blue"  (click)="updateEditNotes()" [disabled]="disableEditNotes==true" >
          <mat-icon svgIcon="mail" class="img-btn mr-2"></mat-icon><span class="float-right"> {{saveDatas}} </span>
        </button>
      </div>
      </section>
    </div>
  </div>
</div>
</div>



<div class="modal fade"  id="showAddPickingQua" tabindex="-1" aria-modal="true" aria-labelledby="showAddPickingQuaLabel" aria-hidden="true">
  <div class="modal-dialog modal-custom">
    <div class="modal-content" style="margin-left: -4px;">
      <div class="modal-header border-0">
        <h6 class="modal-title font-weight-bold text-center" id="showAddPickingQuaLabel">
          Add Associated Picking
          <button type="button" class="close" id="closeshowAddPickingQua" #closeBtn data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </h6>
      </div>

      <div class="modal-body pb-0">
        <section class="row m-0 bg-white no-shadow" style="max-height: 420px;overflow-y: scroll;">
          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12" *ngIf="showAddPickingLoading==false">
            <div class="ml-3" *ngIf="pickingSiteQualifierData.length > 0">
                <div *ngFor="let row of pickingSiteQualifierData" class="form-group">
                  <label class="container" *ngIf="row.disableCheckBox == true">
                    <input type="checkbox" checked="checked" (click)="returnNone()">
                    <span class="checkmark" style="border-radius: 20%;"></span>
                  </label>
                  <input type="checkbox" class="mt-1 edit" style="position: absolute;" (click)="selectQualifierPicking(row.rowId)" *ngIf="row.disableCheckBox == false"/>
                    <p class="p-0 m-0 ml-3">
                      {{row.identifier ? row.identifier : ''}}
                    </p>
                  <div class="ml-3">{{row.label ? row.label : ''}}</div>
                  <div class="ml-3">
                    <label for="raft_code" class="font-weight-bold mb-0">RAFT code:</label>
                    <span class="pl-1">
                      {{pickingAccessIdenData[[row.rowId]+'raft'] ? pickingAccessIdenData[[row.rowId]+'raft']['identifierValue'] : ''}}
                    </span>
                  </div>
                  <div class="ml-3">
                    <label for="name" class="font-weight-bold mb-0">Name:</label>
                    <span class="pl-1">
                      {{pickingAccessIdenData[[row.rowId]+'social'] ? pickingAccessIdenData[[row.rowId]+'social']['identifierValue'] : ''}}
                    </span>
                  </div>
                  <div class="ml-3">
                    <label for="country" class="font-weight-bold mb-0">Country:</label>
                    <span class="pl-1">{{pickingSitesData[row.realEstateAssetId]['countryName']}}</span>
                  </div>
                  <div class="ml-3">
                    <label for="city" class="font-weight-bold mb-0">City:</label>
                    <span class="pl-1">{{pickingSitesData[row.realEstateAssetId]['cityName']}}</span>
                  </div>
                </div>
            </div>
            <div *ngIf="pickingSiteQualifierData.length ==0 && showAddPickingLoading==false" class="text-center">
              <p class="font-weight-bold">No Results Found</p>
            </div>
          </div>

           <ng-container *ngIf="showAddPickingLoading">
              <div class="local-loading-overlay">
                <div class="custom-spinner-template">
                  <mat-spinner class="custom-spinner black-spinner" diameter="40"></mat-spinner>
                </div>
              </div>
            </ng-container>

        </section>
      </div>

      <div class="modal-footer border-0">
        <section class="bg-white no-shadow m-0" >
          <button type="button" class="btn btn-custom btn-link" data-dismiss="modal"> Cancel </button>
          <button type="button" class="btn btn-custom btn-custom-sm btn-blue ml-1" (click)="addPickingQualifier()">
            <mat-icon svgIcon="add" class="img-btn"></mat-icon><span class="float-right"> Add </span>
          </button>
        </section>
      </div>
    </div>
  </div>
</div>



<div class="modal fade" id="showNameSync" tabindex="-1" aria-modal="true" aria-labelledby="showNameSyncLabel" aria-hidden="true">
<div class="modal-dialog modal-custom">
  <div class="modal-content">
    <div class="modal-header border-0">
      <h6 class="modal-title font-weight-bold text-center" id="showNameSyncLabel">
        Copy Main Entrance name on other qualifiers
        <button type="button" class="close" id="closeshowNameSync" #closeBtn data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </h6>
    </div>

    <div class="modal-body">
      <section class="row m-0 bg-white no-shadow" style="height: 30px;">
        <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <div style="color: #cb4b32;" class="text-center">
            Do you want to copy Main Entrance name to all other Qualifiers?
          </div>
        </div>
      </section>
    </div>
    <div class="modal-footer border-0 col my-2">
      <section class="bg-white no-shadow row">
        <button type="button" class="btn btn-custom btn-blue mr-2" data-dismiss="modal"> No </button>
        <button type="button" class="btn btn-custom btn-blue" (click)="syncMainEntranceName()" [disabled]="disableNameSync==true"> Yes </button>
      </section>
    </div>
  </div>
</div>
</div>



<div class="modal fade"  id="editSaerValModal" tabindex="-1" aria-modal="true" aria-labelledby="editSaerValModalLabel" aria-hidden="true">
<div class="modal-dialog modal-custom">
  <div class="modal-content">
    <div class="modal-header border-0">
      <h6 class="modal-title font-weight-bold text-center" id="editSaerValModalLabel">
        <span> Edit SAER Code</span>
        <button type="button" class="close" id="closeeditsaerAlias" #closeBtn data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </h6>
    </div>

    <div class="modal-body" *ngIf="hasMultiplesaerAlias==true">
      <section class="row m-0 bg-white no-shadow">
        <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <img src="assets/images/warning.png" class="img-btn mr-2"><span style="color: #cb4b32;" >RAFT Alias is not unique!!</span>
        </div>
      </section>
    </div>

    <div class="modal-footer border-0" *ngIf="hasMultiplesaerAlias==true">
      <section class="bg-white no-shadow m-0">
        <button type="button" class="btn btn-custom btn-custom-sm btn-blue" data-dismiss="modal">OK</button>
      </section>
    </div>
         <div class="modal-body" *ngIf="hasMultiplesaerAlias==false">
      <section class="row m-0 bg-white no-shadow">
        <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <label class="label-control">SAER Code:
          </label>
           <input style="padding-right: 2px;" class="form-control form-control-sm form-control-paddings" (change)="checksaerAliasVal()" [(ngModel)]="editsaerAliasModel" maxlength="8" type="text"/>
          <span class="ng-clear-wrapper datalistClearButton" title="Clear all"><span class="ng-clear" style="background-color: #fff;"  (click)="resetsaerAliasVal('val')" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (resetsaerAliasVal('val'))">×</span></span>
          <span style="color: #cb4b32;" *ngIf="editsaerAliasError==true">Please Enter saer Code!!!</span>
          <span style="color: #cb4b32;" *ngIf="saerUnique==true">SAER code must be unique!!!</span>
          <span style="color: #cb4b32;" *ngIf="saerLessthanEight==true">SAER code must be eight digit!!!</span>
        </div>
      </section>
    </div>
    <div class="modal-footer border-0 row" *ngIf="hasMultiplesaerAlias==false">
      <section class="bg-white no-shadow col m-0">

        <button type="button" *ngIf = "showArchivedId" class="btn btn-custom btn-custom-sm btn-blue" (click)="openCnfSaerArchiveModal('archive')">
          Archive
        </button>
        <button type="button" *ngIf = "!showArchivedId" class="btn btn-custom btn-custom-sm btn-blue" (click)="openCnfSaerArchiveModal('unarchive')" >
          Unarchive
        </button>
        <article class = "float-right">
        <button type="button" class="btn btn-custom btn-link" [ngStyle]="{'margin-left' : showSwitch == true ? '20px' : '210px'}" data-dismiss="modal"> Cancel </button>
        <button type="button" class="btn btn-custom btn-custom-sm btn-blue" (click)="savesaerAliasVal()" [disabled]="disableEditsaerCodeBtn==true">
          <mat-icon svgIcon="mail" class="img-btn mr-2"></mat-icon><span class="float-right"> {{saveDatas}} </span>
        </button>
      </article>
      </section>
    </div>
  </div>
</div>
</div>

<div class="modal fade mt-4"  id="CnfArchiveSAER" tabindex="-1" aria-modal="true" aria-labelledby="CnfArchiveSAERLabel" aria-hidden="true">
  <div class="modal-dialog modal-custom">
    <div class="modal-content">
      <div class="modal-header border-0">
        <h6 class="modal-title font-weight-bold text-center" id="CnfArchiveSAERLabel">
          <span>Archive SAER code</span>
          <button type="button" class="close" id="closeCnfArchiveSAER" #closeBtn data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </h6>
      </div>

      <div class="modal-body">
        <section class="row m-0 bg-white no-shadow">
          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <span>Do you want to archive this SAER code ? </span>
          </div>
        </section>
      </div>

      <div class="modal-footer border-0 row">
        <section class="bg-white no-shadow m-0 ">
          <button type="button" class="btn btn-custom btn-link" data-dismiss="modal"> Cancel </button>
          <button type="button" class="btn btn-custom btn-custom-sm btn-blue" (click)="archiveSaer()">
            Archive
          </button>
        </section>
      </div>
    </div>
  </div>
  </div>

  <div class="modal fade mt-4"  id="CnfUnArchiveSAER" tabindex="-1" aria-modal="true" aria-labelledby="CnfUnArchiveSAERLabel" aria-hidden="true">
    <div class="modal-dialog modal-custom">
      <div class="modal-content">
        <div class="modal-header border-0">
          <h6 class="modal-title font-weight-bold text-center" id="CnfUnArchiveSAERLabel">
            <span>Unarchive SAER code</span>
            <button type="button" class="close" id="closeCnfUnArchiveSAER" #closeBtn data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </h6>
        </div>

        <div class="modal-body">
          <section class="row m-0 bg-white no-shadow">
            <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
              <span>Do you want to unarchive this SAER code ? </span>
            </div>
          </section>
        </div>

        <div class="modal-footer border-0 row">
          <section class="bg-white no-shadow m-0 ">
            <button type="button" class="btn btn-custom btn-link" data-dismiss="modal"> Cancel </button>
            <button type="button" class="btn btn-custom btn-custom-sm btn-blue" (click)="unarchiveSaer()">
              Unarchive
            </button>
          </section>
        </div>
      </div>
    </div>
    </div>

<div class="modal fade"  id="editSaerNameValModal" tabindex="-1" aria-modal="true" aria-labelledby="editSaerNameValModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-custom">
    <div class="modal-content">
      <div class="modal-header border-0">
        <h6 class="modal-title font-weight-bold text-center" id="editSaerNameValModalLabel">
         Edit SAER Name
          <button type="button" class="close" id="closeEditsaerName" #closeBtn data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </h6>
      </div>

      <div class="modal-body">
        <section class="row m-0 bg-white no-shadow">
          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <label class="label-control">SAER Name:
            </label>
             <input style="padding-right: 2px;" class="form-control form-control-sm form-control-paddings" (change)="checksaerName()"  [(ngModel)]="saerNameHolder" maxlength="10" (ngModelChange)="saerNameHolder = $event.toUpperCase()"  type="text"/>
             <span class="ng-clear-wrapper datalistClearButton" title="Clear all"><span class="ng-clear" style="background-color: #fff;"  (click)="resetsaerName()" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (resetsaerName())">×</span></span>
             <span style="color: #cb4b32;" *ngIf="editsaerNameError==true">Please Enter saer Name!!!</span>
          </div>
        </section>
       </div>


       <div class="modal-footer border-0">
        <section class="bg-white no-shadow m-0">
          <button type="button" class="btn btn-custom btn-link" data-dismiss="modal"> Cancel </button>
          <button type="button" class="btn btn-custom btn-custom-sm btn-blue" (click)="savesaerAliasName()" [disabled]="disableEditsaerNameBtn==true">
            <mat-icon svgIcon="mail" class="img-btn mr-2"></mat-icon><span class="float-right"> {{saveDatas}} </span>
          </button>
        </section>
      </div>
    </div>
  </div>
  </div>

<div class="modal fade"  id="editRnaiplNameValModal" tabindex="-1" aria-modal="true" aria-labelledby="editRnaiplNameValModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-custom">
    <div class="modal-content">
      <div class="modal-header border-0">
        <h6 class="modal-title font-weight-bold text-center" id="editRnaiplNameValModalLabel">
         Edit Rnaipl Name by <span class="label-darkblue">ADMIN</span>
          <button type="button" class="close" id="closeEditRnaiplName" #closeBtn data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </h6>
      </div>

      <div class="modal-body">
        <section class="row m-0 bg-white no-shadow">
          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <label class="label-control">RNAIPL Name:
            </label>
            <input style="padding-right: 2px;" class="form-control form-control-sm form-control-paddings" disabled value="{{rnaiplNameHolder}}" type="text"/>
          </div>
        </section>
      </div>

      <div class="modal-footer border-0 row">
        <section class="bg-white no-shadow col m-0">
          <button class="btn btn-custom btn-custom-sm btn-blue mr-3" (click)="updateRnaiplName(rnaiplNameHolder,rnaiplNameAliasHolder)" [disabled]="disableEditRnaiplNameBtn==true">
            <mat-icon class="img-btn pb-1 pt-1 px-0 mr-2" svgIcon="edit" alt="edit"></mat-icon>
            <span class="float-right">
              Update
            </span>
          </button>
          <button type="button" class="btn btn-custom btn-link float-right" data-dismiss="modal"> Close </button>
        </section>
      </div>
    </div>
  </div>
  </div>


<div class="modal fade"  id="showWorkflowValidation" tabindex="-1" aria-modal="true" aria-labelledby="showWorkflowValidationLabel" aria-hidden="true">
<div class="modal-dialog modal-custom">
  <div class="modal-content" style="margin-left: 9%;">
    <div class="modal-header border-0">
      <h6 class="modal-title font-weight-bold text-center" id="showWorkflowValidationLabel">
        Workflow Validation
        <button type="button" class="close" id="closeWorkflowValidation" #closeBtn data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </h6>
    </div>

    <div class="modal-body">
      <section class="row m-0 bg-white no-shadow">
        <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <label class="label-control fontBold"> NOTES :</label>
          <textarea class="form-control form-control-sm" [(ngModel)]="wkfValNotesModel" maxlength="1000"> </textarea>
            <span class="ng-clear-wrapper datalistClearButton" title="Clear all"><span class="ng-clear" (click)="resetWkfValNotesModel()" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (resetWkfValNotesModel())">×</span></span>
        </div>
      </section>
    </div>

    <div class="modal-footer border-0">
      <section class="bg-white no-shadow m-0">
        <button type="button" class="btn btn-custom btn-link" data-dismiss="modal"> Cancel </button>
        <button type="button" class="btn btn-custom btn-custom-sm btn-blue" (click)="validateWkfNoteRoute()" [disabled]="workflowValidationLoading==true">
          <div class="icon-text-container">
            <mat-icon svgIcon="confirm" alt="greentick"  class="rounded-circle svg-icon" style="padding-right: 2px;"  > </mat-icon>
                <span>Validate</span>
          </div>

        </button>
      </section>
    </div>
  </div>
</div>
</div>



<div class="modal fade"  id="showWorkflowRejection" tabindex="-1" aria-modal="true" aria-labelledby="showWorkflowRejectionLabel" aria-hidden="true">
<div class="modal-dialog modal-custom">
  <div class="modal-content" style="margin-left: 9%;">
    <div class="modal-header border-0">
      <h6 class="modal-title font-weight-bold text-center" id="showWorkflowRejectionLabel">
        Reject The Request
        <button type="button" class="close" id="closeWorkflowRejection" #closeBtn data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </h6>
    </div>

    <div class="modal-body">
      <section class="row m-0 bg-white no-shadow">
        <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <label class="label-control fontBold"> NOTES :<span class="element_astrick">*</span></label>
          <textarea class="form-control form-control-sm" [(ngModel)]="wkfRejNotesModel" (keyup)="checkCommentsField()" maxlength="1000"> </textarea>
          <span class="ng-clear-wrapper datalistClearButton" title="Clear all"><span class="ng-clear" (click)="resetWkfRejNotesModel()" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (resetWkfRejNotesModel())">×</span></span>
          <span style="color: #cb4b32;" *ngIf="rejectWorkflowNotesError==true">Please Enter Notes inorder to reject a workflow!!!</span>
        </div>
      </section>
    </div>

    <div class="modal-footer border-0">
      <section class="bg-white no-shadow m-0">
        <button type="button" class="btn btn-custom btn-link" data-dismiss="modal"> Cancel </button>
        <button type="button" style="background: #cb4b32;height:30px !important" class="btn btn-custom btn-custom-sm btn-red" (click)="rejectWkfNoteRoute()" [disabled]="workflowValidationLoading==true">
          <mat-icon  style="height: 18px !important;" svgIcon="less" class="mr-2"></mat-icon><span class="float-right"> Reject </span>
        </button>
      </section>
    </div>
  </div>
</div>
</div>



<div class="modal fade"  id="showWorkflowInfoRequest" tabindex="-1" aria-modal="true" aria-labelledby="showWorkflowInfoRequestLabel" aria-hidden="true" data-backdrop="static" data-keyboard="false">
<div class="modal-dialog modal-custom">
  <div class="modal-content" style="margin-left: 9%;">
    <div class="modal-header border-0">
      <h6 class="modal-title font-weight-bold text-center" id="showWorkflowInfoRequestLabel">
        More Information Request
        <button type="button" class="close" id="closeWorkflowInfoRequest" #closeBtn data-dismiss="modal" aria-label="Close" [hidden]="validatingWorkflow">
          <span aria-hidden="true">&times;</span>
        </button>
      </h6>
    </div>

    <div class="modal-body">
      <section class="row m-0 bg-white no-shadow">
        <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12" *ngIf="!validatingWorkflow">
          <label class="label-control fontBold"> NOTES :</label>
          <textarea class="form-control form-control-sm" [(ngModel)]="wkfInfoNotesModel" maxlength="1000"> </textarea>
          <span class="ng-clear-wrapper datalistClearButton" title="Clear all"><span class="ng-clear" (click)="resetWkfInfoNotesModel()" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (resetWkfInfoNotesModel())">×</span></span>
        </div>
        <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <label *ngIf="validatingWorkflow" class="label-control fontBold"> Please wait ..</label>
        </div>
      </section>
    </div>

    <div class="modal-footer border-0">
      <section class="bg-white no-shadow m-0">
        <button type="button" class="btn btn-custom btn-link" data-dismiss="modal" [disabled]="validatingWorkflow"> Cancel </button>
        <button type="button" class="btn btn-custom btn-custom-sm btn-blue" (click)="infoWkfNoteRoute()" [disabled]="workflowValidationLoading==true">
          <mat-icon svgIcon="info" style="width: 19px !important;height: 21px !important;" class="rounded-circle"></mat-icon><span class="float-right pl-2"> Request </span>
        </button>
      </section>
    </div>
  </div>
</div>
</div>



<div class="modal fade mt-4" id="notesHistory" tabindex="-1" aria-modal="true" aria-labelledby="notesHistoryLabel" aria-hidden="true">
<div class="modal-dialog modal-custom">
  <div class="modal-content" style="width: 800px;margin-left: -30% !important;">
    <div class="modal-header border-0">
      <h6 class="modal-title font-weight-bold text-center" id="notesHistoryLabel">
        Workflow History
        <button type="button" class="close" id="closeNotesHistory" #closeBtn data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </h6>
    </div>
    <div class="modal-body row m-0 p-0 table-responsive" *ngIf="requestForNotesHistory">
      <div class="info-container mx-4 mb-2">
        <div class="info-row">
          <div class="label">Request Id:</div>
          <div class="value">
            <span style="color: #60504A;">{{ requestForNotesHistory?.requestId }}</span>&nbsp;
            <span >({{ requestForNotesHistory?.strRequestType }})</span>
          </div>
        </div>

        <div class="info-row">
          <div class="label">Company:</div>
          <div class="value">
            {{ requestForNotesHistory?.allianceId }} {{ requestForNotesHistory?.supplierName }}
          </div>
        </div>

        <div class="info-row" *ngIf="requestForNotesHistory?.requestor">
          <div class="label">Requestor:</div>
          <div class="value">
            <a href="mailto:{{ requestForNotesHistory?.RequestorMailId }}?subject=ISA - {{ requestForNotesHistory?.requestId }} / {{ requestForNotesHistory?.supplierName }}"
              style="text-decoration: underline; color: #47525E;">
              {{ requestForNotesHistory?.requestor?.displayName }}
            </a>
          </div>
        </div>

        <div class="info-row" *ngIf="requestForNotesHistory?.approver">
          <div class="label">Approver:</div>
          <div class="value" [ngStyle]="approverColor(requestForNotesHistory?.workflowOwnerWithRole)">
            {{ requestForNotesHistory?.approver }}
              <span class="edit ml-2" *ngIf="requestForNotesHistory['status']=='In progress' && requestForNotesHistory['workflowOwnerWithRole']!='' && (roleVariableHide || superUserShow)"><mat-icon class="editIconStyle" svgIcon="edit" alt="edit" data-toggle="modal" (click)="toggleApproverEdit()" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (toggleApproverEdit())"></mat-icon></span>
          </div>
        </div>
      </div>

      <div class="info-row mx-4 mt-3">
        <div class="label">Status:</div>
        <div class="value">
          <span class="group-status px-3 mr-1" [ngStyle]="{
                    background: colorForWorkflow[requestForNotesHistory?.status],
                    'min-width': '82px'
                  }" style="white-space: nowrap;">
            {{ requestForNotesHistory?.status }}
          </span>
        </div>
      </div>
      <br>
      <div *ngIf="!approverEdit">
      <table class="table m-0">
        <thead style="background-color: #F5F5F5;">
          <tr class="col p-0">
            <th class="sortDecorationunderline" (click)="sort('requestor')" tabindex="0" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (sort('requestor'))">User</th>
            <th class="sortDecorationunderline" (click)="sort('role')" tabindex="0" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (sort('role'))">Role</th>
            <th class="sortDecorationunderline" (click)="sort('validation')" tabindex="0" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (sort('validation'))">Validation</th>
            <th class="sortDecorationunderline" (click)="sort('notes')" style="width: 20%;" tabindex="0" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (sort('notes'))">Notes</th>
            <th class="sortDecorationunderline" (click)="sort('date')" tabindex="0" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (sort('date'))">Date</th>
          </tr>
        </thead>
        <tbody *ngIf="requestForNotesHistory">
          <ng-container *ngFor="let detail of requestForNotesHistory['historys'] | orderBy: key:reverse; let i = index" >
          <tr  class="col forColor p-0">
            <td class="col-12 col-md-3 col-lg-3 col-xl-3 col-sm-6 tdCustom font-weight-bold">{{detail.requestor}}</td>
            <td class="col-12 col-md-3 col-lg-3 col-xl-3 col-sm-6 tdCustom font-weight-bold">{{detail.role ? detail.role : '-'}}</td>
            <td class="col-12 col-md-3 col-lg-3 col-xl-3 col-sm-6 tdCustom font-weight-bold">
              <mat-icon *ngIf="detail.route == 'OK'" svgIcon="confirm" alt="greentick"  class="rounded-circle svg-icon green" style="padding-right: 2px;"  ></mat-icon>
              <mat-icon *ngIf="detail.route == 'KO'" svgIcon="less" alt="redClose" class="rounded-circle red" style="padding-right: 2px;"></mat-icon>
              <mat-icon *ngIf="detail.route == 'More info needed'" svgIcon="information" class="info-color" style="padding-right: 2px;" ></mat-icon>
              <img src="assets/images/Submitted.png" alt="Submitted" class="rounded-circle" *ngIf="detail.route == 'Submitted'">
            </td>
            <td class="col-12 col-md-3 col-lg-3 col-xl-3 col-sm-6 tdCustom font-weight-bold text-left" style="line-break: anywhere;">{{detail.comment ? detail.comment : '-'}}</td>
            <td class="col-12 col-md-3 col-lg-3 col-xl-3 col-sm-6 tdCustom font-weight-bold">{{detail.date ? (detail.date | date:'yyyy-MM-dd') : '-'}}</td>
          </tr>
        </ng-container>
        </tbody>
        <tbody *ngIf="requestForNotesHistory.length==0">
          <tr>
            <td colspan="7" class="font-weight-bold text-darkblue text-center">No Results</td>
          </tr>
        </tbody>

         <ng-container *ngIf="loading">
              <div class="local-loading-overlay">
                <div class="custom-spinner-template">
                  <mat-spinner class="custom-spinner black-spinner" diameter="40"></mat-spinner>
                </div>
              </div>
            </ng-container>

        <tfoot [hidden]="this.history">
              <tr>
                <td colspan="8">

                  <ul *ngIf="histPager.pages && histPager.pages.length" class="pagination">
                    <li [ngClass]="{disabled:histPager.currentPage === 1}">
                        <a (click)="historyTable(1)" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (historyTable(1))">First</a>
                    </li>
                    <li [ngClass]="{disabled:histPager.currentPage === 1}">
                        <a (click)="historyTable(histPager.currentPage - 1)" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (historyTable(histPager.currentPage - 1))">Previous</a>
                    </li>
                    <li *ngFor="let page of histPager.pages" [ngClass]="{active:histPager.currentPage === page}">
                        <a (click)="historyTable(page)" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (historyTable(page))">{{page}}</a>
                    </li>
                    <li [ngClass]="{disabled:histPager.currentPage === histPager.totalPages}">
                        <a (click)="historyTable(histPager.currentPage + 1)" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (historyTable(histPager.currentPage + 1))">Next</a>
                    </li>
                    <li [ngClass]="{disabled:histPager.currentPage === histPager.totalPages}">
                        <a (click)="historyTable(histPager.totalPages)" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (historyTable(histPager.totalPages))">Last</a>
                    </li>
                  </ul>
                </td>
              </tr>
        </tfoot>
      </table>
      </div>
      <div *ngIf="approverEdit">
          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12" >
            <label class="label-control fontBold sendSupRec"> New Approver <span class="astricRed">*</span></label>
            <input type="text" class="form-control form-control-sm" (focus)="focusFunction('sam')" [(ngModel)]="senReqSamMOdel" (keyup)="checkvalidateField()">
            <span class="ng-clear-wrapper datalistClearButton" title="Clear all">
              <span *ngIf="senReqSamMOdel!=''" class="ng-clear" (click)="resetSendReqToSupp('senReqSamMOdel')" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (resetSendReqToSupp('senReqSamMOdel'))"><mat-icon svgIcon="search"></mat-icon></span>
              <span *ngIf="senReqSamMOdel==''" data-toggle="modal" data-target="#ArcaPopup" class="ng-clear" (click)="lookupArca('sam')" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (lookupArca('sam'))">
                <mat-icon style="position: relative;right: 6px;bottom: 3px;" svgIcon="search"></mat-icon>
              </span>
            </span>
            <span style="color: #cb4b32;" *ngIf="senReqSamMOdelError==true">Please enter the SAM</span>
          </div>
          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <label class="label-control fontBold sendSupRec"> Transfer NOTES </label>
            <textarea class="form-control form-control-sm" [(ngModel)]="senReqNotesMOdel"> </textarea>
            <span class="ng-clear-wrapper datalistClearButton" title="Clear all"><span style="position: relative;right: 11px;" class="ng-clear" (click)="resetSendReqToSupp('senReqNotesMOdel')" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (resetSendReqToSupp('senReqNotesMOdel'))">×</span></span>
          </div>
        </div>
    </div>
    <div class="modal-footer border-0 row">
      <section class="bg-white no-shadow m-0 row">
        <button *ngIf="!approverEdit" type="button" class="btn btn-custom btn-blue btn-lg grpBtn" data-dismiss="modal" id="closeCatAuthState">
          Close
        </button>
        <button *ngIf="approverEdit" [disabled]="senReqSamMOdel==''" type="button" class="btn btn-custom btn-blue btn-lg grpBtn" data-dismiss="modal" id="closeCatAuthState__2" (click)="sendToNewApprover(requestForNotesHistory,senReqSamMOdel,senReqNotesMOdel)">
            Send to New Approver
        </button>
      </section>
    </div>
  </div>
</div>
</div>


<div class="modal fade"  id="openWarningBvdportfolio" tabindex="-1" aria-modal="true" aria-labelledby="openWarningBvdportfolioLabel" aria-hidden="true">
<div class="modal-dialog modal-custom">
  <div class="modal-content" style="margin-left: -4px;">
    <div class="modal-header border-0">
      <h6 class="modal-title font-weight-bold text-center" id="openWarningBvdportfolioLabel">
        Warning
        <button type="button" class="close" id="closeupdateaddbvdid" #closeBtn data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </h6>
    </div>

    <div class="modal-body">
      <section class="row m-0 bg-white no-shadow">
        <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <p class="font-weight-bold text-center h6">
            {{siteName}} seems to have its BvD ID {{sitebvidid}}  changed to {{bvdidNumber}}. Do you want to update it before adding it into the Portfolio ?
          </p>
        </div>
      </section>
    </div>

    <div class="modal-footer border-0">
      <section class="bg-white no-shadow m-0" >
        <button type="button" class="btn btn-custom btn-link" data-dismiss="modal"> Cancel </button>
        <button type="button" class="btn btn-custom btn-custom-sm btn-blue" (click)="UpdateaddBvDID()"> Update/add </button>
      </section>
    </div>
  </div>
</div>
</div>

<div class="modal fade"  id="openWarningbvdnotpresentinOrbis" tabindex="-1" aria-modal="true" aria-labelledby="openWarningbvdnotpresentinOrbisLabel" aria-hidden="true">
<div class="modal-dialog modal-custom">
  <div class="modal-content" style="margin-left: -4px;">
    <div class="modal-header border-0">
      <h6 class="modal-title font-weight-bold text-center" id="openWarningbvdnotpresentinOrbisLabel">
        Warning
        <button type="button" class="close" id="closeupdateaddbvdid__2" #closeBtn data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </h6>
    </div>

    <div class="modal-body">
      <section class="row m-0 bg-white no-shadow">
        <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <p class="font-weight-bold text-center h6">
            This BvD ID {{sitebvidid}} does not exist in Orbis Database. Please check it before retrying again.
          </p>
        </div>
      </section>
    </div>

    <div class="modal-footer border-0">
      <section class="bg-white no-shadow m-0" >
        <button type="button" class="btn btn-custom btn-link" data-dismiss="modal"> Cancel </button>
        <button type="button" class="btn btn-custom btn-custom-sm btn-blue" data-dismiss="modal"> Ok </button>
      </section>
    </div>
  </div>
</div>
</div>


<div class="modal fade"  id="showSelectAnotherAddress" tabindex="-1" aria-modal="true" aria-labelledby="showSelectAnotherAddressLabel" aria-hidden="true">
<div class="modal-dialog modal-custom">
  <div class="modal-content">
    <div class="modal-header border-0">
      <h6 class="modal-title font-weight-bold text-center" id="showSelectAnotherAddressLabel">
        Select another address
        <button type="button" class="close" id="closeSelectAnotherAddress" #closeBtn data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </h6>
    </div>

    <div class="modal-body">
      <section class="row m-0 bg-white no-shadow">
        <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12" *ngFor="let addressVals of tempNewData;let i = index">
          <div class="row">
            <div class="form-group col col-12 col-sm-1 col-md-1 col-lg-1 col-xl-1">
              <span *ngIf="addressVals.addressEditRowIdForGPS;else templatA">
                <input style="width: 1.2rem;height: 1.2rem;"  value="{{addressVals.addressEditRowIdForGPS}}" class="edit" type="radio" [(ngModel)]="addressRadioval2" (click)="toggleForNewAddress2()" id="addressRadiovalButton[{{i}}]"/>
              </span>
              <ng-template #templatA>
                <span *ngIf="addressVals.addressEditRowId">
                  <input style="width: 1.2rem;height: 1.2rem;"  value="{{addressVals.addressEditRowId}}" class="edit" type="radio" [(ngModel)]="addressRadioval2" (click)="toggleForNewAddress2()" id="addressRadiovalButton[{{i}}]"/>
                </span>
              </ng-template>
            </div>

          <div class="form-group col col-12 col-sm-11 col-md-11 col-lg-11 col-xl-11">
            <P class="mb-2">
            <span *ngIf="addressVals['wayNumber']">
              {{addressVals['wayNumber']}}
            </span>
            <span class="pl-1" *ngIf="addressVals['streetName']">
              {{addressVals['streetName']}}
            </span>
            </P>
            <P class="mb-2" *ngIf="addressVals['additionalInformation1']">
            <span class="font-weight-bold">
              {{addressVals['additionalInformation1']}}
            </span>
            </P>
            <P class="mb-2" *ngIf="addressVals['additionalInformation2']">
            <span class="font-weight-bold">
              {{addressVals['additionalInformation2']}}
            </span>
            </P>
            <P class="mb-2">
            <span class="font-weight-bold">Postal Code : </span>
            <span class="pl-1">
              {{addressVals['postalCode'] ? addressVals['postalCode'] : '-'}}
            </span>
            </P>
            <P class="mb-2">
            <span class="font-weight-bold">Territorial Division: </span>
            <span class="pl-1">
              {{addressVals['territorialDivision'] ? addressVals['territorialDivision'] : '-'}}
            </span>
            </P>
            <P class="mb-2">
            <span class="font-weight-bold">GPS: </span>
            <span class="font-weight-bold label-darkblue" *ngIf="addressVals['gpsDataLat']">
              {{addressVals['gpsDataLat']}},
            </span>
            <span class="pl-1 font-weight-bold label-darkblue" *ngIf="addressVals['gpsDataLon']">
              {{addressVals['gpsDataLon']}}
            </span>
            </P>
          </div>
          </div>
        </div>
        <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <span style="color: #cb4b32;" *ngIf="radioNotChecked==true">Please Select Address or Add new address!</span>
        </div>
        <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12" *ngIf="tempNewData.length==0">
          <span>No other address available for this site!</span>
        </div>

        <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <div class="row">
          <div class="form-group col col-12 col-sm-1 col-md-1 col-lg-1 col-xl-1">
            <span>
            <input style="width: 1.2rem;height: 1.2rem;" class="edit" type="radio" id="AddNewAddressRadio2" (click)="toggleForNewAddress2()">
            </span>
          </div>
          <div class="form-group col col-12 col-sm-11 col-md-11 col-lg-11 col-xl-11">
            <span class=" font-weight-bold">NEW ADDRESS
            </span>
          </div>
          </div>
        </div>
        <div *ngIf="AddNewAddress==true" class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <div class="row">
          <div class="form-group col col-12 col-sm-3 col-md-3 col-lg-3 col-xl-3">
            <label class="label-control">N°
            </label>
            <div>
            <input
            style="padding-right: 2px;"
            class="form-control form-control-sm form-control-paddings"
            [(ngModel)]="wayNumberModelQualifierEdit" 
            type="text"
            (keyup)="checkForRegExAddressAdd($event,wayNumberModelQualifierEdit,'wayNumberModelQualifierEdit')"
            (ngModelChange)="wayNumberModelQualifierEdit = $event.toUpperCase()"
            maxlength="9"/>
            <span class="ng-clear-wrapper datalistClearButton" title="Clear all"><span class="ng-clear" style="background-color: #fff;" (click)="upresetAddQualifierSiteFields('wayNumberModelQualifierEdit')" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (upresetAddQualifierSiteFields('wayNumberModelQualifierEdit'))">×</span></span>
            <span style="color: #cb4b32;" *ngIf="wayNumberModelQualifierEditRegExError==true">A-Z 0-9 space () . , - /</span>
            </div>
          </div>
          <div class="form-group col col-12 col-sm-9 col-md-9 col-lg-9 col-xl-9">
            <label class="label-control">Street<span class="element_astrick">*</span>
            </label>
            <div>
            <input
            style="padding-right: 2px;"
            class="form-control form-control-sm form-control-paddings"
            [(ngModel)]="qualiferSiteStreetModelUp" 
            type="text"
            (keyup)="checkForRegExAddressAdd($event,qualiferSiteStreetModelUp,'qualiferSiteStreetModelUp')"
            (ngModelChange)="qualiferSiteStreetModelUp = $event.toUpperCase()"
            maxlength="35"/>
            <span class="ng-clear-wrapper datalistClearButton" title="Clear all"><span class="ng-clear" style="background-color: #fff;"  (click)="upresetAddQualifierSiteFields('qualiferSiteStreetModelUp')" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (upresetAddQualifierSiteFields('qualiferSiteStreetModelUp'))">×</span></span>
            <span style="color: #cb4b32;" *ngIf="qualiferSiteStreetModelErrorUp==true">Please enter street</span>
            <span style="color: #cb4b32;" *ngIf="qualiferSiteStreetModelUpRegExError==true">A-Z 0-9 space () . , - /</span>
            </div>
          </div>
          </div>

          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 p-0">
          <label class="label-control">Additional Address information
          </label>
          <div class="mb-2">
            <input style="padding-right: 2px;"
            class="form-control form-control-sm form-control-paddings"
            [(ngModel)]="qualiferSiteAdditionalAddress" 
            (ngModelChange)="qualiferSiteAdditionalAddress = $event.toUpperCase()"
            (keyup)="checkForRegExAddressAdd($event,qualiferSiteAdditionalAddress,'qualiferSiteAdditionalAddress')"
            maxlength="35"
            type="text"/>
            <span class="ng-clear-wrapper datalistClearButton" title="Clear all">
            <span class="ng-clear" style="background-color: #fff;" (click)="upresetAddQualifierSiteFields('qualiferSiteAdditionalAddress')" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (upresetAddQualifierSiteFields('qualiferSiteAdditionalAddress'))">×</span></span>
            <span style="color: #cb4b32;" *ngIf="qualiferSiteAdditionalAddressRegExError==true">A-Z 0-9 space () . , - /</span>
          </div>
          <div>
            <input style="padding-right: 2px;"
            class="form-control form-control-sm form-control-paddings"
            [(ngModel)]="qualiferSiteAdditionalAddressInfo" 
            maxlength="35"
            type="text"
            (ngModelChange)="qualiferSiteAdditionalAddressInfo = $event.toUpperCase()"
            (keyup)="checkForRegExAddressAdd($event,qualiferSiteAdditionalAddressInfo,'qualiferSiteAdditionalAddressInfo')" />
            <span class="ng-clear-wrapper datalistClearButton" title="Clear all">
            <span class="ng-clear" style="background-color: #fff;" (click)="upresetAddQualifierSiteFields('qualiferSiteAdditionalAddressInfo')" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (upresetAddQualifierSiteFields('qualiferSiteAdditionalAddressInfo'))">×</span></span>
            <span style="color: #cb4b32;" *ngIf="qualiferSiteAdditionalAddressInfoRegExError==true">A-Z 0-9 space () . , - /</span>
          </div>
          </div>

          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 p-0">
          <label class="label-control">City Postal Code
          </label>
          <div>
            <input
            style="padding-right: 2px;"
            class="form-control form-control-sm form-control-paddings"
            (keyup)="checkForRegExAddressAdd($event,postalCodeModel,'postalCodeModel')"
            [(ngModel)]="postalCodeModel" 
            (ngModelChange)="postalCodeModel = $event.toUpperCase()"
            type="text"
            maxlength="9"/>
            <span class="ng-clear-wrapper datalistClearButton" title="Clear all"><span class="ng-clear" style="background-color: #fff;" (click)="upresetAddQualifierSiteFields('postalCodeModel')" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (upresetAddQualifierSiteFields('postalCodeModel'))">×</span></span>
            <span style="color: #cb4b32;" *ngIf="postalCodeModelRegExError==true">A-Z 0-9 space () . , - /</span>
          </div>
          </div>

          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 p-0">
          <label class="label-control">Territorial Division
          </label>
          <div>
            <input
            style="padding-right: 2px;"
            class="form-control form-control-sm form-control-paddings"
            (keyup)="checkForRegExAddressAdd($event,territorialDivModelQualifierEdit,'territorialDivModelQualifierEdit')"
            [(ngModel)]="territorialDivModelQualifierEdit" 
            type="text"
            (ngModelChange)="territorialDivModelQualifierEdit = $event.toUpperCase()"
            maxlength="35"/>
            <span class="ng-clear-wrapper datalistClearButton" title="Clear all"><span class="ng-clear" style="background-color: #fff;" (click)="upresetAddQualifierSiteFields('territorialDivModelQualifierEdit')" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (upresetAddQualifierSiteFields('territorialDivModelQualifierEdit'))">×</span></span>
            <span style="color: #cb4b32;" *ngIf="territorialDivModelQualifierEditRegExError==true">A-Z 0-9 space () . , - /</span>
          </div>
          </div>
          <section class="row m-0 bg-white no-shadow">
            <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 p-0">
              <label class="label-control">Latitude :</label>
              <p style="position: relative;padding: 0;">
                <span style="width: 18%;display: inline-block;">
                  <input id="latitude_degres__5" type="text" (keyup)="dmsversddanotheraddress()" class="form-control form-control-sm form-control-paddings pr-1" [(ngModel)]="latDegVal">

                </span>
                <label class="font-weight-bold" style="position: absolute;top: 0;" for="latitude_degres">&deg;</label>&nbsp;
                <span style="width: 18%;display: inline-block;">
                  <input id="latitude_minutes__5" type="text" (keyup)="dmsversddanotheraddress()" class="form-control form-control-sm form-control-paddings pr-1" [(ngModel)]="latMinVal">

                </span>
                <label class="font-weight-bold" style="position: absolute;top: 0;" for="latitude_minutes">'</label>&nbsp;
                <span style="width: 35%;display: inline-block;">
                  <input id="latitude_secondes__5" type="text" (keyup)="dmsversddanotheraddress()" class="form-control form-control-sm form-control-paddings pr-1" [(ngModel)]="latSecVal">

                </span>
                <mat-label class="font-weight-bold" style="position: absolute;top: 0;" for="latitude_secondes">''</mat-label>&nbsp;
                <span style="width: 17%;display: inline-block;">
                <mat-select class="form-control form-control-sm p-0"  [(ngModel)]="northSouthModel" (ngModelChange)="dmsversddanotheraddress()" panelClass="dropdown-panel" [disableOptionCentering]="true">
                    <mat-option value="North">N</mat-option>
                    <mat-option value="South">S</mat-option>
                </mat-select>
                </span>
              </p>
            </div>
            <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 pr-0">
              <label class="label-control">Longitude :</label>
              <p style="position: relative;padding: 0;">
                <span style="width: 18%;display: inline-block;">
                  <input id="longitude_degres__5" type="text" (keyup)="dmsversddanotheraddress()" class="form-control form-control-sm form-control-paddings pr-1" [(ngModel)]="longDegVal">

                </span>
                <label class="font-weight-bold" style="position: absolute;top: 0;" for="longitude_degres">&deg;</label>&nbsp;
                <span style="width: 18%;display: inline-block;">
                  <input id="longitude_minutes__5" type="text" (keyup)="dmsversddanotheraddress()" class="form-control form-control-sm form-control-paddings pr-1" [(ngModel)]="longMinVal">

                </span>
                <label class="font-weight-bold" style="position: absolute;top: 0;" for="longitude_minutes">'</label>&nbsp;
                <span style="width: 35%;display: inline-block;">
                  <input id="longitude_secondes__4" type="text" (keyup)="dmsversddanotheraddress()" class="form-control form-control-sm form-control-paddings pr-1" [(ngModel)]="longSecVal">

                </span>
                <mat-label class="font-weight-bold" style="position: absolute;top: 0;" for="longitude_secondes">''</mat-label>&nbsp;
                <span style="width: 17%;display: inline-block;">
                <mat-select class="form-control form-control-sm p-0"  [(ngModel)]="eastWestModel" (ngModelChange)="dmsversddanotheraddress()" panelClass="dropdown-panel" [disableOptionCentering]="true">
                    <mat-option value="East">E</mat-option>
                    <mat-option value="West">W</mat-option>
                </mat-select>
                </span>
              </p>
            </div>
         </section>
          <div class="row">
          <div class="form-group col col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
            <label class="label-control">Latitude
            </label>
            <div>
            <input style="padding-right: 2px;" class="form-control form-control-sm form-control-paddings" (keyup)="ddversdmsanotheraddress()" [(ngModel)]="gpsValueModelLat" type="text"/>
            <span class="ng-clear-wrapper datalistClearButton" title="Clear all"><span class="ng-clear" style="background-color: #fff;" (click)="upresetAddQualifierSiteFields('gpsValueModelLat')" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (upresetAddQualifierSiteFields('gpsValueModelLat'))">×</span></span>
            </div>
          </div>

          <div class="form-group col col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 p-0">
            <label class="label-control">Longitude
            </label>
            <div>
            <input style="padding-right: 2px;" class="form-control form-control-sm form-control-paddings" (keyup)="ddversdmsanotheraddress()" [(ngModel)]="gpsValueModelLon" type="text"/>
            <span class="ng-clear-wrapper datalistClearButton" title="Clear all"><span class="ng-clear" style="background-color: #fff;" (click)="upresetAddQualifierSiteFields('gpsValueModelLon')" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (upresetAddQualifierSiteFields('gpsValueModelLon'))">×</span></span>
            </div>
          </div>
          </div>
        </div>
      </section>
    </div>

    <div class="modal-footer border-0">
      <section class="bg-white no-shadow m-0" style="width: 100%;">
        <button type="button"  class="btn btn-custom btn-blue" (click)="copyGpsdata('gpslat')" *ngIf="AddNewAddress ==true && roleVariableHide ==true && gpsValueModelLat=='' && gpsValueModelLon==''" >
          Copy city Gps data
        </button>
      <div style="float: right;">
        <button type="button" class="btn btn-custom btn-link" data-dismiss="modal"> Cancel </button>
        <button type="button" class="btn btn-custom btn-custom-sm btn-blue" (click)="selectAnotherAddress()" [disabled]="disableSelAnotherAddress==true">
          <mat-icon svgIcon="mail" class="img-btn mr-2"></mat-icon><span class="float-right"> {{saveDatas}} </span>
        </button>
    </div>
   </section>

    </div>
  </div>
</div>
</div>


<div class="modal fade"  id="openWarningNoGpsData" tabindex="-1" aria-modal="true" aria-labelledby="openWarningNoGpsDataLabel" aria-hidden="true">
<div class="modal-dialog modal-custom">
  <div class="modal-content" style="margin-left: -4px;">
    <div class="modal-header border-0">
      <h6 class="modal-title font-weight-bold text-center" id="openWarningNoGpsDataLabel">
        Warning

      </h6>
    </div>

    <div class="modal-body">
      <section class="row m-0 bg-white no-shadow">
        <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <p class="font-weight-bold text-center h6">
            No City GPS data available
          </p>
        </div>
      </section>
    </div>

    <div class="modal-footer border-0">
      <section class="bg-white no-shadow m-0" >
        <button type="button" class="btn btn-custom btn-link" data-dismiss="modal"> Cancel </button>
        <button type="button" class="btn btn-custom btn-custom-sm btn-blue" data-dismiss="modal"> Ok </button>
      </section>
    </div>
  </div>
</div>
</div>


<div class="modal fade"  id="AddTaxIdentfiers" tabindex="-1" aria-modal="true" aria-labelledby="AddTaxIdentfiersLabel" aria-hidden="true">
<div class="modal-dialog modal-custom">
  <div class="modal-content">
    <div class="modal-header border-0">
      <h6 class="modal-title font-weight-bold text-center" id="AddTaxIdentfiersLabel">
        Add Tax Identifier
        <button type="button" class="close" id="closeAddTax" #closeBtn data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </h6>
    </div>

    <div class="modal-body">
      <section class="row m-0 bg-white no-shadow">
        <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <mat-label class="label-control">Tax Identifier Type
          </mat-label>
          <mat-select class="form-control form-control-sm" [(ngModel)]="TaxTypeIdnetifierModel" (ngModelChange)="changeTaxType($event)" panelClass="dropdown-panel" [disableOptionCentering]="true">
            <mat-option *ngFor="let TaxiType of TaxIdentifierType" [value]="TaxiType['name']">{{TaxiType['name']}}</mat-option>
          </mat-select>
          <span style="color: #cb4b32;" *ngIf="IdnetifierTypeError==true">Please select the Tax Identifier Type.</span>
        </div>
        <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <label class="label-control">Value
          </label>
          <input type="text" id="addTaxIdenInput" class="form-control form-control-sm" [(ngModel)]="NewIdnetifierValue">
          <span class="ng-clear-wrapper datalistClearButton" title="Clear"><span class="ng-clear" (click)="resetTaxidentif()" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (resetTaxidentif())">×</span></span>
          <span style="color: #cb4b32;" *ngIf="IdnetifierValueError==true">Please enter the value.</span>
        </div>
      </section>
    </div>

    <div class="modal-footer border-0">
      <section class="bg-white no-shadow m-0">
        <button type="button" class="btn btn-custom btn-link" data-dismiss="modal"> Cancel </button>
        <button type="button" [disabled]="disableSaveBtnAlias" class="btn btn-custom btn-custom-sm btn-blue" data-target="#showAliasAddModal" data-toggle="modal" (click)="AddTaxIdentifiersType()">
          <mat-icon svgIcon="mail" class="img-btn mr-2"></mat-icon><span class="float-right"> {{saveDatas}} </span>
        </button>
      </section>
    </div>
  </div>
</div>
</div>


<div class="modal fade"  id="ValidateC2bSaer" tabindex="-1" aria-modal="true" aria-labelledby="ValidateC2bSaerLabel" aria-hidden="true">
  <div class="modal-dialog modal-custom">
    <div class="modal-content">
      <div class="modal-header border-0">
        <h6 class="modal-title font-weight-bold text-center" id="ValidateC2bSaerLabel">
          Validate SAER
          <button type="button" class="close" id="closeAddSaer" #closeBtn data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </h6>
      </div>

      <div class="modal-body">
        <section class="row m-0 bg-white no-shadow">
          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <label class="label-control">Name
            </label>
            <input type="text" id="addSaerName" class="form-control form-control-sm" [(ngModel)]="saer_NameModel">

            <span style="color: #cb4b32;" *ngIf="saerNameExists==true">Please enter the value.</span>
            <span style="color: #cb4b32;" *ngIf="saerNameMinlen==true">Enter 10 characters max</span>
          </div>
          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <label class="label-control">Code
            </label>
            <input type="text" id="addSaerCode" class="form-control form-control-sm" [(ngModel)]="saer_CodeModel">
            <span class="ng-clear-wrapper datalistClearButton" title="Clear"><span class="ng-clear" (click)="resetTaxidentif()" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (resetTaxidentif())">×</span></span>
            <span style="color: #cb4b32;" *ngIf="saerCodeExists==true">Please enter the code.</span>
            <span style="color: #cb4b32;" *ngIf="saerMinlength==true">Enter 8 Digit Numerical value</span>
            <span style="color: #cb4b32;" *ngIf="saerUniqueError==true">SAER code must be unique!!!</span>

          </div>
        </section>
      </div>

      <div class="modal-footer border-0">
        <section class="bg-white no-shadow m-0">
          <button type="button" class="btn btn-custom btn-link" data-dismiss="modal"> Cancel </button>
          <button type="button" [disabled]="disableSaveBtnAlias" class="btn btn-custom btn-custom-sm btn-blue" data-target="#showAliasAddModal" data-toggle="modal" (click)="AddSaerCodetoQua()">
            <mat-icon svgIcon="mail" class="img-btn mr-2"></mat-icon><span class="float-right"> {{saveDatas}} </span>
          </button>
        </section>
      </div>
    </div>
  </div>
</div>


<div class="modal fade"  id="editRnaiplValModal" tabindex="-1" aria-modal="true" aria-labelledby="editRnaiplValModalLabel" aria-hidden="true">
<div class="modal-dialog modal-custom">
 <div class="modal-content">
   <div class="modal-header border-0">
     <h6 class="modal-title font-weight-bold text-center" id="editRnaiplValModalLabel">
      <span> Edit Rnaipl Code by ADMIN</span>
       <button type="button" class="close" id="closeeditRnaiplAlias" #closeBtn data-dismiss="modal" aria-label="Close">
         <span aria-hidden="true">&times;</span>
       </button>
     </h6>
   </div>

   <div class="modal-body" *ngIf="hasMultipleRnaiplAlias==true">
     <section class="row m-0 bg-white no-shadow">
       <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
         <img src="assets/images/warning.png" class="img-btn mr-2"><span style="color: #cb4b32;" >RNAIPL Code is not unique!!</span>
       </div>
     </section>
   </div>

   <div class="modal-footer border-0" *ngIf="hasMultipleRnaiplAlias==true">
     <section class="bg-white no-shadow m-0">
       <button type="button" class="btn btn-custom btn-custom-sm btn-blue" data-dismiss="modal">OK</button>
     </section>
   </div>
   <div class="modal-body" *ngIf="hasMultipleRnaiplAlias==false">
     <section class="row m-0 bg-white no-shadow">
       <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
         <mat-label class="label-control">RNAIPL Code:
         </mat-label>
         <input style="padding-right: 2px;" class="form-control form-control-sm form-control-paddings" (change)="checkRnaiplAliasVal()" [(ngModel)]="editRnaiplAliasModel" type="text" maxlength="20"/>
         <span class="ng-clear-wrapper datalistClearButton" title="Clear all"><span class="ng-clear" style="background-color: #fff;"  (click)="resetRnaiplAliasVal()" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (resetRnaiplAliasVal())">×</span></span>
         <span style="color: #cb4b32;" *ngIf="editRnaiplAliasError==true">Please Enter RNAIPL Code!!!</span>
       </div>
     </section>
   </div>

   <div class="modal-footer border-0" *ngIf="hasMultipleRnaiplAlias==false">
     <section class="bg-white no-shadow m-0">
       <button type="button" class="btn btn-custom btn-link" data-dismiss="modal"> Cancel </button>
       <button type="button" class="btn btn-custom btn-custom-sm btn-blue" (click)="saveRnaiplAliasVal()" [disabled]="disableEditRnaiplCodeBtn==true">
        <mat-icon svgIcon="mail" class="img-btn mr-2"></mat-icon><span class="float-right"> {{saveDatas}} </span>
       </button>
     </section>
   </div>
 </div>
</div>
</div>


<div class="modal fade"  id="openEditRaftModal" tabindex="-1" aria-modal="true" aria-labelledby="openEditRaftModalLabel" aria-hidden="true">
<div class="modal-dialog modal-custom">
  <div class="modal-content">
    <div class="modal-header border-0">
      <h6 class="modal-title font-weight-bold text-center" id="openEditRaftModalLabel">
       Edit Raft Account
        <button type="button" class="close" id="closeraftmodal" #closeBtn data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </h6>
    </div>

    <div class="modal-body">
      <section class="bg-white no-shadow m-0 w-100">
      <article class="float-right">
        <button type="button" class="btn btn-custom btn-link" data-dismiss="modal"> Cancel </button>

      <button type="button" style="background-color: #ec051d" class="btn btn-custom btn-custom-sm mr-1" (click)="DeleteRaftcode()" *ngIf="superUserShow ==true">
        <mat-icon svgIcon="delete" class="mr-1 pb-1" alt="DEL"></mat-icon>
          <span class="float-right">
            Delete
          </span>
      </button>
      <button type="button" class="btn btn-custom btn-custom-sm btn-blue" (click)="UnarchiveRaftcode()" *ngIf="showArchivedRaftcode==true">
        Unarchive
      </button>
    </article>
  </section>
    </div>

    <div class="modal-footer border-0">

    </div>
  </div>
</div>
</div>



<div class="modal fade"  id="openAddCertificateModal" tabindex="-1" aria-modal="true" aria-labelledby="openAddCertificateModalLabel" aria-hidden="true">
<div class="modal-dialog modal-custom">
  <div class="modal-content" >
    <div class="modal-header border-0">
      <h6 class="modal-title font-weight-bold text-center" id="openAddCertificateModalLabel">
        Add Certificate
        <button type="button" class="close" id="closeAddCertificateModal" #closeBtn data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </h6>
    </div>
    <div class="modal-body">
      <section class="row m-0 bg-white no-shadow" >
        <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
       <mat-label class="label-control">Type<span style="color:red;">*</span></mat-label>
          <mat-select class="form-control form-control-sm" [(ngModel)]="CertificateTypeModel" (ngModelChange)="checkRequiredFields($event,'type')" panelClass="dropdown-panel" [disableOptionCentering]="true">
            <mat-option *ngFor="let type of CertificateTypeAll" [value]="type">{{type}}</mat-option>
        </mat-select>
        <span style="color: #cb4b32;" *ngIf="CertificateTypeError==true">Please select the Certificate Type.</span>
           </div>
        <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <label class="label-control">Number<span style="color:#cb4b32;">*</span></label>
          <input type="text" id="CertificateNumberModel" class="form-control form-control-sm" [(ngModel)]="CertificateNumberModel" (change)="checkRequiredFields($event,'number')" >
          <span class="ng-clear-wrapper datalistClearButton" title="Clear"><span class="ng-clear" (click)="resetCertNo()" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (resetCertNo())">×</span></span>
          <span style="color: #cb4b32;"  *ngIf="CertificateNumberError==true">Please Enter the Number.</span>
        </div>
        <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <label class="label-control">Start Validation Date<span style="color:#cb4b32;">*</span></label>
          <div class="search-container">
          <div class="inner-addon right-addon">
            <span class="fa fa-calendar" (click)="d1.toggle()" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (d1.toggle())"></span>
          <input type="text" id="CertificateStartDateModel" class="form-control form-control-sm"  autocomplete="off" placeholder="YYYY-MM-DD" [(ngModel)]="CertificateStartDateModel"
          ngbDatepicker #d1="ngbDatepicker" (ngModelChange)="checkRequiredFields($event,'startDate')" >
          <span style="color: #cb4b32;"  *ngIf="CertificateStartDateError==true">Please Enter the Start Validation Date.</span>
         </div>
          </div>
        </div>
        <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <label class="label-control">Expiration Date</label>

          <div class="search-container">
            <div class="inner-addon right-addon"> <span class="fa fa-calendar" (click)="d2.toggle()" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (d2.toggle())"></span>
          <input type="text" id="CertificateEndDateModel" class="form-control form-control-sm" autocomplete="off" placeholder="YYYY-MM-DD" [(ngModel)]="CertificateEndDateModel"
          ngbDatepicker #d2="ngbDatepicker">
        </div>
      </div>
        </div>
      </section>
    </div>
    <div class="modal-footer border-0">
      <section class="bg-white no-shadow m-0">
        <button type="button" class="btn btn-custom btn-link" id="addcertificateCloseBtn" data-dismiss="modal"> Cancel </button>
        <button type="button" [disabled]="disableSaveBtnAlias" class="btn btn-custom btn-custom-sm btn-blue" (click)="addCertificate()">
          <mat-icon svgIcon="mail" class="img-btn mr-2"></mat-icon><span class="float-right"> {{saveCertificate}} </span>
        </button>
      </section>
    </div>
  </div>
</div>
</div>



<!-- <div class="modal fade"  id="openAddMaterialGroupModal" tabindex="-1" aria-modal="true" aria-labelledby="openAddMaterialGroupModalLabel" aria-hidden="true">
<div class="modal-dialog modal-custom">
<div class="modal-content" >
  <div class="modal-header border-0">
    <h6 class="modal-title font-weight-bold text-center" id="openAddMaterialGroupModalLabel"
      Add Material Group
      <button type="button" class="close" id="closeAddMaterialGroupModal" #closeBtn data-dismiss="modal" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </h6>
  </div>
  <div class="modal-body">
    <section class="row m-0 bg-white no-shadow" >

      <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
        <label class="label-control">Material Group<span style="color:#cb4b32;">*</span></label>
        <input type="text" id="materialGroupNameModal" class="form-control form-control-sm" [(ngModel)]="materialGroupNameModal" (change)="checkRequiredFieldsForMG($event,'MG')" >
        <span class="ng-clear-wrapper datalistClearButton" title="Clear"><span class="ng-clear" (click)="resetMaterilGroup()" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (resetMaterilGroup())">×</span></span>
        <span style="color: #cb4b32;"  *ngIf="materialGroupNameError==true">Please Enter the Material Group.</span>
        <span style="color: #cb4b32;"  *ngIf="identifierValue==true">Material Group already exists.</span>
        <span style="color: #cb4b32;"  *ngIf="validData==true">This Material Group is not a Validated one</span>
      </div>

      <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
     <mat-label class="label-control">Activity<span style="color:red;">*</span></mat-label>
        <mat-select class="form-control form-control-sm" [(ngModel)]="materialGroupActivityModal" (ngModelChange)="checkRequiredFieldsForMG($event,'activity')" panelClass="dropdown-panel" [disableOptionCentering]="true">
          <mat-option value=""></mat-option>
          <mat-option *ngFor="let type of activityTypeList" [value]="type.code">{{type.code}} - {{type.name}}</mat-option>
      </mat-select>
      <span style="color: #cb4b32;" *ngIf="materialGroupActivityError==true">Please select the Activity.</span>
         </div>

    </section>
  </div>
  <div class="modal-footer border-0">
    <section class="bg-white no-shadow m-0">
      <button type="button" class="btn btn-custom btn-link" id="addcertificateCloseBtn__2" data-dismiss="modal"> Cancel </button>
      <button type="button" [disabled]="disableSaveBtnAlias" class="btn btn-custom btn-custom-sm btn-blue" (click)="addMaterialGroup()">
        <mat-icon svgIcon="mail" class="img-btn mr-2"></mat-icon><span class="float-right"> {{saveCertificate}} </span>
      </button>
    </section>
  </div>
  </div>
</div> -->



<div style="display: none;">
<button id="btnForIdAssociatedPick" data-target="#showAssociatedPickingModal" data-toggle="modal"></button>
<button id="btnForDispAddQualifier" data-target="#addqualiferSiteModalPopup" data-toggle="modal"></button>
<button id="btnForNoMainEntranceACP" data-target="#showNoMainEntranceModal" data-toggle="modal"></button>
<button id="btnForNoAssociatedQualifier" data-target="#openNoAssociatedQualifier" data-toggle="modal"></button>
<button id="btnForWarningAddQualifier" data-target="#showWarningForAddQualifier" data-toggle="modal"></button>
<button id="btnForNoMainEntranceQualifier" data-target="#showWarningNoMainEntrance" data-toggle="modal"></button>
<button id="btnForChangeCompany" data-target="#changeCompanyModal" data-toggle="modal"></button>
<button id="btnForOpenLookForCpy" data-target="#lookForCpyModal" data-toggle="modal"></button>
<button id="btnForNoArchivedQua" data-target="#showNotAllArchived" data-toggle="modal"></button>
<button id="btnForIsHQArchive" data-target="#showIsHQForArchive" data-toggle="modal"></button>
<button id="btnForNoShortNameOrCity" data-target="#showNoShortNameOrCityModal" data-toggle="modal"></button>
<button id="btnForBvdIdStatus" data-target="#showBvdIdStatus" data-toggle="modal"></button>
<button id="btnForLinkToSameSite" data-target="#showSameCpyLink" data-toggle="modal"></button>
<button id="btnForCnfArchive" data-target="#CnfArchiveBvdId" data-toggle="modal"></button>
<button id="btnForCnfUnArchive" data-target="#CnfUnArchiveBvdId" data-toggle="modal"></button>
<button id="btnForCnfTaxArchive" data-target="#CnfArchiveTax" data-toggle="modal"></button>
<button id="btnForCnfTaxUnArchive" data-target="#CnfUnArchiveTax" data-toggle="modal"></button>
<button id="btnForDeleteBvd" data-target="#CnfDeleteBvdId" data-toggle="modal"></button>
<button id="btnForCnfSaerArchive" data-target="#CnfArchiveSAER" data-toggle="modal"></button>
<button id="btnForCnfSaerUnArchive" data-target="#CnfUnArchiveSAER" data-toggle="modal"></button>
<button id="btnForCnfLatamArchive" data-target="#CnfArchiveLATAM" data-toggle="modal"></button>
<button id="btnForCnfLatamUnArchive" data-target="#CnfUnArchiveLATAM" data-toggle="modal"></button>
<button id="btnForWarnSameSite" data-target="#alreadyAttachedToSiteModal" data-toggle="modal"></button>
<button id="btnForValidateAcpOpen" data-target="#showValidateAcp" data-toggle="modal"></button>
<button id="showAddQuaSteps" data-target="#showAddQualifierSteps" data-toggle="modal"></button>
<button id="btnForCreateCitySteps" data-target="#showCreateCitySteps" data-toggle="modal"></button>
<button id="btnForUpdateCpySteps" data-target="#showUpdateCpySteps" data-toggle="modal"></button>
<button id="btnForShowValidateAcp" data-target="#showValidateAcpSteps" data-toggle="modal"></button>
<button id="btnForWarningBvdportfolio" data-target="#openWarningBvdportfolio" data-toggle="modal"></button>
<button id="btnForbvdnotpresentinOrbis" data-target="#openWarningbvdnotpresentinOrbis" data-toggle="modal"></button>
<button id="btnForNoGpsData" data-target="#openWarningNoGpsData" data-toggle="modal"></button>
<button id="btnForArcaPopup" data-target="#ArcaPopup" data-toggle="modal"></button>
<button id="btnForOpenRoleExistsWarning" data-target="#openWarningForRoleUpdate" data-toggle="modal"></button>
<button id="btnForsinglealcor" data-target="#openForsingleAlcor" data-toggle="modal"></button>
<button id="btnFormultiplealcor" data-target="#openFormultipleAlcor" data-toggle="modal"></button>
<button id="btnnoalcor" data-target="#openNoAlcor" data-toggle="modal"></button>
<button id="btnForblankupdate" data-target="#showBlankUpdateProcess" data-toggle="modal"></button>
<button id="btnForQualifierValidation" data-target="#qualifierValidationModal" data-toggle="modal" style="position: absolute; left: -9999px; opacity: 0; pointer-events: none;"></button>
<button id="btnForDocumentValidation" data-target="#documentValidationModal" data-toggle="modal" style="position: absolute; left: -9999px; opacity: 0; pointer-events: none;"></button>
</div>

